(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
const $551afe4eb57f5422$export$6fb38195a7366394 = async function(data) {
    const response = await fetch(igniteDmnJsVars.ajaxUrl, {
        method: "POST",
        body: data
    });
    if (!response.ok) throw new Error(`[${response.status}] ${response.statusText}`);
    const responseJson = await response.json();
    return responseJson;
};


const $4aa70e6322f04d6f$export$3c293e733be50c44 = (data)=>{
    if (data && window.location.host === "ignitedmn.wpenginepowered.com") console.log(data);
};
const $4aa70e6322f04d6f$export$4a2fbc025e4a4a37 = (myObject)=>Object.keys(myObject).length === 0 && myObject.constructor === Object;
const $4aa70e6322f04d6f$export$3ae94a2503e890a1 = (date)=>{
    const year = date.getFullYear();
    const month = $4aa70e6322f04d6f$var$formatNumber(date.getMonth() + 1);
    const day = $4aa70e6322f04d6f$var$formatNumber(date.getDate());
    return `${year}-${month}-${day}`;
};
const $4aa70e6322f04d6f$var$formatNumber = (number)=>{
    return number < 10 ? "0" + number : number;
};
const $4aa70e6322f04d6f$export$deb57dc8c2016a9 = (date)=>{
    // Create a new Date object with the date specified
    const dateObject = new Date(date);
    // Get the day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
    const dayOfWeek = dateObject.getDay();
    return dayOfWeek;
};
const $4aa70e6322f04d6f$export$3ef3aade8b3d4986 = (date, lowercase = false)=>{
    // Create a new Date object with the date specified
    const dateObject = new Date(date);
    // Get the day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
    const dayOfWeek = dateObject.getDay();
    // Get the day name instead of the index
    const daysOfWeek = $4aa70e6322f04d6f$export$a33638efd29e46b();
    return lowercase ? daysOfWeek[dayOfWeek].toLowerCase() : daysOfWeek[dayOfWeek];
};
const $4aa70e6322f04d6f$export$f132f811af620c86 = (inputDateString)=>{
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    const date = new Date(inputDateString);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    // Add the appropriate suffix for the day
    const dayWithSuffix = $4aa70e6322f04d6f$var$addSuffixToDay(day);
    return `${dayWithSuffix} ${month} ${year}`;
};
// Function to add suffix to day (e.g., 1st, 2nd, 3rd, 4th, etc.)
const $4aa70e6322f04d6f$var$addSuffixToDay = (day)=>{
    if (day >= 11 && day <= 13) return day + "th";
    switch(day % 10){
        case 1:
            return day + "st";
        case 2:
            return day + "nd";
        case 3:
            return day + "rd";
        default:
            return day + "th";
    }
};
const $4aa70e6322f04d6f$export$a33638efd29e46b = (lowercase = false)=>{
    return lowercase ? [
        "sunday",
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday"
    ] : [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ];
};
const $4aa70e6322f04d6f$export$f2a29205a8bccc09 = (openingTime, closingTime, interval)=>{
    const result = [];
    // Parse opening and closing times
    const [openHour, openMinute] = openingTime.split(":").map(Number);
    let [closeHour, closeMinute] = closingTime.split(":").map(Number);
    // Adjust closing hour if it is on the next day
    if (closeHour < openHour) closeHour += 24;
    // Generate times in 15-minute intervals
    for(let hour = openHour; hour <= closeHour; hour++){
        for(let minute = 0; minute < 60; minute += interval)// Check if the generated time is within the opening and closing times
        if (hour === openHour && minute >= openMinute || hour > openHour && hour < closeHour || hour === closeHour && minute <= closeMinute) {
            // Format the time as HH:MM
            const formattedHour = (hour % 24).toString().padStart(2, "0");
            const formattedMinute = minute.toString().padStart(2, "0");
            result.push(`${formattedHour}:${formattedMinute}`);
        }
    }
    return result;
};
const $4aa70e6322f04d6f$export$d2ec87026d057c43 = (minDuration, maxDuration, durationLength)=>{
    const result = [];
    // Ensure the input parameters are valid
    if (minDuration < 0 || maxDuration < 0 || durationLength <= 0) {
        console.error("Invalid input parameters");
        return result;
    }
    // Generate possible durations within the specified range
    for(let duration = minDuration; duration <= maxDuration; duration += durationLength)result.push({
        value: duration,
        label: $4aa70e6322f04d6f$var$formatMinutes(duration)
    });
    return result;
};
const $4aa70e6322f04d6f$var$formatMinutes = (minutes)=>{
    if (isNaN(minutes) || minutes < 0) return "Invalid input";
    if (minutes < 60) return minutes + " minute" + (minutes === 1 ? "" : "s");
    else {
        const hours = Math.floor(minutes / 60);
        const remainingMinutes = minutes % 60;
        const hoursText = hours + " hour" + (hours === 1 ? "" : "s");
        const minutesText = remainingMinutes > 0 ? " and " + remainingMinutes + " minute" + (remainingMinutes === 1 ? "" : "s") : "";
        return hoursText + minutesText;
    }
};
const $4aa70e6322f04d6f$export$ce85b5fea1553a6 = async (widget, elem, elemHTML)=>{
    widget.querySelector(elem).innerHTML = elemHTML;
};
const $4aa70e6322f04d6f$export$869dd14c14f4e57f = async (widget, times)=>{
    const elem = widget.querySelector(".ig-dmn__form-time");
    let timesHTML = `<option value="">Select a time</option>`;
    times.forEach((time)=>{
        timesHTML += `<option value="${time}">${time}</option>`;
    });
    // Update the dropdown options
    elem.innerHTML = timesHTML;
    // Remove the disabled attribute
    elem.removeAttribute("disabled");
};
const $4aa70e6322f04d6f$export$f87dae7c5c825238 = async (widget, min, max)=>{
    const numPeopleDropdown = widget.querySelector(".ig-dmn__form-guests");
    // Generate the dropdown options for the num_people dropdown
    let numPeopleHTML = `<option value="">Select number of people</option>`;
    let i = min;
    while(i <= max){
        numPeopleHTML += `<option value="${i}">${i}</option>`;
        i++;
    }
    // Update the dropdown options
    numPeopleDropdown.innerHTML = numPeopleHTML;
    // Remove the disabled attribute
    numPeopleDropdown.removeAttribute("disabled");
};
const $4aa70e6322f04d6f$export$a561e682d551491b = async (widget, durations)=>{
    const elem = widget.querySelector(".ig-dmn__form-duration");
    let durationsHTML = `<option value="">Select duration</option>`;
    durations.forEach((duration)=>{
        durationsHTML += `<option value="${duration.value}">${duration.label}</option>`;
    });
    // Update the dropdown options
    elem.innerHTML = durationsHTML;
    // Remove the disabled attribute
    elem.removeAttribute("disabled");
};
const $4aa70e6322f04d6f$export$b4a82bb6383c18a0 = (startDate, endDate)=>{
    // Get today's date
    const today = new Date();
    // Convert start and end dates to Date objects if they are not already
    startDate = new Date(startDate);
    endDate = new Date(endDate);
    // Check if today is between the start and end dates
    return today >= startDate && today <= endDate;
};
const $4aa70e6322f04d6f$export$68b158e1f523791a = (startDate, endDate)=>{
    const dateArray = [];
    let currentDate = new Date(startDate);
    endDate = new Date(endDate);
    while(currentDate <= endDate){
        dateArray.push(currentDate.toISOString().split("T")[0]);
        currentDate.setDate(currentDate.getDate() + 1);
    }
    return dateArray;
};
const $4aa70e6322f04d6f$export$5ecbd3be3bcbabc8 = (iframe)=>{
    var iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
    // Get the height of the content inside the iframe
    var contentHeight = Math.max(iframeDocument.body.scrollHeight, iframeDocument.documentElement.scrollHeight);
    // Remove the minHeight styling from the iframe
    iframe.removeAttribute("style");
    // Set the height of the iframe
    iframe.style.height = contentHeight + "px";
};
const $4aa70e6322f04d6f$export$f09c14f15f5542d7 = (widget)=>{
    widget.scrollTo({
        top: 0,
        behavior: "smooth"
    });
};
const $4aa70e6322f04d6f$export$187631d3cc65a5c3 = (widget, selector)=>{
    if (widget) {
        const targetElement = widget.querySelector(selector);
        const widgetScrollTop = widget.scrollTop;
        if (targetElement) {
            // Calculate the target offset from the top of the document
            const targetOffset = targetElement.getBoundingClientRect().top + widgetScrollTop;
            // Smooth scroll animation
            widget.scrollTo({
                top: targetOffset,
                behavior: "smooth"
            });
        } else console.error("Element with selector '" + selector + "' not found.");
    } else console.error("widget is not defined");
};
const $4aa70e6322f04d6f$export$e60f3efd19f0b6f1 = (parameterName)=>{
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.has(parameterName);
};
const $4aa70e6322f04d6f$export$37c42e52ae3e39ff = (parameterName)=>{
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(parameterName);
};
const $4aa70e6322f04d6f$export$5fa1f25e8ff4f893 = (form)=>{
    const date = form.querySelector(".ig-dmn__form-date").value;
    const time = form.querySelector(".ig-dmn__form-time").value;
    const duration = form.querySelector(".ig-dmn__form-duration").value;
    const numPeople = form.querySelector(".ig-dmn__form-num-people").value;
    const detailsValid = date != "" && time != "" && duration != "" && numPeople != "";
    let dobValid = true;
    // Check if DOB is set to be required
    if (form.querySelector(".ig-dmn__form-dates")) {
        const day = form.querySelector(".ig-dmn__form-dob-day").value;
        const month = form.querySelector(".ig-dmn__form-dob-month").value;
        const year = form.querySelector(".ig-dmn__form-dob-year").value;
        const dateString = `${day}${month}${year}`;
        dobValid = day != "" && month != "" && year != "" && $4aa70e6322f04d6f$var$isValidDate(dateString);
    }
    return detailsValid && dobValid;
};
const $4aa70e6322f04d6f$var$isValidDate = (dateString)=>{
    // Check if the input is a string
    if (typeof dateString !== "string") return false;
    // Ensure the input has exactly 8 characters
    if (dateString.length !== 8) return false;
    // Extract day, month, and year from the input string
    const day = parseInt(dateString.substring(0, 2), 10);
    const month = parseInt(dateString.substring(2, 4), 10);
    const year = parseInt(dateString.substring(4), 10);
    // Check if the extracted values represent a valid date
    const isValidDay = day >= 1 && day <= 31;
    const isValidMonth = month >= 1 && month <= 12;
    const isValidYear = year >= 1000; // Assuming the year should be at least 1000
    // Check if the date itself is valid (e.g., no 31st February)
    const daysInMonth = new Date(year, month, 0).getDate();
    const isValidDate = isValidDay && isValidMonth && day <= daysInMonth;
    return isValidDate && isValidYear;
};
const $4aa70e6322f04d6f$export$427d387d87736bfd = (url)=>{
    // Create a URL object
    let urlObj = new URL(url);
    // Set the 'source' parameter to 'partner'
    urlObj.searchParams.set("source", "partner");
    // Return the modified URL
    return urlObj.toString();
};
const $4aa70e6322f04d6f$export$9cabd011967ef036 = (duration)=>{
    if (duration.value === -1) return duration; // Keep "Until close" as is
    const hours = Math.floor(duration.value / 60);
    const minutes = duration.value % 60;
    let newLabel = "";
    if (hours > 0) {
        newLabel += `${hours} hour${hours > 1 ? "s" : ""}`;
        if (minutes > 0) newLabel += " and ";
    }
    if (minutes > 0) newLabel += `${minutes} minute${minutes > 1 ? "s" : ""}`;
    return {
        ...duration,
        label: newLabel
    };
};



const $8967bc42bf098e48$export$8a22be7c64085dc6 = async (venueId = null)=>{
    const formData = new FormData();
    formData.append("action", "getVenueData");
    if (venueId != null) formData.append("venueID", venueId); //Optional override venue ID
    (0, $4aa70e6322f04d6f$export$3c293e733be50c44)("Getting venues from DMN - https://api.designmynight.com/v4/venues/?venue_group=VENUE_GROUP_ID");
    const responseJson = await (0, $551afe4eb57f5422$export$6fb38195a7366394)(formData);
    (0, $4aa70e6322f04d6f$export$3c293e733be50c44)("Venues:");
    (0, $4aa70e6322f04d6f$export$3c293e733be50c44)(responseJson);
    return responseJson;
};
const $8967bc42bf098e48$export$c7e818e6afe71b1a = async ()=>{
    const bookingTypeObj = (0, $6ab8eb33d1de4787$export$4cc47fe0ce792f33)();
    // Return any packages for the booking type selected
    return bookingTypeObj.packages ?? [];
};
const $8967bc42bf098e48$export$7109cb6850612023 = async ()=>{
    const formData = new FormData();
    formData.append("action", "getMarketingPreferences");
    const venueId = (0, $6ab8eb33d1de4787$export$54eca3721020c605)("venue")._id;
    if (venueId) formData.append("venueID", venueId);
    const responseJson = await (0, $551afe4eb57f5422$export$6fb38195a7366394)(formData);
    return responseJson;
};


const $6ab8eb33d1de4787$export$54eca3721020c605 = (key = null)=>{
    const dmnData = localStorage.getItem("dmnData") ? JSON.parse(localStorage.getItem("dmnData")) : {};
    if (dmnData && key) return dmnData[key] ?? null;
    else // return all dmn data
    return dmnData;
};
const $6ab8eb33d1de4787$export$80824bcdfa204e75 = ()=>{
    return $6ab8eb33d1de4787$export$54eca3721020c605("bookingDetails");
};
const $6ab8eb33d1de4787$export$eba3534479dea9c3 = ()=>{
    return $6ab8eb33d1de4787$export$54eca3721020c605("bookingType");
};
const $6ab8eb33d1de4787$export$4cc47fe0ce792f33 = (id = null)=>{
    // If no id passed through check the localStorage for the active bookingType and use that if set
    const bookingTypeId = id === null ? $6ab8eb33d1de4787$export$eba3534479dea9c3() : id;
    const venueData = $6ab8eb33d1de4787$export$54eca3721020c605("venue");
    if (venueData.booking_types) {
        const bookingTypeObj = venueData.booking_types.find((bookingType)=>bookingType.id === bookingTypeId);
        return bookingTypeObj;
    } else return null;
};
const $6ab8eb33d1de4787$export$6843f928420ce3e4 = ()=>{
    return $6ab8eb33d1de4787$export$54eca3721020c605("validation");
};
const $6ab8eb33d1de4787$export$f772d4644e06847e = (data)=>{
    localStorage.setItem("dmnData", JSON.stringify(data));
};
const $6ab8eb33d1de4787$export$4d82403bb5c8dbd4 = (stage)=>{
    const dmnData = $6ab8eb33d1de4787$export$54eca3721020c605();
    dmnData.stage = stage;
    $6ab8eb33d1de4787$export$f772d4644e06847e(dmnData);
};
const $6ab8eb33d1de4787$export$497de35e4b022230 = (venueData)=>{
    const dmnData = $6ab8eb33d1de4787$export$54eca3721020c605();
    dmnData.venue = venueData;
    $6ab8eb33d1de4787$export$f772d4644e06847e(dmnData);
};
const $6ab8eb33d1de4787$export$f90498dccc0d60cf = (bookingTypes)=>{
    const dmnData = $6ab8eb33d1de4787$export$54eca3721020c605();
    dmnData.bookingTypes = bookingTypes;
    $6ab8eb33d1de4787$export$f772d4644e06847e(dmnData);
};
const $6ab8eb33d1de4787$export$f8ec9f12bd4a3e45 = (bookingType)=>{
    const dmnData = $6ab8eb33d1de4787$export$54eca3721020c605();
    dmnData.bookingType = bookingType;
    $6ab8eb33d1de4787$export$f772d4644e06847e(dmnData);
};
const $6ab8eb33d1de4787$export$1a76a6d47efc9b3e = (bookingDetails)=>{
    const dmnData = $6ab8eb33d1de4787$export$54eca3721020c605();
    dmnData.bookingDetails = bookingDetails;
    $6ab8eb33d1de4787$export$f772d4644e06847e(dmnData);
};
const $6ab8eb33d1de4787$export$555e91b9030a2487 = (validation)=>{
    const dmnData = $6ab8eb33d1de4787$export$54eca3721020c605();
    dmnData.validation = validation;
    $6ab8eb33d1de4787$export$f772d4644e06847e(dmnData);
};
const $6ab8eb33d1de4787$export$c925ae8f8414d3e7 = (offers)=>{
    const dmnData = $6ab8eb33d1de4787$export$54eca3721020c605();
    dmnData.offers = offers;
    $6ab8eb33d1de4787$export$f772d4644e06847e(dmnData);
};
const $6ab8eb33d1de4787$export$dff0f9677dbdb644 = (offer)=>{
    const dmnData = $6ab8eb33d1de4787$export$54eca3721020c605();
    dmnData.activeOffer = offer;
    $6ab8eb33d1de4787$export$f772d4644e06847e(dmnData);
};
const $6ab8eb33d1de4787$export$aea372fef393a613 = (widget, resetVenue = false)=>{
    // Get the venue ID that the booking is being made for
    const venueId = widget.getAttribute("data-venue-id");
    if (resetVenue && $6ab8eb33d1de4787$export$54eca3721020c605("venue")) $6ab8eb33d1de4787$export$497de35e4b022230(null);
    else // Update the localStorage venue data
    (0, $8967bc42bf098e48$export$8a22be7c64085dc6)(venueId).then((data)=>{
        $6ab8eb33d1de4787$export$497de35e4b022230(data);
    });
    // Remove offers
    if ($6ab8eb33d1de4787$export$54eca3721020c605("offers")) $6ab8eb33d1de4787$export$c925ae8f8414d3e7(null);
    // Remove any active offers
    if ($6ab8eb33d1de4787$export$54eca3721020c605("activeOffer")) $6ab8eb33d1de4787$export$dff0f9677dbdb644(null);
    // Remove booking type
    if ($6ab8eb33d1de4787$export$54eca3721020c605("bookingType")) $6ab8eb33d1de4787$export$f8ec9f12bd4a3e45(null);
    // Remove booking details
    if ($6ab8eb33d1de4787$export$54eca3721020c605("bookingDetails")) $6ab8eb33d1de4787$export$1a76a6d47efc9b3e(null);
    // Remove validation object
    if ($6ab8eb33d1de4787$export$54eca3721020c605("validation")) $6ab8eb33d1de4787$export$555e91b9030a2487(null);
};


const $cc943cf31e795207$export$56525cbb1fcd885c = (widget)=>{
    widget.querySelector(".ig-dmn__loader-container").classList.remove("opacity-0", "invisible");
    widget.querySelector(".ig-dmn__inner").classList.add("opacity-50");
};
const $cc943cf31e795207$export$5cee2c2772922923 = (widget)=>{
    widget.querySelector(".ig-dmn__loader-container").classList.add("opacity-0", "invisible");
    widget.querySelector(".ig-dmn__inner").classList.remove("opacity-0", "invisible", "opacity-50");
};
const $cc943cf31e795207$export$43dc4e2240cb354f = (widget)=>{
    const widgetType = widget.getAttribute("data-reservation-type");
    let type;
    switch(widgetType){
        case "table":
            type = "General";
            break;
        case "occasions":
            type = "Occasions";
            break;
        case "specific":
            type = "Specific";
            break;
    }
    return type;
};
const $cc943cf31e795207$export$42d1a34989af9d5c = (widget)=>{
    return widget.getAttribute("data-env") ?? "";
};





const $3590469e1f0cdfd9$export$85e58a4b0352fe9b = async (env, form)=>{
    if (env === "test") // Test env being used so don't actually post anything!
    return await $3590469e1f0cdfd9$export$59cdba661c8586ac();
    else // Post the booking details to DMN
    return await $3590469e1f0cdfd9$export$e8ac04e43d4447(form);
};
const $3590469e1f0cdfd9$export$e8ac04e43d4447 = async (form)=>{
    let formData = new FormData(form);
    formData.append("action", "postBooking");
    const venueId = (0, $6ab8eb33d1de4787$export$54eca3721020c605)("venue")._id;
    if (venueId) formData.append("venueID", venueId);
    const bookingResponse = (0, $551afe4eb57f5422$export$6fb38195a7366394)(formData);
    return bookingResponse;
};
const $3590469e1f0cdfd9$export$59cdba661c8586ac = async ()=>{
    const bookingDetails = (0, $6ab8eb33d1de4787$export$80824bcdfa204e75)();
    const bookingTypeDetails = (0, $6ab8eb33d1de4787$export$4cc47fe0ce792f33)(bookingDetails.type);
    const booking = {
        status: "complete",
        type: {
            name: bookingTypeDetails.name
        },
        num_people: bookingDetails.num_people,
        date: bookingDetails.date
    };
    return new Promise((resolve, reject)=>{
        setTimeout(()=>{
            resolve(booking);
            reject("An error has occurred.");
        }, 400);
    });
};






const $8f528785e5628694$export$e558ebf3c711c0e3 = async function(widget) {
    const bookingForm = widget.querySelector(".ig-dmn__booking-form");
    let formData = new FormData(bookingForm);
    formData.append("action", "getOffers");
    const venueId = (0, $6ab8eb33d1de4787$export$54eca3721020c605)("venue")._id;
    if (venueId) formData.append("venueID", venueId);
    const responseJson = await (0, $551afe4eb57f5422$export$6fb38195a7366394)(formData);
    return responseJson;
};










const $112d7b3b085137cd$export$29ae4492a789360a = async (offers)=>{
    const offersData = await $112d7b3b085137cd$var$getOffersDataForAjax(offers);
    const formData = new FormData();
    formData.append("offers", offersData);
    formData.append("action", "getOffersHtml");
    const responseJson = await (0, $551afe4eb57f5422$export$6fb38195a7366394)(formData);
    return responseJson;
};
const $112d7b3b085137cd$var$getOffersDataForAjax = async (offers)=>{
    let offersData = [];
    const activeOffer = $6ab8eb33d1de4787$export$54eca3721020c605("activeOffer");
    offers.forEach((offer)=>{
        const offerData = {
            id: offer._id,
            title: offer.title,
            selected: offer._id === activeOffer
        };
        offersData.push(offerData);
    });
    return JSON.stringify(offersData);
};






const $b133988ee4497173$export$938fda647833c65e = async (booking)=>{
    const status = $b133988ee4497173$var$getBookingStatus(booking.status);
    const enquiryType = $b133988ee4497173$var$isEnquiry(booking) ? "enquiry" : "booking";
    const completeMessage = await $b133988ee4497173$var$getBookingCompleteMessage(status, booking);
    const formData = new FormData();
    if (status === "success") formData.append("show_upsell_booking_type", booking.type.id);
    formData.append("status", status);
    formData.append("heading", status === "success" ? `Thank you for your ${enquiryType}` : `Your ${enquiryType} was unsuccessful`);
    formData.append("message", completeMessage);
    formData.append("action", "getBookingCompleteHtml");
    const responseJson = await (0, $551afe4eb57f5422$export$6fb38195a7366394)(formData);
    return responseJson;
};
const $b133988ee4497173$var$getBookingStatus = (bookingStatus)=>{
    const successStatusArr = [
        "new",
        "in_progress",
        "complete",
        "confirmed"
    ];
    return successStatusArr.includes(bookingStatus) ? "success" : "error";
};
const $b133988ee4497173$var$isEnquiry = (booking)=>{
    return booking.status === "new" || booking.status === "in_progress";
};
const $b133988ee4497173$var$getBookingCompleteMessage = async (status, booking)=>{
    if (status === "success") {
        const enquiryType = $b133988ee4497173$var$isEnquiry(booking) ? "enquiry" : "booking";
        const intro = $b133988ee4497173$var$isEnquiry(booking) ? "We have recieved" : "We are happy to confirm";
        const bookingType = (0, $bde3b974cc47c9fd$export$98f06c4eeebe0b65)(booking.type.name);
        const peopleText = booking.num_people === 1 ? "person" : "people";
        return `${intro} your ${bookingType} ${enquiryType} for ${booking.num_people} ${peopleText} on ${(0, $4aa70e6322f04d6f$export$f132f811af620c86)(booking.date)}`;
    } else {
        const errorMessage = await $b133988ee4497173$var$getBookingErrorMessage();
        return errorMessage;
    }
};
const $b133988ee4497173$var$getBookingErrorMessage = async ()=>{
    const formData = new FormData();
    formData.append("action", "getErrorMessage");
    const responseJson = await (0, $551afe4eb57f5422$export$6fb38195a7366394)(formData);
    return responseJson;
};




const $737da3fd3b21e501$export$6b2087ef4c27009c = async (bookingType)=>{
    const formData = new FormData();
    formData.append("booking_type", bookingType);
    formData.append("action", "getVirtualTourIframe");
    const iframe = await (0, $551afe4eb57f5422$export$6fb38195a7366394)(formData);
    return iframe;
};
const $737da3fd3b21e501$export$d684b8e92c9b530b = async (bookingType)=>{
    const iframe = await $737da3fd3b21e501$export$6b2087ef4c27009c(bookingType);
    const formData = new FormData();
    formData.append("iframe", iframe);
    formData.append("action", "getVirtualTourHtml");
    const virtualTourHTML = await (0, $551afe4eb57f5422$export$6fb38195a7366394)(formData);
    return virtualTourHTML;
};


const $63daabb835e29093$export$1c9503703a5621c0 = (widget)=>{
    const offers = $6ab8eb33d1de4787$export$54eca3721020c605("offers");
    const trigger = widget.querySelector(".ig-dmn__offers-trigger");
    if (trigger && offers && offers.length > 0) trigger.addEventListener("click", (event)=>{
        event.preventDefault();
        // Open the modal
        $63daabb835e29093$var$openModal(widget);
        // Load in the offers
        (0, $112d7b3b085137cd$export$29ae4492a789360a)(offers).then((modalHTML)=>{
            $4aa70e6322f04d6f$export$ce85b5fea1553a6(widget, ".ig-dmn__modal-inner", modalHTML);
            // init toggleOffer function
            (0, $236d893478cc0ae9$export$3d7f7c678ef3fb35)(widget);
            // Show the modal content after .4 seconds
            setTimeout($63daabb835e29093$var$showModalContent(widget), 400);
        });
    });
    // Call the initCloseModalTrigger function
    $63daabb835e29093$var$initCloseModalTrigger(widget);
};
const $63daabb835e29093$export$e9c0f5cb968f2933 = (widget, bookingType)=>{
    // Open the modal
    $63daabb835e29093$var$openModal(widget);
    (0, $737da3fd3b21e501$export$d684b8e92c9b530b)(bookingType).then((modalHTML)=>{
        $4aa70e6322f04d6f$export$ce85b5fea1553a6(widget, ".ig-dmn__modal-inner", modalHTML);
        // Show the modal content after .4 seconds
        setTimeout($63daabb835e29093$var$showModalContent(widget), 400);
    });
    // Call the initCloseModalTrigger function
    $63daabb835e29093$var$initCloseModalTrigger(widget);
};
const $63daabb835e29093$export$8e2d697d9c0c7e4c = async (widget, booking)=>{
    // Open the modal
    $63daabb835e29093$var$openModal(widget);
    // Load in the modal content
    const bookingCompleteHTML = await (0, $b133988ee4497173$export$938fda647833c65e)(booking);
    $4aa70e6322f04d6f$export$ce85b5fea1553a6(widget, ".ig-dmn__modal-inner", bookingCompleteHTML);
    // Show the modal content after .4 seconds
    setTimeout($63daabb835e29093$var$showModalContent(widget), 400);
    // Call the initCloseModalTrigger function
    $63daabb835e29093$var$initCloseModalTrigger(widget, "complete");
};
const $63daabb835e29093$var$openModal = (widget)=>{
    const modal = widget.querySelector(".ig-dmn__modal");
    const modalLoader = modal.querySelector(".ig-dmn__loader");
    const modalInner = modal.querySelector(".ig-dmn__modal-inner");
    // Clear the current offers in the modal
    $4aa70e6322f04d6f$export$ce85b5fea1553a6(widget, ".ig-dmn__modal-inner", "");
    // Show the loader
    modalLoader.classList.remove("hidden");
    // Hide the inner elem
    modalInner.classList.add("hidden");
    // Show the modal
    document.body.style.overflow = "hidden";
    modal.classList.remove("hidden");
    modal.classList.add("flex");
};
const $63daabb835e29093$var$showModalContent = (widget)=>{
    const modal = widget.querySelector(".ig-dmn__modal");
    const modalLoader = modal.querySelector(".ig-dmn__loader");
    const modalInner = modal.querySelector(".ig-dmn__modal-inner");
    // Hide the loader
    modalLoader.classList.add("hidden");
    // Show the inner elem
    modalInner.classList.remove("hidden");
};
const $63daabb835e29093$var$initCloseModalTrigger = (widget, stage = "booking")=>{
    const closeTrigger = widget.querySelector(".ig-dmn__modal-close");
    if (closeTrigger) closeTrigger.addEventListener("click", (event)=>{
        event.preventDefault();
        $63daabb835e29093$export$3f6fecd573f3fa48(widget, stage);
    });
};
const $63daabb835e29093$export$3f6fecd573f3fa48 = (widget, stage = "booking")=>{
    const modal = widget.querySelector(".ig-dmn__modal");
    if (stage === "complete") {
        // Booking is complete so refresh widget
        // Check if we should load the venues stage or the booking type stage
        const initStage = widget.getAttribute("data-venues") && widget.getAttribute("data-venues") != "" ? "venues" : "bookingTypes";
        if (initStage === "venues") (0, $c5a626aad556a640$export$12ed1233ac55ca66)(widget);
        else (0, $c5a626aad556a640$export$f5f00fdbfdfc6331)(widget);
    }
    // Hide the modal
    document.body.style.overflow = "auto";
    modal.classList.remove("flex");
    modal.classList.add("hidden");
};


const $236d893478cc0ae9$export$303b87d72d757175 = (activeOffer)=>{
    const offers = $6ab8eb33d1de4787$export$54eca3721020c605("offers").map((offer)=>{
        return offer._id;
    });
    return offers.includes(activeOffer);
};
const $236d893478cc0ae9$export$c925ae8f8414d3e7 = (widget, offers)=>{
    // Update the offers in localStorage
    $6ab8eb33d1de4787$export$c925ae8f8414d3e7(offers);
    // Check if there is an active offer set in localStorage and check if this is still available. If not then remove the html and hide the active offer elem.
    const activeOffer = $6ab8eb33d1de4787$export$54eca3721020c605("activeOffer");
    const isActiveOfferValid = $236d893478cc0ae9$export$303b87d72d757175(activeOffer);
    if (!isActiveOfferValid) $236d893478cc0ae9$var$removeActiveOffer(widget);
    // Hide the offers section if there are no offers available for the data given
    if (offers.length > 0) widget.querySelector(".ig-dmn__offers").classList.remove("hidden");
    else widget.querySelector(".ig-dmn__offers").classList.add("hidden");
    // Run the initOffersModal function
    (0, $63daabb835e29093$export$1c9503703a5621c0)(widget);
    // Run the initRemoveOfferTrigger function
    $236d893478cc0ae9$var$initRemoveOfferTrigger(widget);
};
const $236d893478cc0ae9$var$removeActiveOffer = (widget)=>{
    // Update the activeOffer in localStorage
    $6ab8eb33d1de4787$export$dff0f9677dbdb644(null);
    // Hide the active offer elem from the widget
    widget.querySelector(".ig-dmn__offers-active").classList.add("hidden");
    // Reset the HTML of the active offer
    $4aa70e6322f04d6f$export$ce85b5fea1553a6(widget, ".ig-dmn__offers-active-item", "");
};
const $236d893478cc0ae9$var$initRemoveOfferTrigger = (widget)=>{
    const trigger = widget.querySelector(".ig-dmn__offers-active-remove");
    if (trigger) trigger.addEventListener("click", (event)=>{
        event.preventDefault();
        $236d893478cc0ae9$var$removeActiveOffer(widget);
    });
};
const $236d893478cc0ae9$export$3d7f7c678ef3fb35 = (widget)=>{
    const triggers = widget.querySelectorAll(".ig-dmn__modal-offer");
    if (triggers) triggers.forEach((trigger)=>{
        trigger.addEventListener("click", (event)=>{
            event.preventDefault();
            const offer = trigger.getAttribute("data-offer-id");
            const offerTitle = trigger.querySelector(".ig-dmn__modal-offer-title").innerHTML;
            // Update the active offer in localStorage
            $6ab8eb33d1de4787$export$dff0f9677dbdb644(offer);
            // Update the active offer text
            $4aa70e6322f04d6f$export$ce85b5fea1553a6(widget, ".ig-dmn__offers-active-item", offerTitle);
            // Show the active offer element
            widget.querySelector(".ig-dmn__offers-active").classList.remove("hidden");
            // Hide the modal
            (0, $63daabb835e29093$export$3f6fecd573f3fa48)(widget);
        });
    });
};





const $4633da21d666e450$export$c2afb403ff7aee9a = async (widget)=>{
    const type = widget.querySelector(".ig-dmn__form-dmn-type").value;
    const date = widget.querySelector(".ig-dmn__form-date").value;
    const formData = new FormData();
    formData.append("type", type);
    formData.append("date", date);
    formData.append("action", "getBookingRules");
    const venueId = (0, $6ab8eb33d1de4787$export$54eca3721020c605)("venue")._id;
    if (venueId) formData.append("venueID", venueId);
    const bookingRules = await (0, $551afe4eb57f5422$export$6fb38195a7366394)(formData);
    return bookingRules;
};



const $3d341e8d82a45736$export$4094a254a72f2bb8 = async (widget)=>{
    let duration = "";
    let numPeople = widget.querySelector(".ig-dmn__form-guests").value;
    const bookingRules = await (0, $4633da21d666e450$export$c2afb403ff7aee9a)(widget);
    if (bookingRules.no_duration) return duration;
    let minDuration = bookingRules.min_duration ?? null;
    let maxDuration = bookingRules.max_duration ?? null;
    // Check if numPeople has a value
    if (numPeople != "") {
        // Convert the numPeople variable to an integer
        numPeople = parseInt(numPeople);
        // Get the booking type object for the booking type selected
        const bookingTypeObj = (0, $6ab8eb33d1de4787$export$4cc47fe0ce792f33)();
        // Check if there are any rules dependant on number of guests set in DMN for the booking type selected
        if (bookingTypeObj.num_people_overrides) {
            // Get the min and max duration for the booking type based on the overrides
            const overrideDurations = $3d341e8d82a45736$var$getDurationOverrides(bookingTypeObj.num_people_overrides, numPeople);
            // If the getDurationOverrides function returns an object instead of false, update the mina dn max duration variables
            if (overrideDurations) {
                minDuration = overrideDurations.min;
                maxDuration = overrideDurations.max;
            }
        }
    }
    duration = await $3d341e8d82a45736$var$calcuateBookingDuration(minDuration, maxDuration);
    return duration;
};
const $3d341e8d82a45736$var$getDurationOverrides = (overrides, numPeople)=>{
    // Iterating through each range in the overrides array
    for(const key in overrides){
        const range = overrides[key];
        // Checking if numPeople falls within the current range
        if (numPeople >= range.num_people_from && numPeople <= range.num_people_to) // Returning an object with min_duration and max_duration, or null if they don't exist
        return {
            min: range.min_duration || null,
            max: range.max_duration || null
        };
    }
    // If no matching range is found, return false
    return false;
};
const $3d341e8d82a45736$var$calcuateBookingDuration = async (minDuration, maxDuration)=>{
    if (minDuration === null && maxDuration === null) // No min or max duration set in DMN so return an empty string;
    return "";
    if (minDuration) // Return the minDuration if set in DMN
    return minDuration;
    if (maxDuration) // If minDuration isn't set, return the maxDuration
    return maxDuration;
};





const $24588bd5abad6871$export$d8a437c87f927f7 = async (widget, depositInfo = false)=>{
    if (depositInfo) $24588bd5abad6871$var$showDepositSection(widget, depositInfo);
    else $24588bd5abad6871$export$187a8a85163fa692(widget);
};
const $24588bd5abad6871$export$187a8a85163fa692 = (widget)=>{
    // Clear any current deposit info
    $24588bd5abad6871$var$clearDepositInfo(widget);
// Add the hidden class to the section
//widget.querySelector('.ig-dmn__deposit').classList.add('hidden');
};
const $24588bd5abad6871$var$clearDepositInfo = (widget)=>{
    // Clear the HTML from the total cost elem
    (0, $4aa70e6322f04d6f$export$ce85b5fea1553a6)(widget, ".ig-dmn__deposit-total", "");
    // Clear the HTML from the description elem
    (0, $4aa70e6322f04d6f$export$ce85b5fea1553a6)(widget, ".ig-dmn__deposit-description", "");
};
const $24588bd5abad6871$var$updateDepositInfo = (widget, amount, total, perType, type)=>{
    const pounds = Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "GBP"
    });
    // Clear the HTML from the total cost elem
    (0, $4aa70e6322f04d6f$export$ce85b5fea1553a6)(widget, ".ig-dmn__deposit-total", pounds.format(total));
    // Clear the HTML from the description elem
    (0, $4aa70e6322f04d6f$export$ce85b5fea1553a6)(widget, ".ig-dmn__deposit-description", `${pounds.format(amount)} per ${perType}`);
};
const $24588bd5abad6871$var$showDepositSection = (widget, depositInfo)=>{
    // Clear any current deposit info
    $24588bd5abad6871$var$clearDepositInfo(widget);
    // Update the deposit info
    $24588bd5abad6871$var$updateDepositInfo(widget, depositInfo.amount, depositInfo.total, depositInfo.amount_per, depositInfo.type);
// Remove the hidden class to the section
//widget.querySelector('.ig-dmn__deposit').classList.remove('hidden');
};







const $24eadea78386e142$export$faea57be7a472670 = (widget)=>{
    const buttons = widget.querySelectorAll(".ig-dmn__stage-trigger");
    if (buttons) buttons.forEach((btn)=>{
        btn.addEventListener("click", (event)=>{
            event.preventDefault();
            const stage = btn.getAttribute("data-stage");
            (0, $cc943cf31e795207$export$56525cbb1fcd885c)(widget);
            // Run the init stage function to call the next stage
            (0, $c5a626aad556a640$export$ae2dff29da9c2d50)(widget, stage).then(()=>{
                // Scroll to the top of the widget
                (0, $4aa70e6322f04d6f$export$f09c14f15f5542d7)(widget);
                setTimeout(()=>{
                    (0, $cc943cf31e795207$export$5cee2c2772922923)(widget);
                }, 400);
            });
        });
    });
};
const $24eadea78386e142$export$299090c2cb4604f = async (widget, valid, action, validation)=>{
    const isFormComplete = (0, $f817778a02e4b83a$export$35b13d9c5f196302)(widget);
    const enquireBtn = widget.querySelector('.ig-dmn__stage-trigger[data-stage="enquire"]');
    const proceedBtn = widget.querySelector('.ig-dmn__stage-trigger[data-stage="details"]');
    if (isFormComplete) {
        if (action === "accept") {
            // Booking is valid so hide the enquiry buttona nd show the proceed button
            enquireBtn.classList.add("!hidden", "ig-dmn-btn--disabled");
            proceedBtn.classList.remove("!hidden", "ig-dmn-btn--disabled");
        }
        if (action === "enquire") {
            // Can submit an enquiry but not proceed so enable the enquire button and disable the proceed button
            enquireBtn.classList.remove("!hidden", "ig-dmn-btn--disabled");
            proceedBtn.classList.add("!hidden", "ig-dmn-btn--disabled");
        }
        if (action === "may_enquire") {
            // Bookings are full but you can still submit an enquiry. You can't proceed though so enable the enquire button and disable the proceed button
            enquireBtn.classList.remove("!hidden", "ig-dmn-btn--disabled");
            proceedBtn.classList.add("!hidden", "ig-dmn-btn--disabled");
        /* 
            * TODO: Show an error message here saying this is unavailable but you can still enquire
            */ }
        if (action === "reject") {
            // Can't proceed or submit an enquiry so disable both buttons
            enquireBtn.classList.add("!hidden", "ig-dmn-btn--disabled");
            proceedBtn.classList.add("!hidden", "ig-dmn-btn--disabled");
        /* 
            * TODO: Show an error message here saying this is unavailable
            */ }
    } else $24eadea78386e142$export$4c212154abb8b633(widget);
};
const $24eadea78386e142$export$4c212154abb8b633 = (widget)=>{
    const enquireBtn = widget.querySelector('.ig-dmn__stage-trigger[data-stage="enquire"]');
    const proceedBtn = widget.querySelector('.ig-dmn__stage-trigger[data-stage="details"]');
    // Show the enquire button
    enquireBtn.classList.remove("!hidden");
    // Disable the enquire button if no bookingType is set in localStorage
    if (!(0, $6ab8eb33d1de4787$export$54eca3721020c605)("bookingType")) enquireBtn.classList.add("ig-dmn-btn--disabled");
    // Show and disable the proceed button
    proceedBtn.classList.remove("!hidden");
    proceedBtn.classList.add("ig-dmn-btn--disabled");
};



const $b91133fb1ec5c5cc$export$9bc346c2d77d670a = async function(widget, triggerType) {
    const venueId = $6ab8eb33d1de4787$export$54eca3721020c605("venue")._id;
    // Check if the booking is valid
    const validation = await $b91133fb1ec5c5cc$export$8000a2305fcd955e(widget);
    const isValid = validation.valid;
    if (isValid && validation.action !== "reject") {
        // Update the bookingDetails in localStorage
        $6ab8eb33d1de4787$export$1a76a6d47efc9b3e({
            ...validation.bookingDetails,
            formType: validation.next.web ? "web" : "api",
            url: validation.next.web
        });
        // Update the validation in localStorage
        $6ab8eb33d1de4787$export$555e91b9030a2487(validation);
    } else // If a dropddown field is empty use the sugested values to populate this based on the infor selected
    // Display error messgae if all fields are added
    await (0, $f817778a02e4b83a$export$cecabb3b2fe7f2f9)(widget, validation.validation, triggerType);
    // Hide/Show the deposit section
    await (0, $24588bd5abad6871$export$d8a437c87f927f7)(widget, validation.depositRequired);
    // Update the nav buttons
    await (0, $24eadea78386e142$export$299090c2cb4604f)(widget, isValid, validation.action, validation);
    return validation;
};
const $b91133fb1ec5c5cc$export$8000a2305fcd955e = async function(widget) {
    const bookingForm = widget.querySelector(".ig-dmn__booking-form");
    if (bookingForm) {
        // Work out the duration here and pass it through to the validation
        const duration = await (0, $3d341e8d82a45736$export$4094a254a72f2bb8)(widget);
        const formData = new FormData(bookingForm);
        formData.append("duration", duration);
        formData.append("action", "getBookingValidation");
        const venueId = $6ab8eb33d1de4787$export$54eca3721020c605("venue")._id;
        if (venueId) formData.append("venueID", venueId);
        const debugData = [];
        for (const data of formData.entries())if (data[0] !== "action") debugData.push({
            key: data[0],
            value: data[1]
        });
        (0, $4aa70e6322f04d6f$export$3c293e733be50c44)("Checking if booking details are valid - https://api.designmynight.com/v4/venues/VENUE_ID/booking-availability?type=BOOKING_TYPE_ID&date=DATE&num_people=2NUM_PEOPLE&time=TIME&duration=DURATION");
        (0, $4aa70e6322f04d6f$export$3c293e733be50c44)("Booking Details:");
        (0, $4aa70e6322f04d6f$export$3c293e733be50c44)(debugData);
        const validation = await (0, $551afe4eb57f5422$export$6fb38195a7366394)(formData);
        (0, $4aa70e6322f04d6f$export$3c293e733be50c44)("Validation:");
        (0, $4aa70e6322f04d6f$export$3c293e733be50c44)(validation);
        return validation;
    }
};



class $252a7d750dfe5974$export$82f9ebd9adeba146 extends Date {
    static parseDateTime(e, i = "YYYY-MM-DD", n = "en-US") {
        if (!e) return new Date((new Date).setHours(0, 0, 0, 0));
        if (e instanceof $252a7d750dfe5974$export$82f9ebd9adeba146) return e.toJSDate();
        if (e instanceof Date) return e;
        if (/^-?\d{10,}$/.test(String(e))) return new Date(Number(e));
        if ("string" == typeof e) {
            const s = [];
            let o = null;
            for(; null != (o = $252a7d750dfe5974$export$82f9ebd9adeba146.regex.exec(i));)"\\" !== o[1] && s.push(o);
            if (s.length) {
                const i = {
                    year: null,
                    month: null,
                    shortMonth: null,
                    longMonth: null,
                    day: null,
                    hour: 0,
                    minute: 0,
                    second: 0,
                    ampm: null,
                    value: ""
                };
                s[0].index > 0 && (i.value += ".*?");
                for (const [e, o] of Object.entries(s)){
                    const s = Number(e), { group: a, pattern: r } = $252a7d750dfe5974$export$82f9ebd9adeba146.formatPatterns(o[0], n);
                    i[a] = s + 1, i.value += r, i.value += ".*?";
                }
                const o = new RegExp(`^${i.value}$`);
                if (o.test(e)) {
                    const s = o.exec(e), a = Number(s[i.year]);
                    let r = null;
                    i.month ? r = Number(s[i.month]) - 1 : i.shortMonth ? r = $252a7d750dfe5974$export$82f9ebd9adeba146.shortMonths(n).indexOf(s[i.shortMonth]) : i.longMonth && (r = $252a7d750dfe5974$export$82f9ebd9adeba146.longMonths(n).indexOf(s[i.longMonth]));
                    const c = Number(s[i.day]) || 1, l = Number(s[i.hour]);
                    let h = Number.isNaN(l) ? 0 : l;
                    const d = Number(s[i.minute]), p = Number.isNaN(d) ? 0 : d, u = Number(s[i.second]), g = Number.isNaN(u) ? 0 : u, m = s[i.ampm];
                    return m && "PM" === m && (h += 12, 24 === h && (h = 0)), new Date(a, r, c, h, p, g, 0);
                }
            }
        }
        return new Date((new Date).setHours(0, 0, 0, 0));
    }
    static regex = /(\\)?(Y{2,4}|M{1,4}|D{1,2}|H{1,2}|h{1,2}|m{1,2}|s{1,2}|A|a)/g;
    static MONTH_JS = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ];
    static shortMonths(e) {
        return $252a7d750dfe5974$export$82f9ebd9adeba146.MONTH_JS.map((t)=>new Date(2019, t).toLocaleString(e, {
                month: "short"
            }));
    }
    static longMonths(e) {
        return $252a7d750dfe5974$export$82f9ebd9adeba146.MONTH_JS.map((t)=>new Date(2019, t).toLocaleString(e, {
                month: "long"
            }));
    }
    static formatPatterns(e, i) {
        switch(e){
            case "YY":
            case "YYYY":
                return {
                    group: "year",
                    pattern: `(\\d{${e.length}})`
                };
            case "M":
                return {
                    group: "month",
                    pattern: "(\\d{1,2})"
                };
            case "MM":
                return {
                    group: "month",
                    pattern: "(\\d{2})"
                };
            case "MMM":
                return {
                    group: "shortMonth",
                    pattern: `(${$252a7d750dfe5974$export$82f9ebd9adeba146.shortMonths(i).join("|")})`
                };
            case "MMMM":
                return {
                    group: "longMonth",
                    pattern: `(${$252a7d750dfe5974$export$82f9ebd9adeba146.longMonths(i).join("|")})`
                };
            case "D":
                return {
                    group: "day",
                    pattern: "(\\d{1,2})"
                };
            case "DD":
                return {
                    group: "day",
                    pattern: "(\\d{2})"
                };
            case "h":
            case "H":
                return {
                    group: "hour",
                    pattern: "(\\d{1,2})"
                };
            case "hh":
            case "HH":
                return {
                    group: "hour",
                    pattern: "(\\d{2})"
                };
            case "m":
                return {
                    group: "minute",
                    pattern: "(\\d{1,2})"
                };
            case "mm":
                return {
                    group: "minute",
                    pattern: "(\\d{2})"
                };
            case "s":
                return {
                    group: "second",
                    pattern: "(\\d{1,2})"
                };
            case "ss":
                return {
                    group: "second",
                    pattern: "(\\d{2})"
                };
            case "a":
            case "A":
                return {
                    group: "ampm",
                    pattern: "(AM|PM|am|pm)"
                };
        }
    }
    lang;
    constructor(e = null, i = "YYYY-MM-DD", n = "en-US"){
        super($252a7d750dfe5974$export$82f9ebd9adeba146.parseDateTime(e, i, n)), this.lang = n;
    }
    getWeek(t) {
        const e = new Date(this.midnight_ts(this)), i = (this.getDay() + (7 - t)) % 7;
        e.setDate(e.getDate() - i);
        const n = e.getTime();
        return e.setMonth(0, 1), e.getDay() !== t && e.setMonth(0, 1 + (4 - e.getDay() + 7) % 7), 1 + Math.ceil((n - e.getTime()) / 6048e5);
    }
    clone() {
        return new $252a7d750dfe5974$export$82f9ebd9adeba146(this);
    }
    toJSDate() {
        return new Date(this);
    }
    inArray(t, e = "[]") {
        return t.some((t)=>t instanceof Array ? this.isBetween(t[0], t[1], e) : this.isSame(t, "day"));
    }
    isBetween(t, e, i = "()") {
        switch(i){
            default:
            case "()":
                return this.midnight_ts(this) > this.midnight_ts(t) && this.midnight_ts(this) < this.midnight_ts(e);
            case "[)":
                return this.midnight_ts(this) >= this.midnight_ts(t) && this.midnight_ts(this) < this.midnight_ts(e);
            case "(]":
                return this.midnight_ts(this) > this.midnight_ts(t) && this.midnight_ts(this) <= this.midnight_ts(e);
            case "[]":
                return this.midnight_ts() >= this.midnight_ts(t) && this.midnight_ts() <= this.midnight_ts(e);
        }
    }
    isBefore(t, e = "days") {
        switch(e){
            case "day":
            case "days":
                return new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime() > new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime();
            case "month":
            case "months":
                return new Date(t.getFullYear(), t.getMonth(), 1).getTime() > new Date(this.getFullYear(), this.getMonth(), 1).getTime();
            case "year":
            case "years":
                return t.getFullYear() > this.getFullYear();
        }
        throw new Error("isBefore: Invalid unit!");
    }
    isSameOrBefore(t, e = "days") {
        switch(e){
            case "day":
            case "days":
                return new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime() >= new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime();
            case "month":
            case "months":
                return new Date(t.getFullYear(), t.getMonth(), 1).getTime() >= new Date(this.getFullYear(), this.getMonth(), 1).getTime();
        }
        throw new Error("isSameOrBefore: Invalid unit!");
    }
    isAfter(t, e = "days") {
        switch(e){
            case "day":
            case "days":
                return new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime() > new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime();
            case "month":
            case "months":
                return new Date(this.getFullYear(), this.getMonth(), 1).getTime() > new Date(t.getFullYear(), t.getMonth(), 1).getTime();
            case "year":
            case "years":
                return this.getFullYear() > t.getFullYear();
        }
        throw new Error("isAfter: Invalid unit!");
    }
    isSameOrAfter(t, e = "days") {
        switch(e){
            case "day":
            case "days":
                return new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime() >= new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime();
            case "month":
            case "months":
                return new Date(this.getFullYear(), this.getMonth(), 1).getTime() >= new Date(t.getFullYear(), t.getMonth(), 1).getTime();
        }
        throw new Error("isSameOrAfter: Invalid unit!");
    }
    isSame(t, e = "days") {
        switch(e){
            case "day":
            case "days":
                return new Date(this.getFullYear(), this.getMonth(), this.getDate()).getTime() === new Date(t.getFullYear(), t.getMonth(), t.getDate()).getTime();
            case "month":
            case "months":
                return new Date(this.getFullYear(), this.getMonth(), 1).getTime() === new Date(t.getFullYear(), t.getMonth(), 1).getTime();
        }
        throw new Error("isSame: Invalid unit!");
    }
    add(t, e = "days") {
        switch(e){
            case "day":
            case "days":
                this.setDate(this.getDate() + t);
                break;
            case "month":
            case "months":
                this.setMonth(this.getMonth() + t);
        }
        return this;
    }
    subtract(t, e = "days") {
        switch(e){
            case "day":
            case "days":
                this.setDate(this.getDate() - t);
                break;
            case "month":
            case "months":
                this.setMonth(this.getMonth() - t);
        }
        return this;
    }
    diff(t, e = "days") {
        switch(e){
            default:
            case "day":
            case "days":
                return Math.round((this.midnight_ts() - this.midnight_ts(t)) / 864e5);
            case "month":
            case "months":
                let e1 = 12 * (t.getFullYear() - this.getFullYear());
                return e1 -= t.getMonth(), e1 += this.getMonth(), e1;
        }
    }
    format(e, i = "en-US") {
        let n = "";
        const s = [];
        let o = null;
        for(; null != (o = $252a7d750dfe5974$export$82f9ebd9adeba146.regex.exec(e));)"\\" !== o[1] && s.push(o);
        if (s.length) {
            s[0].index > 0 && (n += e.substring(0, s[0].index));
            for (const [t, o] of Object.entries(s)){
                const a = Number(t);
                n += this.formatTokens(o[0], i), s[a + 1] && (n += e.substring(o.index + o[0].length, s[a + 1].index)), a === s.length - 1 && (n += e.substring(o.index + o[0].length));
            }
        }
        return n.replace(/\\/g, "");
    }
    midnight_ts(t) {
        return t ? new Date(t.getFullYear(), t.getMonth(), t.getDate(), 0, 0, 0, 0).getTime() : new Date(this.getFullYear(), this.getMonth(), this.getDate(), 0, 0, 0, 0).getTime();
    }
    formatTokens(e, i) {
        switch(e){
            case "YY":
                return String(this.getFullYear()).slice(-2);
            case "YYYY":
                return String(this.getFullYear());
            case "M":
                return String(this.getMonth() + 1);
            case "MM":
                return `0${this.getMonth() + 1}`.slice(-2);
            case "MMM":
                return $252a7d750dfe5974$export$82f9ebd9adeba146.shortMonths(i)[this.getMonth()];
            case "MMMM":
                return $252a7d750dfe5974$export$82f9ebd9adeba146.longMonths(i)[this.getMonth()];
            case "D":
                return String(this.getDate());
            case "DD":
                return `0${this.getDate()}`.slice(-2);
            case "H":
                return String(this.getHours());
            case "HH":
                return `0${this.getHours()}`.slice(-2);
            case "h":
                return String(this.getHours() % 12 || 12);
            case "hh":
                return `0${this.getHours() % 12 || 12}`.slice(-2);
            case "m":
                return String(this.getMinutes());
            case "mm":
                return `0${this.getMinutes()}`.slice(-2);
            case "s":
                return String(this.getSeconds());
            case "ss":
                return `0${this.getSeconds()}`.slice(-2);
            case "a":
                return this.getHours() < 12 || 24 === this.getHours() ? "am" : "pm";
            case "A":
                return this.getHours() < 12 || 24 === this.getHours() ? "AM" : "PM";
            default:
                return "";
        }
    }
}
class $252a7d750dfe5974$var$e {
    picker;
    constructor(t){
        this.picker = t;
    }
    render(e, i) {
        e || (e = new $252a7d750dfe5974$export$82f9ebd9adeba146), e.setDate(1), e.setHours(0, 0, 0, 0), "function" == typeof this[`get${i}View`] && this[`get${i}View`](e);
    }
    getContainerView(t) {
        this.picker.ui.container.innerHTML = "", this.picker.options.header && this.picker.trigger("render", {
            date: t.clone(),
            view: "Header"
        }), this.picker.trigger("render", {
            date: t.clone(),
            view: "Main"
        }), this.picker.options.autoApply || this.picker.trigger("render", {
            date: t.clone(),
            view: "Footer"
        });
    }
    getHeaderView(t) {
        const e = document.createElement("header");
        this.picker.options.header instanceof HTMLElement && e.appendChild(this.picker.options.header), "string" == typeof this.picker.options.header && (e.innerHTML = this.picker.options.header), this.picker.ui.container.appendChild(e), this.picker.trigger("view", {
            target: e,
            date: t.clone(),
            view: "Header"
        });
    }
    getMainView(t) {
        const e = document.createElement("main");
        this.picker.ui.container.appendChild(e);
        const i = document.createElement("div");
        i.className = `calendars grid-${this.picker.options.grid}`;
        for(let e = 0; e < this.picker.options.calendars; e++){
            const n = document.createElement("div");
            n.className = "calendar", i.appendChild(n);
            const s = this.getCalendarHeaderView(t.clone());
            n.appendChild(s), this.picker.trigger("view", {
                date: t.clone(),
                view: "CalendarHeader",
                index: e,
                target: s
            });
            const o = this.getCalendarDayNamesView();
            n.appendChild(o), this.picker.trigger("view", {
                date: t.clone(),
                view: "CalendarDayNames",
                index: e,
                target: o
            });
            const a = this.getCalendarDaysView(t.clone());
            n.appendChild(a), this.picker.trigger("view", {
                date: t.clone(),
                view: "CalendarDays",
                index: e,
                target: a
            });
            const r = this.getCalendarFooterView(this.picker.options.lang, t.clone());
            n.appendChild(r), this.picker.trigger("view", {
                date: t.clone(),
                view: "CalendarFooter",
                index: e,
                target: r
            }), this.picker.trigger("view", {
                date: t.clone(),
                view: "CalendarItem",
                index: e,
                target: n
            }), t.add(1, "month");
        }
        e.appendChild(i), this.picker.trigger("view", {
            date: t.clone(),
            view: "Calendars",
            target: i
        }), this.picker.trigger("view", {
            date: t.clone(),
            view: "Main",
            target: e
        });
    }
    getFooterView(t) {
        const e = document.createElement("footer"), i = document.createElement("div");
        i.className = "footer-buttons";
        const n = document.createElement("button");
        n.className = "cancel-button unit", n.innerHTML = this.picker.options.locale.cancel, i.appendChild(n);
        const s = document.createElement("button");
        s.className = "apply-button unit", s.innerHTML = this.picker.options.locale.apply, s.disabled = !0, i.appendChild(s), e.appendChild(i), this.picker.ui.container.appendChild(e), this.picker.trigger("view", {
            date: t,
            target: e,
            view: "Footer"
        });
    }
    getCalendarHeaderView(t) {
        const e = document.createElement("div");
        e.className = "header";
        const i = document.createElement("div");
        i.className = "month-name", i.innerHTML = `<span>${t.toLocaleString(this.picker.options.lang, {
            month: "long"
        })}</span> ${t.format("YYYY")}`, e.appendChild(i);
        const n = document.createElement("button");
        n.className = "previous-button unit", n.innerHTML = this.picker.options.locale.previousMonth, e.appendChild(n);
        const s = document.createElement("button");
        return s.className = "next-button unit", s.innerHTML = this.picker.options.locale.nextMonth, e.appendChild(s), e;
    }
    getCalendarDayNamesView() {
        const t = document.createElement("div");
        t.className = "daynames-row";
        for(let e = 1; e <= 7; e++){
            const i = 3 + this.picker.options.firstDay + e, n = document.createElement("div");
            n.className = "dayname", n.innerHTML = new Date(1970, 0, i, 12, 0, 0, 0).toLocaleString(this.picker.options.lang, {
                weekday: "short"
            }), n.title = new Date(1970, 0, i, 12, 0, 0, 0).toLocaleString(this.picker.options.lang, {
                weekday: "long"
            }), t.appendChild(n), this.picker.trigger("view", {
                dayIdx: i,
                view: "CalendarDayName",
                target: n
            });
        }
        return t;
    }
    getCalendarDaysView(t) {
        const e = document.createElement("div");
        e.className = "days-grid";
        const i = this.calcOffsetDays(t, this.picker.options.firstDay), n = 32 - new Date(t.getFullYear(), t.getMonth(), 32).getDate();
        for(let t = 0; t < i; t++){
            const t = document.createElement("div");
            t.className = "offset", e.appendChild(t);
        }
        for(let i = 1; i <= n; i++){
            t.setDate(i);
            const n = this.getCalendarDayView(t);
            e.appendChild(n), this.picker.trigger("view", {
                date: t,
                view: "CalendarDay",
                target: n
            });
        }
        return e;
    }
    getCalendarDayView(e) {
        const i = this.picker.options.date ? new $252a7d750dfe5974$export$82f9ebd9adeba146(this.picker.options.date) : null, n = new $252a7d750dfe5974$export$82f9ebd9adeba146, s = document.createElement("div");
        return s.className = "day unit", s.innerHTML = e.format("D"), s.dataset.time = String(e.getTime()), e.isSame(n, "day") && s.classList.add("today"), [
            0,
            6
        ].includes(e.getDay()) && s.classList.add("weekend"), this.picker.datePicked.length ? this.picker.datePicked[0].isSame(e, "day") && s.classList.add("selected") : i && e.isSame(i, "day") && s.classList.add("selected"), this.picker.trigger("view", {
            date: e,
            view: "CalendarDay",
            target: s
        }), s;
    }
    getCalendarFooterView(t, e) {
        const i = document.createElement("div");
        return i.className = "footer", i;
    }
    calcOffsetDays(t, e) {
        let i = t.getDay() - e;
        return i < 0 && (i += 7), i;
    }
}
class $252a7d750dfe5974$var$i {
    picker;
    instances = {};
    constructor(t){
        this.picker = t;
    }
    initialize() {
        const t = [];
        this.picker.options.plugins.forEach((e)=>{
            "function" == typeof e ? t.push(new e) : "string" == typeof e && "undefined" != typeof easepick && Object.prototype.hasOwnProperty.call(easepick, e) ? t.push(new easepick[e]) : console.warn(`easepick: ${e} not found.`);
        }), t.sort((t, e)=>t.priority > e.priority ? -1 : t.priority < e.priority || t.dependencies.length > e.dependencies.length ? 1 : t.dependencies.length < e.dependencies.length ? -1 : 0), t.forEach((t)=>{
            t.attach(this.picker), this.instances[t.getName()] = t;
        });
    }
    getInstance(t) {
        return this.instances[t];
    }
    addInstance(t) {
        if (Object.prototype.hasOwnProperty.call(this.instances, t)) console.warn(`easepick: ${t} already added.`);
        else {
            if ("undefined" != typeof easepick && Object.prototype.hasOwnProperty.call(easepick, t)) {
                const e = new easepick[t];
                return e.attach(this.picker), this.instances[e.getName()] = e, e;
            }
            if ("undefined" !== this.getPluginFn(t)) {
                const e = new (this.getPluginFn(t));
                return e.attach(this.picker), this.instances[e.getName()] = e, e;
            }
            console.warn(`easepick: ${t} not found.`);
        }
        return null;
    }
    removeInstance(t) {
        return t in this.instances && this.instances[t].detach(), delete this.instances[t];
    }
    reloadInstance(t) {
        return this.removeInstance(t), this.addInstance(t);
    }
    getPluginFn(t) {
        return [
            ...this.picker.options.plugins
        ].filter((e)=>"function" == typeof e && (new e).getName() === t).shift();
    }
}
class $252a7d750dfe5974$export$185802fd694ee1f5 {
    Calendar = new $252a7d750dfe5974$var$e(this);
    PluginManager = new $252a7d750dfe5974$var$i(this);
    calendars = [];
    datePicked = [];
    cssLoaded = 0;
    binds = {
        hidePicker: this.hidePicker.bind(this),
        show: this.show.bind(this)
    };
    options = {
        doc: document,
        css: [],
        element: null,
        firstDay: 1,
        grid: 1,
        calendars: 1,
        lang: "en-US",
        date: null,
        format: "YYYY-MM-DD",
        readonly: !0,
        autoApply: !0,
        header: !1,
        inline: !1,
        scrollToDate: !0,
        locale: {
            nextMonth: '<svg width="11" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M2.748 16L0 13.333 5.333 8 0 2.667 2.748 0l7.919 8z" fill-rule="nonzero"/></svg>',
            previousMonth: '<svg width="11" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M7.919 0l2.748 2.667L5.333 8l5.334 5.333L7.919 16 0 8z" fill-rule="nonzero"/></svg>',
            cancel: "Cancel",
            apply: "Apply"
        },
        documentClick: this.binds.hidePicker,
        plugins: []
    };
    ui = {
        container: null,
        shadowRoot: null,
        wrapper: null
    };
    version = "1.2.1";
    constructor(t){
        const e = {
            ...this.options.locale,
            ...t.locale
        };
        this.options = {
            ...this.options,
            ...t
        }, this.options.locale = e, this.handleOptions(), this.ui.wrapper = document.createElement("span"), this.ui.wrapper.style.display = "none", this.ui.wrapper.style.position = "absolute", this.ui.wrapper.style.pointerEvents = "none", this.ui.wrapper.className = "easepick-wrapper", this.ui.wrapper.attachShadow({
            mode: "open"
        }), this.ui.shadowRoot = this.ui.wrapper.shadowRoot, this.ui.container = document.createElement("div"), this.ui.container.className = "container", this.options.zIndex && (this.ui.container.style.zIndex = String(this.options.zIndex)), this.options.inline && (this.ui.wrapper.style.position = "relative", this.ui.container.classList.add("inline")), this.ui.shadowRoot.appendChild(this.ui.container), this.options.element.after(this.ui.wrapper), this.handleCSS(), this.options.element.addEventListener("click", this.binds.show), this.on("view", this.onView.bind(this)), this.on("render", this.onRender.bind(this)), this.PluginManager.initialize(), this.parseValues(), "function" == typeof this.options.setup && this.options.setup(this), this.on("click", this.onClick.bind(this));
        const i = this.options.scrollToDate ? this.getDate() : null;
        this.renderAll(i);
    }
    on(t, e, i = {}) {
        this.ui.container.addEventListener(t, e, i);
    }
    off(t, e, i = {}) {
        this.ui.container.removeEventListener(t, e, i);
    }
    trigger(t, e = {}) {
        return this.ui.container.dispatchEvent(new CustomEvent(t, {
            detail: e
        }));
    }
    destroy() {
        this.options.element.removeEventListener("click", this.binds.show), "function" == typeof this.options.documentClick && document.removeEventListener("click", this.options.documentClick, !0), Object.keys(this.PluginManager.instances).forEach((t)=>{
            this.PluginManager.removeInstance(t);
        }), this.ui.wrapper.remove();
    }
    onRender(t) {
        const { view: e, date: i } = t.detail;
        this.Calendar.render(i, e);
    }
    onView(t) {
        const { view: e, target: i } = t.detail;
        "Footer" === e && this.datePicked.length && (i.querySelector(".apply-button").disabled = !1);
    }
    onClickHeaderButton(t) {
        this.isCalendarHeaderButton(t) && (t.classList.contains("next-button") ? this.calendars[0].add(1, "month") : this.calendars[0].subtract(1, "month"), this.renderAll(this.calendars[0]));
    }
    onClickCalendarDay(e) {
        if (this.isCalendarDay(e)) {
            const i = new $252a7d750dfe5974$export$82f9ebd9adeba146(e.dataset.time);
            this.options.autoApply ? (this.setDate(i), this.trigger("select", {
                date: this.getDate()
            }), this.hide()) : (this.datePicked[0] = i, this.trigger("preselect", {
                date: this.getDate()
            }), this.renderAll());
        }
    }
    onClickApplyButton(t) {
        if (this.isApplyButton(t)) {
            if (this.datePicked[0] instanceof Date) {
                const t = this.datePicked[0].clone();
                this.setDate(t);
            }
            this.hide(), this.trigger("select", {
                date: this.getDate()
            });
        }
    }
    onClickCancelButton(t) {
        this.isCancelButton(t) && this.hide();
    }
    onClick(t) {
        const e = t.target;
        if (e instanceof HTMLElement) {
            const t = e.closest(".unit");
            if (!(t instanceof HTMLElement)) return;
            this.onClickHeaderButton(t), this.onClickCalendarDay(t), this.onClickApplyButton(t), this.onClickCancelButton(t);
        }
    }
    isShown() {
        return this.ui.container.classList.contains("inline") || this.ui.container.classList.contains("show");
    }
    show(t) {
        if (this.isShown()) return;
        const e = t && "target" in t ? t.target : this.options.element, { top: i, left: n } = this.adjustPosition(e);
        this.ui.container.style.top = `${i}px`, this.ui.container.style.left = `${n}px`, this.ui.container.classList.add("show"), this.trigger("show", {
            target: e
        });
    }
    hide() {
        this.ui.container.classList.remove("show"), this.datePicked.length = 0, this.renderAll(), this.trigger("hide");
    }
    setDate(e) {
        const i = new $252a7d750dfe5974$export$82f9ebd9adeba146(e, this.options.format);
        this.options.date = i.clone(), this.updateValues(), this.calendars.length && this.renderAll();
    }
    getDate() {
        return this.options.date instanceof $252a7d750dfe5974$export$82f9ebd9adeba146 ? this.options.date.clone() : null;
    }
    parseValues() {
        this.options.date ? this.setDate(this.options.date) : this.options.element instanceof HTMLInputElement && this.options.element.value.length && this.setDate(this.options.element.value), this.options.date instanceof Date || (this.options.date = null);
    }
    updateValues() {
        const t = this.getDate(), e = t instanceof Date ? t.format(this.options.format, this.options.lang) : "", i = this.options.element;
        i instanceof HTMLInputElement ? i.value = e : i instanceof HTMLElement && (i.innerText = e);
    }
    hidePicker(t) {
        let e = t.target, i = null;
        e.shadowRoot && (e = t.composedPath()[0], i = e.getRootNode().host), this.isShown() && i !== this.ui.wrapper && e !== this.options.element && this.hide();
    }
    renderAll(t) {
        this.trigger("render", {
            view: "Container",
            date: (t || this.calendars[0]).clone()
        });
    }
    isCalendarHeaderButton(t) {
        return [
            "previous-button",
            "next-button"
        ].some((e)=>t.classList.contains(e));
    }
    isCalendarDay(t) {
        return t.classList.contains("day");
    }
    isApplyButton(t) {
        return t.classList.contains("apply-button");
    }
    isCancelButton(t) {
        return t.classList.contains("cancel-button");
    }
    gotoDate(e) {
        const i = new $252a7d750dfe5974$export$82f9ebd9adeba146(e, this.options.format);
        i.setDate(1), this.calendars[0] = i.clone(), this.renderAll();
    }
    clear() {
        this.options.date = null, this.datePicked.length = 0, this.updateValues(), this.renderAll(), this.trigger("clear");
    }
    handleOptions() {
        this.options.element instanceof HTMLElement || (this.options.element = this.options.doc.querySelector(this.options.element)), "function" == typeof this.options.documentClick && document.addEventListener("click", this.options.documentClick, !0), this.options.element instanceof HTMLInputElement && (this.options.element.readOnly = this.options.readonly), this.options.date ? this.calendars[0] = new $252a7d750dfe5974$export$82f9ebd9adeba146(this.options.date, this.options.format) : this.calendars[0] = new $252a7d750dfe5974$export$82f9ebd9adeba146;
    }
    handleCSS() {
        if (Array.isArray(this.options.css)) this.options.css.forEach((t)=>{
            const e = document.createElement("link");
            e.href = t, e.rel = "stylesheet";
            const i = ()=>{
                this.cssLoaded++, this.cssLoaded === this.options.css.length && (this.ui.wrapper.style.display = "");
            };
            e.addEventListener("load", i), e.addEventListener("error", i), this.ui.shadowRoot.append(e);
        });
        else if ("string" == typeof this.options.css) {
            const t = document.createElement("style"), e = document.createTextNode(this.options.css);
            t.appendChild(e), this.ui.shadowRoot.append(t), this.ui.wrapper.style.display = "";
        } else "function" == typeof this.options.css && (this.options.css.call(this, this), this.ui.wrapper.style.display = "");
    }
    adjustPosition(t) {
        const e = t.getBoundingClientRect(), i = this.ui.wrapper.getBoundingClientRect();
        this.ui.container.classList.add("calc");
        const n = this.ui.container.getBoundingClientRect();
        this.ui.container.classList.remove("calc");
        let s = e.bottom - i.bottom, o = e.left - i.left;
        return "undefined" != typeof window && (window.innerHeight < s + n.height && s - n.height >= 0 && (s = e.top - i.top - n.height), window.innerWidth < o + n.width && e.right - n.width >= 0 && (o = e.right - i.right - n.width)), {
            left: o,
            top: s
        };
    }
}
var $252a7d750dfe5974$export$4a89e7a35daa0ff4 = Object.freeze({
    __proto__: null,
    Core: $252a7d750dfe5974$export$185802fd694ee1f5,
    create: $252a7d750dfe5974$export$185802fd694ee1f5
});
class $252a7d750dfe5974$var$o {
    picker;
    options;
    priority = 0;
    dependencies = [];
    attach(t) {
        const e = this.getName(), i = {
            ...this.options
        };
        this.options = {
            ...this.options,
            ...t.options[e] || {}
        };
        for (const n of Object.keys(i))if (null !== i[n] && "object" == typeof i[n] && Object.keys(i[n]).length && e in t.options && n in t.options[e]) {
            const s = {
                ...t.options[e][n]
            };
            null !== s && "object" == typeof s && Object.keys(s).length && Object.keys(s).every((t)=>Object.keys(i[n]).includes(t)) && (this.options[n] = {
                ...i[n],
                ...s
            });
        }
        if (this.picker = t, this.dependenciesNotFound()) {
            const t = this.dependencies.filter((t)=>!this.pluginsAsStringArray().includes(t));
            return void console.warn(`${this.getName()}: required dependencies (${t.join(", ")}).`);
        }
        const n = this.camelCaseToKebab(this.getName());
        this.picker.ui.container.classList.add(n), this.onAttach();
    }
    detach() {
        const t = this.camelCaseToKebab(this.getName());
        this.picker.ui.container.classList.remove(t), "function" == typeof this.onDetach && this.onDetach();
    }
    dependenciesNotFound() {
        return this.dependencies.length && !this.dependencies.every((t)=>this.pluginsAsStringArray().includes(t));
    }
    pluginsAsStringArray() {
        return this.picker.options.plugins.map((t)=>"function" == typeof t ? (new t).getName() : t);
    }
    camelCaseToKebab(t) {
        return t.replace(/([a-zA-Z])(?=[A-Z])/g, "$1-").toLowerCase();
    }
}
class $252a7d750dfe5974$export$104e0eb2cfcc1787 extends $252a7d750dfe5974$var$o {
    priority = 1;
    binds = {
        onView: this.onView.bind(this)
    };
    options = {
        minDate: null,
        maxDate: null,
        minDays: null,
        maxDays: null,
        selectForward: null,
        selectBackward: null,
        presets: !0,
        inseparable: !1,
        filter: null
    };
    getName() {
        return "LockPlugin";
    }
    onAttach() {
        if (this.options.minDate && (this.options.minDate = new $252a7d750dfe5974$export$82f9ebd9adeba146(this.options.minDate, this.picker.options.format, this.picker.options.lang)), this.options.maxDate && (this.options.maxDate = new $252a7d750dfe5974$export$82f9ebd9adeba146(this.options.maxDate, this.picker.options.format, this.picker.options.lang), this.options.maxDate instanceof $252a7d750dfe5974$export$82f9ebd9adeba146 && this.picker.options.calendars > 1 && this.picker.calendars[0].isSame(this.options.maxDate, "month"))) {
            const t = this.picker.calendars[0].clone().subtract(1, "month");
            this.picker.gotoDate(t);
        }
        if ((this.options.minDays || this.options.maxDays || this.options.selectForward || this.options.selectBackward) && !this.picker.options.plugins.includes("RangePlugin")) {
            const t = [
                "minDays",
                "maxDays",
                "selectForward",
                "selectBackward"
            ];
            console.warn(`${this.getName()}: options ${t.join(", ")} required RangePlugin.`);
        }
        this.picker.on("view", this.binds.onView);
    }
    onDetach() {
        this.picker.off("view", this.binds.onView);
    }
    onView(e) {
        const { view: i, target: n, date: s } = e.detail;
        if ("CalendarHeader" === i && (this.options.minDate instanceof $252a7d750dfe5974$export$82f9ebd9adeba146 && s.isSameOrBefore(this.options.minDate, "month") && n.classList.add("no-previous-month"), this.options.maxDate instanceof $252a7d750dfe5974$export$82f9ebd9adeba146 && s.isSameOrAfter(this.options.maxDate, "month") && n.classList.add("no-next-month")), "CalendarDay" === i) {
            const t = this.picker.datePicked.length ? this.picker.datePicked[0] : null;
            if (this.testFilter(s)) return void n.classList.add("locked");
            if (this.options.inseparable) {
                if (this.options.minDays) {
                    const t = s.clone().subtract(this.options.minDays - 1, "day"), e = s.clone().add(this.options.minDays - 1, "day");
                    let i = !1, o = !1;
                    for(; t.isBefore(s, "day");){
                        if (this.testFilter(t)) {
                            i = !0;
                            break;
                        }
                        t.add(1, "day");
                    }
                    for(; e.isAfter(s, "day");){
                        if (this.testFilter(e)) {
                            o = !0;
                            break;
                        }
                        e.subtract(1, "day");
                    }
                    i && o && n.classList.add("not-available");
                }
                this.rangeIsNotAvailable(s, t) && n.classList.add("not-available");
            }
            this.dateIsNotAvailable(s, t) && n.classList.add("not-available");
        }
        if (this.options.presets && "PresetPluginButton" === i) {
            const e = new $252a7d750dfe5974$export$82f9ebd9adeba146(Number(n.dataset.start)), i = new $252a7d750dfe5974$export$82f9ebd9adeba146(Number(n.dataset.end)), s = i.diff(e, "day"), o = this.options.minDays && s < this.options.minDays, a = this.options.maxDays && s > this.options.maxDays;
            (o || a || this.lockMinDate(e) || this.lockMaxDate(e) || this.lockMinDate(i) || this.lockMaxDate(i) || this.rangeIsNotAvailable(e, i)) && n.setAttribute("disabled", "disabled");
        }
    }
    dateIsNotAvailable(t, e) {
        return this.lockMinDate(t) || this.lockMaxDate(t) || this.lockMinDays(t, e) || this.lockMaxDays(t, e) || this.lockSelectForward(t) || this.lockSelectBackward(t);
    }
    rangeIsNotAvailable(t, e) {
        if (!t || !e) return !1;
        const i = (t.isSameOrBefore(e, "day") ? t : e).clone(), n = (e.isSameOrAfter(t, "day") ? e : t).clone();
        for(; i.isSameOrBefore(n, "day");){
            if (this.testFilter(i)) return !0;
            i.add(1, "day");
        }
        return !1;
    }
    lockMinDate(e) {
        return this.options.minDate instanceof $252a7d750dfe5974$export$82f9ebd9adeba146 && e.isBefore(this.options.minDate, "day");
    }
    lockMaxDate(e) {
        return this.options.maxDate instanceof $252a7d750dfe5974$export$82f9ebd9adeba146 && e.isAfter(this.options.maxDate, "day");
    }
    lockMinDays(t, e) {
        if (this.options.minDays && e) {
            const i = e.clone().subtract(this.options.minDays - 1, "day"), n = e.clone().add(this.options.minDays - 1, "day");
            return t.isBetween(i, n);
        }
        return !1;
    }
    lockMaxDays(t, e) {
        if (this.options.maxDays && e) {
            const i = e.clone().subtract(this.options.maxDays, "day"), n = e.clone().add(this.options.maxDays, "day");
            return !t.isBetween(i, n);
        }
        return !1;
    }
    lockSelectForward(t) {
        if (1 === this.picker.datePicked.length && this.options.selectForward) {
            const e = this.picker.datePicked[0].clone();
            return t.isBefore(e, "day");
        }
        return !1;
    }
    lockSelectBackward(t) {
        if (1 === this.picker.datePicked.length && this.options.selectBackward) {
            const e = this.picker.datePicked[0].clone();
            return t.isAfter(e, "day");
        }
        return !1;
    }
    testFilter(t) {
        return "function" == typeof this.options.filter && this.options.filter(t, this.picker.datePicked);
    }
}
class $252a7d750dfe5974$export$50cb8d2d94e32d56 extends $252a7d750dfe5974$var$o {
    dependencies = [
        "RangePlugin"
    ];
    binds = {
        onView: this.onView.bind(this),
        onClick: this.onClick.bind(this)
    };
    options = {
        customLabels: [
            "Today",
            "Yesterday",
            "Last 7 Days",
            "Last 30 Days",
            "This Month",
            "Last Month"
        ],
        customPreset: {},
        position: "left"
    };
    getName() {
        return "PresetPlugin";
    }
    onAttach() {
        if (!Object.keys(this.options.customPreset).length) {
            const e = new $252a7d750dfe5974$export$82f9ebd9adeba146, i = ()=>{
                const i = e.clone();
                i.setDate(1);
                const n = new Date(e.getFullYear(), e.getMonth() + 1, 0);
                return [
                    new $252a7d750dfe5974$export$82f9ebd9adeba146(i),
                    new $252a7d750dfe5974$export$82f9ebd9adeba146(n)
                ];
            }, n = ()=>{
                const i = e.clone();
                i.setMonth(i.getMonth() - 1), i.setDate(1);
                const n = new Date(e.getFullYear(), e.getMonth(), 0);
                return [
                    new $252a7d750dfe5974$export$82f9ebd9adeba146(i),
                    new $252a7d750dfe5974$export$82f9ebd9adeba146(n)
                ];
            }, s = [
                [
                    e.clone(),
                    e.clone()
                ],
                [
                    e.clone().subtract(1, "day"),
                    e.clone().subtract(1, "day")
                ],
                [
                    e.clone().subtract(6, "day"),
                    e.clone()
                ],
                [
                    e.clone().subtract(29, "day"),
                    e.clone()
                ],
                i(),
                n()
            ];
            Object.values(this.options.customLabels).forEach((t, e)=>{
                this.options.customPreset[t] = s[e];
            });
        }
        this.picker.on("view", this.binds.onView), this.picker.on("click", this.binds.onClick);
    }
    onDetach() {
        this.picker.off("view", this.binds.onView), this.picker.off("click", this.binds.onClick);
    }
    onView(t) {
        const { view: e, target: i } = t.detail;
        if ("Main" === e) {
            const t = document.createElement("div");
            t.className = "preset-plugin-container", Object.keys(this.options.customPreset).forEach((e)=>{
                if (Object.prototype.hasOwnProperty.call(this.options.customPreset, e)) {
                    const i = this.options.customPreset[e], n = document.createElement("button");
                    n.className = "preset-button unit", n.innerHTML = e, n.dataset.start = i[0].getTime(), n.dataset.end = i[1].getTime(), t.appendChild(n), this.picker.trigger("view", {
                        view: "PresetPluginButton",
                        target: n
                    });
                }
            }), i.appendChild(t), i.classList.add(`preset-${this.options.position}`), this.picker.trigger("view", {
                view: "PresetPluginContainer",
                target: t
            });
        }
    }
    onClick(e) {
        const i = e.target;
        if (i instanceof HTMLElement) {
            const e = i.closest(".unit");
            if (!(e instanceof HTMLElement)) return;
            if (this.isPresetButton(e)) {
                const i = new $252a7d750dfe5974$export$82f9ebd9adeba146(Number(e.dataset.start)), n = new $252a7d750dfe5974$export$82f9ebd9adeba146(Number(e.dataset.end));
                this.picker.options.autoApply ? (this.picker.setDateRange(i, n), this.picker.trigger("select", {
                    start: this.picker.getStartDate(),
                    end: this.picker.getEndDate()
                }), this.picker.hide()) : (this.picker.datePicked = [
                    i,
                    n
                ], this.picker.renderAll());
            }
        }
    }
    isPresetButton(t) {
        return t.classList.contains("preset-button");
    }
}
class $252a7d750dfe5974$export$b24658a4f5b768c extends $252a7d750dfe5974$var$o {
    tooltipElement;
    triggerElement;
    binds = {
        setStartDate: this.setStartDate.bind(this),
        setEndDate: this.setEndDate.bind(this),
        setDateRange: this.setDateRange.bind(this),
        getStartDate: this.getStartDate.bind(this),
        getEndDate: this.getEndDate.bind(this),
        onView: this.onView.bind(this),
        onShow: this.onShow.bind(this),
        onMouseEnter: this.onMouseEnter.bind(this),
        onMouseLeave: this.onMouseLeave.bind(this),
        onClickCalendarDay: this.onClickCalendarDay.bind(this),
        onClickApplyButton: this.onClickApplyButton.bind(this),
        parseValues: this.parseValues.bind(this),
        updateValues: this.updateValues.bind(this),
        clear: this.clear.bind(this)
    };
    options = {
        elementEnd: null,
        startDate: null,
        endDate: null,
        repick: !1,
        strict: !0,
        delimiter: " - ",
        tooltip: !0,
        tooltipNumber: (t)=>t,
        locale: {
            zero: "",
            one: "day",
            two: "",
            few: "",
            many: "",
            other: "days"
        },
        documentClick: this.hidePicker.bind(this)
    };
    getName() {
        return "RangePlugin";
    }
    onAttach() {
        this.binds._setStartDate = this.picker.setStartDate, this.binds._setEndDate = this.picker.setEndDate, this.binds._setDateRange = this.picker.setDateRange, this.binds._getStartDate = this.picker.getStartDate, this.binds._getEndDate = this.picker.getEndDate, this.binds._parseValues = this.picker.parseValues, this.binds._updateValues = this.picker.updateValues, this.binds._clear = this.picker.clear, this.binds._onClickCalendarDay = this.picker.onClickCalendarDay, this.binds._onClickApplyButton = this.picker.onClickApplyButton, Object.defineProperties(this.picker, {
            setStartDate: {
                configurable: !0,
                value: this.binds.setStartDate
            },
            setEndDate: {
                configurable: !0,
                value: this.binds.setEndDate
            },
            setDateRange: {
                configurable: !0,
                value: this.binds.setDateRange
            },
            getStartDate: {
                configurable: !0,
                value: this.binds.getStartDate
            },
            getEndDate: {
                configurable: !0,
                value: this.binds.getEndDate
            },
            parseValues: {
                configurable: !0,
                value: this.binds.parseValues
            },
            updateValues: {
                configurable: !0,
                value: this.binds.updateValues
            },
            clear: {
                configurable: !0,
                value: this.binds.clear
            },
            onClickCalendarDay: {
                configurable: !0,
                value: this.binds.onClickCalendarDay
            },
            onClickApplyButton: {
                configurable: !0,
                value: this.binds.onClickApplyButton
            }
        }), this.options.elementEnd && (this.options.elementEnd instanceof HTMLElement || (this.options.elementEnd = this.picker.options.doc.querySelector(this.options.elementEnd)), this.options.elementEnd instanceof HTMLInputElement && (this.options.elementEnd.readOnly = this.picker.options.readonly), "function" == typeof this.picker.options.documentClick && (document.removeEventListener("click", this.picker.options.documentClick, !0), "function" == typeof this.options.documentClick && document.addEventListener("click", this.options.documentClick, !0)), this.options.elementEnd.addEventListener("click", this.picker.show.bind(this.picker))), this.options.repick = this.options.repick && this.options.elementEnd instanceof HTMLElement, this.picker.options.date = null, this.picker.on("view", this.binds.onView), this.picker.on("show", this.binds.onShow), this.picker.on("mouseenter", this.binds.onMouseEnter, !0), this.picker.on("mouseleave", this.binds.onMouseLeave, !0), this.checkIntlPluralLocales();
    }
    onDetach() {
        Object.defineProperties(this.picker, {
            setStartDate: {
                configurable: !0,
                value: this.binds._setStartDate
            },
            setEndDate: {
                configurable: !0,
                value: this.binds._setEndDate
            },
            setDateRange: {
                configurable: !0,
                value: this.binds._setDateRange
            },
            getStartDate: {
                configurable: !0,
                value: this.binds._getStartDate
            },
            getEndDate: {
                configurable: !0,
                value: this.binds._getEndDate
            },
            parseValues: {
                configurable: !0,
                value: this.binds._parseValues
            },
            updateValues: {
                configurable: !0,
                value: this.binds._updateValues
            },
            clear: {
                configurable: !0,
                value: this.binds._clear
            },
            onClickCalendarDay: {
                configurable: !0,
                value: this.binds._onClickCalendarDay
            },
            onClickApplyButton: {
                configurable: !0,
                value: this.binds._onClickApplyButton
            }
        }), this.picker.off("view", this.binds.onView), this.picker.off("show", this.binds.onShow), this.picker.off("mouseenter", this.binds.onMouseEnter, !0), this.picker.off("mouseleave", this.binds.onMouseLeave, !0);
    }
    parseValues() {
        if (this.options.startDate || this.options.endDate) this.options.strict ? this.options.startDate && this.options.endDate ? this.setDateRange(this.options.startDate, this.options.endDate) : (this.options.startDate = null, this.options.endDate = null) : (this.options.startDate && this.setStartDate(this.options.startDate), this.options.endDate && this.setEndDate(this.options.endDate));
        else if (this.options.elementEnd) this.options.strict ? this.picker.options.element instanceof HTMLInputElement && this.picker.options.element.value.length && this.options.elementEnd instanceof HTMLInputElement && this.options.elementEnd.value.length && this.setDateRange(this.picker.options.element.value, this.options.elementEnd.value) : (this.picker.options.element instanceof HTMLInputElement && this.picker.options.element.value.length && this.setStartDate(this.picker.options.element.value), this.options.elementEnd instanceof HTMLInputElement && this.options.elementEnd.value.length && this.setEndDate(this.options.elementEnd.value));
        else if (this.picker.options.element instanceof HTMLInputElement && this.picker.options.element.value.length) {
            const [t, e] = this.picker.options.element.value.split(this.options.delimiter);
            this.options.strict ? t && e && this.setDateRange(t, e) : (t && this.setStartDate(t), e && this.setEndDate(e));
        }
    }
    updateValues() {
        const t = this.picker.options.element, e = this.options.elementEnd, i = this.picker.getStartDate(), n = this.picker.getEndDate(), s = i instanceof Date ? i.format(this.picker.options.format, this.picker.options.lang) : "", o = n instanceof Date ? n.format(this.picker.options.format, this.picker.options.lang) : "";
        if (e) t instanceof HTMLInputElement ? t.value = s : t instanceof HTMLElement && (t.innerText = s), e instanceof HTMLInputElement ? e.value = o : e instanceof HTMLElement && (e.innerText = o);
        else {
            const e = `${s}${s || o ? this.options.delimiter : ""}${o}`;
            t instanceof HTMLInputElement ? t.value = e : t instanceof HTMLElement && (t.innerText = e);
        }
    }
    clear() {
        this.options.startDate = null, this.options.endDate = null, this.picker.datePicked.length = 0, this.updateValues(), this.picker.renderAll(), this.picker.trigger("clear");
    }
    onShow(t) {
        const { target: e } = t.detail;
        this.triggerElement = e, this.picker.options.scrollToDate && this.getStartDate() instanceof Date && this.picker.gotoDate(this.getStartDate()), this.initializeRepick();
    }
    onView(e) {
        const { view: i, target: n } = e.detail;
        if ("Main" === i && (this.tooltipElement = document.createElement("span"), this.tooltipElement.className = "range-plugin-tooltip", n.appendChild(this.tooltipElement)), "CalendarDay" === i) {
            const e = new $252a7d750dfe5974$export$82f9ebd9adeba146(n.dataset.time), i = this.picker.datePicked, s = i.length ? this.picker.datePicked[0] : this.getStartDate(), o = i.length ? this.picker.datePicked[1] : this.getEndDate();
            s && s.isSame(e, "day") && n.classList.add("start"), s && o && (o.isSame(e, "day") && n.classList.add("end"), e.isBetween(s, o) && n.classList.add("in-range"));
        }
        if ("Footer" === i) {
            const t = 1 === this.picker.datePicked.length && !this.options.strict || 2 === this.picker.datePicked.length;
            n.querySelector(".apply-button").disabled = !t;
        }
    }
    hidePicker(t) {
        let e = t.target, i = null;
        e.shadowRoot && (e = t.composedPath()[0], i = e.getRootNode().host), this.picker.isShown() && i !== this.picker.ui.wrapper && e !== this.picker.options.element && e !== this.options.elementEnd && this.picker.hide();
    }
    setStartDate(e) {
        const i = new $252a7d750dfe5974$export$82f9ebd9adeba146(e, this.picker.options.format);
        this.options.startDate = i ? i.clone() : null, this.updateValues(), this.picker.renderAll();
    }
    setEndDate(e) {
        const i = new $252a7d750dfe5974$export$82f9ebd9adeba146(e, this.picker.options.format);
        this.options.endDate = i ? i.clone() : null, this.updateValues(), this.picker.renderAll();
    }
    setDateRange(e, i) {
        const n = new $252a7d750dfe5974$export$82f9ebd9adeba146(e, this.picker.options.format), s = new $252a7d750dfe5974$export$82f9ebd9adeba146(i, this.picker.options.format);
        this.options.startDate = n ? n.clone() : null, this.options.endDate = s ? s.clone() : null, this.updateValues(), this.picker.renderAll();
    }
    getStartDate() {
        return this.options.startDate instanceof Date ? this.options.startDate.clone() : null;
    }
    getEndDate() {
        return this.options.endDate instanceof Date ? this.options.endDate.clone() : null;
    }
    onMouseEnter(e) {
        const i = e.target;
        if (i instanceof HTMLElement) {
            this.isContainer(i) && this.initializeRepick();
            const e = i.closest(".unit");
            if (!(e instanceof HTMLElement)) return;
            if (this.picker.isCalendarDay(e)) {
                if (1 !== this.picker.datePicked.length) return;
                let i = this.picker.datePicked[0].clone(), n = new $252a7d750dfe5974$export$82f9ebd9adeba146(e.dataset.time), s = !1;
                if (i.isAfter(n, "day")) {
                    const t = i.clone();
                    i = n.clone(), n = t.clone(), s = !0;
                }
                if ([
                    ...this.picker.ui.container.querySelectorAll(".day")
                ].forEach((o)=>{
                    const a = new $252a7d750dfe5974$export$82f9ebd9adeba146(o.dataset.time), r = this.picker.Calendar.getCalendarDayView(a);
                    a.isBetween(i, n) && r.classList.add("in-range"), a.isSame(this.picker.datePicked[0], "day") && (r.classList.add("start"), r.classList.toggle("flipped", s)), o === e && (r.classList.add("end"), r.classList.toggle("flipped", s)), o.className = r.className;
                }), this.options.tooltip) {
                    const t = this.options.tooltipNumber(n.diff(i, "day") + 1);
                    if (t > 0) {
                        const i = new Intl.PluralRules(this.picker.options.lang).select(t), n = `${t} ${this.options.locale[i]}`;
                        this.showTooltip(e, n);
                    } else this.hideTooltip();
                }
            }
        }
    }
    onMouseLeave(t) {
        if (this.isContainer(t.target) && this.options.repick) {
            const t = this.getStartDate(), e = this.getEndDate();
            t && e && (this.picker.datePicked.length = 0, this.picker.renderAll());
        }
    }
    onClickCalendarDay(e) {
        if (this.picker.isCalendarDay(e)) {
            2 === this.picker.datePicked.length && (this.picker.datePicked.length = 0);
            const i = new $252a7d750dfe5974$export$82f9ebd9adeba146(e.dataset.time);
            if (this.picker.datePicked[this.picker.datePicked.length] = i, 2 === this.picker.datePicked.length && this.picker.datePicked[0].isAfter(this.picker.datePicked[1])) {
                const t = this.picker.datePicked[1].clone();
                this.picker.datePicked[1] = this.picker.datePicked[0].clone(), this.picker.datePicked[0] = t.clone();
            }
            1 !== this.picker.datePicked.length && this.picker.options.autoApply || this.picker.trigger("preselect", {
                start: this.picker.datePicked[0] instanceof Date ? this.picker.datePicked[0].clone() : null,
                end: this.picker.datePicked[1] instanceof Date ? this.picker.datePicked[1].clone() : null
            }), 1 === this.picker.datePicked.length && (!this.options.strict && this.picker.options.autoApply && (this.picker.options.element === this.triggerElement && this.setStartDate(this.picker.datePicked[0]), this.options.elementEnd === this.triggerElement && this.setEndDate(this.picker.datePicked[0]), this.picker.trigger("select", {
                start: this.picker.getStartDate(),
                end: this.picker.getEndDate()
            })), this.picker.renderAll()), 2 === this.picker.datePicked.length && (this.picker.options.autoApply ? (this.setDateRange(this.picker.datePicked[0], this.picker.datePicked[1]), this.picker.trigger("select", {
                start: this.picker.getStartDate(),
                end: this.picker.getEndDate()
            }), this.picker.hide()) : (this.hideTooltip(), this.picker.renderAll()));
        }
    }
    onClickApplyButton(t) {
        this.picker.isApplyButton(t) && (1 !== this.picker.datePicked.length || this.options.strict || (this.picker.options.element === this.triggerElement && (this.options.endDate = null, this.setStartDate(this.picker.datePicked[0])), this.options.elementEnd === this.triggerElement && (this.options.startDate = null, this.setEndDate(this.picker.datePicked[0]))), 2 === this.picker.datePicked.length && this.setDateRange(this.picker.datePicked[0], this.picker.datePicked[1]), this.picker.trigger("select", {
            start: this.picker.getStartDate(),
            end: this.picker.getEndDate()
        }), this.picker.hide());
    }
    showTooltip(t, e) {
        this.tooltipElement.style.visibility = "visible", this.tooltipElement.innerHTML = e;
        const i = this.picker.ui.container.getBoundingClientRect(), n = this.tooltipElement.getBoundingClientRect(), s = t.getBoundingClientRect();
        let o = s.top, a = s.left;
        o -= i.top, a -= i.left, o -= n.height, a -= n.width / 2, a += s.width / 2, this.tooltipElement.style.top = `${o}px`, this.tooltipElement.style.left = `${a}px`;
    }
    hideTooltip() {
        this.tooltipElement.style.visibility = "hidden";
    }
    checkIntlPluralLocales() {
        if (!this.options.tooltip) return;
        const t = [
            ...new Set([
                new Intl.PluralRules(this.picker.options.lang).select(0),
                new Intl.PluralRules(this.picker.options.lang).select(1),
                new Intl.PluralRules(this.picker.options.lang).select(2),
                new Intl.PluralRules(this.picker.options.lang).select(6),
                new Intl.PluralRules(this.picker.options.lang).select(18)
            ])
        ], e = Object.keys(this.options.locale);
        t.every((t)=>e.includes(t)) || console.warn(`${this.getName()}: provide locales (${t.join(", ")}) for correct tooltip text.`);
    }
    initializeRepick() {
        if (!this.options.repick) return;
        const t = this.getStartDate(), e = this.getEndDate();
        e && this.triggerElement === this.picker.options.element && (this.picker.datePicked[0] = e), t && this.triggerElement === this.options.elementEnd && (this.picker.datePicked[0] = t);
    }
    isContainer(t) {
        return t === this.picker.ui.container;
    }
}
class $252a7d750dfe5974$export$bc2c7766e90501b6 extends $252a7d750dfe5974$var$o {
    options = {
        native: !1,
        seconds: !1,
        stepHours: 1,
        stepMinutes: 5,
        stepSeconds: 5,
        format12: !1
    };
    rangePlugin;
    timePicked = {
        input: null,
        start: null,
        end: null
    };
    timePrePicked = {
        input: null,
        start: null,
        end: null
    };
    binds = {
        getDate: this.getDate.bind(this),
        getStartDate: this.getStartDate.bind(this),
        getEndDate: this.getEndDate.bind(this),
        onView: this.onView.bind(this),
        onInput: this.onInput.bind(this),
        onChange: this.onChange.bind(this),
        onClick: this.onClick.bind(this),
        setTime: this.setTime.bind(this),
        setStartTime: this.setStartTime.bind(this),
        setEndTime: this.setEndTime.bind(this)
    };
    getName() {
        return "TimePlugin";
    }
    onAttach() {
        this.binds._getDate = this.picker.getDate, this.binds._getStartDate = this.picker.getStartDate, this.binds._getEndDate = this.picker.getEndDate, Object.defineProperties(this.picker, {
            getDate: {
                configurable: !0,
                value: this.binds.getDate
            },
            getStartDate: {
                configurable: !0,
                value: this.binds.getStartDate
            },
            getEndDate: {
                configurable: !0,
                value: this.binds.getEndDate
            },
            setTime: {
                configurable: !0,
                value: this.binds.setTime
            },
            setStartTime: {
                configurable: !0,
                value: this.binds.setStartTime
            },
            setEndTime: {
                configurable: !0,
                value: this.binds.setEndTime
            }
        }), this.rangePlugin = this.picker.PluginManager.getInstance("RangePlugin"), this.parseValues(), this.picker.on("view", this.binds.onView), this.picker.on("input", this.binds.onInput), this.picker.on("change", this.binds.onChange), this.picker.on("click", this.binds.onClick);
    }
    onDetach() {
        delete this.picker.setTime, delete this.picker.setStartTime, delete this.picker.setEndTime, Object.defineProperties(this.picker, {
            getDate: {
                configurable: !0,
                value: this.binds._getDate
            },
            getStartDate: {
                configurable: !0,
                value: this.binds._getStartDate
            },
            getEndDate: {
                configurable: !0,
                value: this.binds._getEndDate
            }
        }), this.picker.off("view", this.binds.onView), this.picker.off("input", this.binds.onInput), this.picker.off("change", this.binds.onChange), this.picker.off("click", this.binds.onClick);
    }
    onView(t) {
        const { view: e, target: i } = t.detail;
        if ("Main" === e) {
            this.rangePlugin = this.picker.PluginManager.getInstance("RangePlugin");
            const t = document.createElement("div");
            if (t.className = "time-plugin-container", this.rangePlugin) {
                const e = this.getStartInput();
                t.appendChild(e), this.picker.trigger("view", {
                    view: "TimePluginInput",
                    target: e
                });
                const i = this.getEndInput();
                t.appendChild(i), this.picker.trigger("view", {
                    view: "TimePluginInput",
                    target: i
                });
            } else {
                const e = this.getSingleInput();
                t.appendChild(e), this.picker.trigger("view", {
                    view: "TimePluginInput",
                    target: e
                });
            }
            i.appendChild(t), this.picker.trigger("view", {
                view: "TimePluginContainer",
                target: t
            });
        }
    }
    onInput(e) {
        const i = e.target;
        if (i instanceof HTMLInputElement && i.classList.contains("time-plugin-input")) {
            const e = this.timePicked[i.name] || new $252a7d750dfe5974$export$82f9ebd9adeba146, [n, s] = i.value.split(":");
            e.setHours(Number(n) || 0, Number(s) || 0, 0, 0), this.picker.options.autoApply ? (this.timePicked[i.name] = e, this.picker.updateValues()) : this.timePrePicked[i.name] = e;
        }
    }
    onChange(e) {
        const i = e.target;
        if (i instanceof HTMLSelectElement && i.classList.contains("time-plugin-custom-input")) {
            const e = /(\w+)\[(\w+)\]/, [, n, s] = i.name.match(e), o = Number(i.value);
            let a = new $252a7d750dfe5974$export$82f9ebd9adeba146;
            switch(!this.picker.options.autoApply && this.timePrePicked[n] instanceof Date ? a = this.timePrePicked[n].clone() : this.timePicked[n] instanceof Date && (a = this.timePicked[n].clone()), s){
                case "HH":
                    if (this.options.format12) {
                        const t = i.closest(".time-plugin-custom-block").querySelector(`select[name="${n}[period]"]`).value, e = this.handleFormat12(t, a, o);
                        a.setHours(e.getHours(), e.getMinutes(), e.getSeconds(), 0);
                    } else a.setHours(o, a.getMinutes(), a.getSeconds(), 0);
                    break;
                case "mm":
                    a.setHours(a.getHours(), o, a.getSeconds(), 0);
                    break;
                case "ss":
                    a.setHours(a.getHours(), a.getMinutes(), o, 0);
                    break;
                case "period":
                    if (this.options.format12) {
                        const t = i.closest(".time-plugin-custom-block").querySelector(`select[name="${n}[HH]"]`).value, e = this.handleFormat12(i.value, a, Number(t));
                        a.setHours(e.getHours(), e.getMinutes(), e.getSeconds(), 0);
                    }
            }
            if (this.picker.options.autoApply) this.timePicked[n] = a, this.picker.updateValues();
            else {
                this.timePrePicked[n] = a;
                const t = this.picker.ui.container.querySelector(".apply-button");
                if (this.rangePlugin) {
                    const e = this.rangePlugin.options, i = this.picker.datePicked, n = e.strict && 2 === i.length || !e.strict && i.length > 0 || !i.length && e.strict && e.startDate instanceof Date && e.endDate instanceof Date || !i.length && !e.strict && (e.startDate instanceof Date || e.endDate instanceof Date);
                    t.disabled = !n;
                } else this.picker.datePicked.length && (t.disabled = !1);
            }
        }
    }
    onClick(t) {
        const e = t.target;
        if (e instanceof HTMLElement) {
            const t = e.closest(".unit");
            if (!(t instanceof HTMLElement)) return;
            this.picker.isApplyButton(t) && (Object.keys(this.timePicked).forEach((t)=>{
                this.timePrePicked[t] instanceof Date && (this.timePicked[t] = this.timePrePicked[t].clone());
            }), this.picker.updateValues(), this.timePrePicked = {
                input: null,
                start: null,
                end: null
            }), this.picker.isCancelButton(t) && (this.timePrePicked = {
                input: null,
                start: null,
                end: null
            }, this.picker.renderAll());
        }
    }
    setTime(t) {
        const e = this.handleTimeString(t);
        this.timePicked.input = e.clone(), this.picker.renderAll(), this.picker.updateValues();
    }
    setStartTime(t) {
        const e = this.handleTimeString(t);
        this.timePicked.start = e.clone(), this.picker.renderAll(), this.picker.updateValues();
    }
    setEndTime(t) {
        const e = this.handleTimeString(t);
        this.timePicked.end = e.clone(), this.picker.renderAll(), this.picker.updateValues();
    }
    handleTimeString(e) {
        const i = new $252a7d750dfe5974$export$82f9ebd9adeba146, [n, s, o] = e.split(":").map((t)=>Number(t)), a = n && !Number.isNaN(n) ? n : 0, r = s && !Number.isNaN(s) ? s : 0, c = o && !Number.isNaN(o) ? o : 0;
        return i.setHours(a, r, c, 0), i;
    }
    getDate() {
        if (this.picker.options.date instanceof Date) {
            const e = new $252a7d750dfe5974$export$82f9ebd9adeba146(this.picker.options.date, this.picker.options.format);
            if (this.timePicked.input instanceof Date) {
                const t = this.timePicked.input;
                e.setHours(t.getHours(), t.getMinutes(), t.getSeconds(), 0);
            }
            return e;
        }
        return null;
    }
    getStartDate() {
        if (this.rangePlugin.options.startDate instanceof Date) {
            const e = new $252a7d750dfe5974$export$82f9ebd9adeba146(this.rangePlugin.options.startDate, this.picker.options.format);
            if (this.timePicked.start instanceof Date) {
                const t = this.timePicked.start;
                e.setHours(t.getHours(), t.getMinutes(), t.getSeconds(), 0);
            }
            return e;
        }
        return null;
    }
    getEndDate() {
        if (this.rangePlugin.options.endDate instanceof Date) {
            const e = new $252a7d750dfe5974$export$82f9ebd9adeba146(this.rangePlugin.options.endDate, this.picker.options.format);
            if (this.timePicked.end instanceof Date) {
                const t = this.timePicked.end;
                e.setHours(t.getHours(), t.getMinutes(), t.getSeconds(), 0);
            }
            return e;
        }
        return null;
    }
    getSingleInput() {
        return this.options.native ? this.getNativeInput("input") : this.getCustomInput("input");
    }
    getStartInput() {
        return this.options.native ? this.getNativeInput("start") : this.getCustomInput("start");
    }
    getEndInput() {
        return this.options.native ? this.getNativeInput("end") : this.getCustomInput("end");
    }
    getNativeInput(t) {
        const e = document.createElement("input");
        e.type = "time", e.name = t, e.className = "time-plugin-input unit";
        const i = this.timePicked[t];
        if (i) {
            const t = `0${i.getHours()}`.slice(-2), n = `0${i.getMinutes()}`.slice(-2);
            e.value = `${t}:${n}`;
        }
        return e;
    }
    getCustomInput(t) {
        const e = document.createElement("div");
        e.className = "time-plugin-custom-block";
        const i = document.createElement("select");
        i.className = "time-plugin-custom-input unit", i.name = `${t}[HH]`;
        const n = this.options.format12 ? 1 : 0, s = this.options.format12 ? 13 : 24;
        let o = null;
        !this.picker.options.autoApply && this.timePrePicked[t] instanceof Date ? o = this.timePrePicked[t].clone() : this.timePicked[t] instanceof Date && (o = this.timePicked[t].clone());
        for(let t = n; t < s; t += this.options.stepHours){
            const e = document.createElement("option");
            e.value = String(t), e.text = String(t), o && (this.options.format12 ? (o.getHours() % 12 ? o.getHours() % 12 : 12) === t && (e.selected = !0) : o.getHours() === t && (e.selected = !0)), i.appendChild(e);
        }
        e.appendChild(i);
        const a = document.createElement("select");
        a.className = "time-plugin-custom-input unit", a.name = `${t}[mm]`;
        for(let t = 0; t < 60; t += this.options.stepMinutes){
            const e = document.createElement("option");
            e.value = `0${String(t)}`.slice(-2), e.text = `0${String(t)}`.slice(-2), o && o.getMinutes() === t && (e.selected = !0), a.appendChild(e);
        }
        if (e.appendChild(a), this.options.seconds) {
            const i = document.createElement("select");
            i.className = "time-plugin-custom-input unit", i.name = `${t}[ss]`;
            const n = 60;
            for(let t = 0; t < n; t += this.options.stepSeconds){
                const e = document.createElement("option");
                e.value = `0${String(t)}`.slice(-2), e.text = `0${String(t)}`.slice(-2), o && o.getSeconds() === t && (e.selected = !0), i.appendChild(e);
            }
            e.appendChild(i);
        }
        if (this.options.format12) {
            const i = document.createElement("select");
            i.className = "time-plugin-custom-input unit", i.name = `${t}[period]`, [
                "AM",
                "PM"
            ].forEach((t)=>{
                const e = document.createElement("option");
                e.value = t, e.text = t, o && "PM" === t && o.getHours() >= 12 && (e.selected = !0), i.appendChild(e);
            }), e.appendChild(i);
        }
        return e;
    }
    handleFormat12(t, e, i) {
        const n = e.clone();
        switch(t){
            case "AM":
                12 === i ? n.setHours(0, n.getMinutes(), n.getSeconds(), 0) : n.setHours(i, n.getMinutes(), n.getSeconds(), 0);
                break;
            case "PM":
                12 !== i ? n.setHours(i + 12, n.getMinutes(), n.getSeconds(), 0) : n.setHours(i, n.getMinutes(), n.getSeconds(), 0);
        }
        return n;
    }
    parseValues() {
        if (this.rangePlugin) {
            if (this.rangePlugin.options.strict) {
                if (this.rangePlugin.options.startDate && this.rangePlugin.options.endDate) {
                    const e = new $252a7d750dfe5974$export$82f9ebd9adeba146(this.rangePlugin.options.startDate, this.picker.options.format), i = new $252a7d750dfe5974$export$82f9ebd9adeba146(this.rangePlugin.options.endDate, this.picker.options.format);
                    this.timePicked.start = e.clone(), this.timePicked.end = i.clone();
                }
            } else {
                if (this.rangePlugin.options.startDate) {
                    const e = new $252a7d750dfe5974$export$82f9ebd9adeba146(this.rangePlugin.options.startDate, this.picker.options.format);
                    this.timePicked.start = e.clone();
                }
                if (this.rangePlugin.options.endDate) {
                    const e = new $252a7d750dfe5974$export$82f9ebd9adeba146(this.rangePlugin.options.endDate, this.picker.options.format);
                    this.timePicked.end = e.clone();
                }
            }
            if (this.rangePlugin.options.elementEnd) {
                if (this.rangePlugin.options.strict) {
                    if (this.picker.options.element instanceof HTMLInputElement && this.picker.options.element.value.length && this.rangePlugin.options.elementEnd instanceof HTMLInputElement && this.rangePlugin.options.elementEnd.value.length) {
                        const e = new $252a7d750dfe5974$export$82f9ebd9adeba146(this.picker.options.element.value, this.picker.options.format), i = new $252a7d750dfe5974$export$82f9ebd9adeba146(this.rangePlugin.options.elementEnd.value, this.picker.options.format);
                        this.timePicked.start = e.clone(), this.timePicked.end = i.clone();
                    }
                } else {
                    if (this.picker.options.element instanceof HTMLInputElement && this.picker.options.element.value.length) {
                        const e = new $252a7d750dfe5974$export$82f9ebd9adeba146(this.picker.options.element.value, this.picker.options.format);
                        this.timePicked.start = e.clone();
                    }
                    if (this.rangePlugin.options.elementEnd instanceof HTMLInputElement && this.rangePlugin.options.elementEnd.value.length) {
                        const e = new $252a7d750dfe5974$export$82f9ebd9adeba146(this.rangePlugin.options.elementEnd.value, this.picker.options.format);
                        this.timePicked.start = e.clone();
                    }
                }
            } else if (this.picker.options.element instanceof HTMLInputElement && this.picker.options.element.value.length) {
                const [e, i] = this.picker.options.element.value.split(this.rangePlugin.options.delimiter);
                if (this.rangePlugin.options.strict) {
                    if (e && i) {
                        const n = new $252a7d750dfe5974$export$82f9ebd9adeba146(e, this.picker.options.format), s = new $252a7d750dfe5974$export$82f9ebd9adeba146(i, this.picker.options.format);
                        this.timePicked.start = n.clone(), this.timePicked.end = s.clone();
                    }
                } else {
                    if (e) {
                        const i = new $252a7d750dfe5974$export$82f9ebd9adeba146(e, this.picker.options.format);
                        this.timePicked.start = i.clone();
                    }
                    if (i) {
                        const e = new $252a7d750dfe5974$export$82f9ebd9adeba146(i, this.picker.options.format);
                        this.timePicked.start = e.clone();
                    }
                }
            }
        } else {
            if (this.picker.options.date) {
                const e = new $252a7d750dfe5974$export$82f9ebd9adeba146(this.picker.options.date, this.picker.options.format);
                this.timePicked.input = e.clone();
            }
            if (this.picker.options.element instanceof HTMLInputElement && this.picker.options.element.value.length) {
                const e = new $252a7d750dfe5974$export$82f9ebd9adeba146(this.picker.options.element.value, this.picker.options.format);
                this.timePicked.input = e.clone();
            }
        }
    }
}
class $252a7d750dfe5974$export$eff88f8158d3110a extends $252a7d750dfe5974$var$o {
    docElement = null;
    rangePlugin;
    binds = {
        onView: this.onView.bind(this),
        onKeydown: this.onKeydown.bind(this)
    };
    options = {
        unitIndex: 1,
        dayIndex: 2
    };
    getName() {
        return "KbdPlugin";
    }
    onAttach() {
        const t = this.picker.options.element, e = t.getBoundingClientRect();
        if (this.docElement = document.createElement("span"), this.docElement.style.position = "absolute", this.docElement.style.top = `${t.offsetTop}px`, this.docElement.style.left = t.offsetLeft + e.width - 25 + "px", this.docElement.attachShadow({
            mode: "open"
        }), this.options.html) this.docElement.shadowRoot.innerHTML = this.options.html;
        else {
            const t = `\n      <style>\n      button {\n        border: none;\n        background: transparent;\n        font-size: ${window.getComputedStyle(this.picker.options.element).fontSize};\n      }\n      </style>\n\n      <button>&#128197;</button>\n      `;
            this.docElement.shadowRoot.innerHTML = t;
        }
        const i = this.docElement.shadowRoot.querySelector("button");
        i && (i.addEventListener("click", (t)=>{
            t.preventDefault(), this.picker.show({
                target: this.picker.options.element
            });
        }, {
            capture: !0
        }), i.addEventListener("keydown", (t)=>{
            "Escape" === t.code && this.picker.hide();
        }, {
            capture: !0
        })), this.picker.options.element.after(this.docElement), this.picker.on("view", this.binds.onView), this.picker.on("keydown", this.binds.onKeydown);
    }
    onDetach() {
        this.docElement && this.docElement.isConnected && this.docElement.remove(), this.picker.off("view", this.binds.onView), this.picker.off("keydown", this.binds.onKeydown);
    }
    onView(t) {
        const { view: e, target: i } = t.detail;
        i && "querySelector" in i && ("CalendarDay" !== e || [
            "locked",
            "not-available"
        ].some((t)=>i.classList.contains(t)) ? [
            ...i.querySelectorAll(".unit:not(.day)")
        ].forEach((t)=>t.tabIndex = this.options.unitIndex) : i.tabIndex = this.options.dayIndex);
    }
    onKeydown(t) {
        switch(this.onMouseEnter(t), t.code){
            case "ArrowUp":
            case "ArrowDown":
                this.verticalMove(t);
                break;
            case "ArrowLeft":
            case "ArrowRight":
                this.horizontalMove(t);
                break;
            case "Enter":
            case "Space":
                this.handleEnter(t);
                break;
            case "Escape":
                this.picker.hide();
        }
    }
    findAllowableDaySibling(t, e, i) {
        const n = Array.from(t.querySelectorAll(`.day[tabindex="${this.options.dayIndex}"]`)), s = n.indexOf(e);
        return n.filter((t, e)=>i(e, s) && t.tabIndex === this.options.dayIndex)[0];
    }
    changeMonth(t) {
        const e = {
            ArrowLeft: "previous",
            ArrowRight: "next"
        }, i = this.picker.ui.container.querySelector(`.${e[t.code]}-button[tabindex="${this.options.unitIndex}"]`);
        i && !i.parentElement.classList.contains(`no-${e[t.code]}-month`) && (i.dispatchEvent(new Event("click", {
            bubbles: !0
        })), setTimeout(()=>{
            let e = null;
            switch(t.code){
                case "ArrowLeft":
                    const t1 = this.picker.ui.container.querySelectorAll(`.day[tabindex="${this.options.dayIndex}"]`);
                    e = t1[t1.length - 1];
                    break;
                case "ArrowRight":
                    e = this.picker.ui.container.querySelector(`.day[tabindex="${this.options.dayIndex}"]`);
            }
            e && e.focus();
        }));
    }
    verticalMove(t) {
        const e = t.target;
        if (e.classList.contains("day")) {
            t.preventDefault();
            const i = this.findAllowableDaySibling(this.picker.ui.container, e, (e, i)=>e === ("ArrowUp" === t.code ? i - 7 : i + 7));
            i && i.focus();
        }
    }
    horizontalMove(t) {
        const e = t.target;
        if (e.classList.contains("day")) {
            t.preventDefault();
            const i = this.findAllowableDaySibling(this.picker.ui.container, e, (e, i)=>e === ("ArrowLeft" === t.code ? i - 1 : i + 1));
            i ? i.focus() : this.changeMonth(t);
        }
    }
    handleEnter(t) {
        const e = t.target;
        e.classList.contains("day") && (t.preventDefault(), e.dispatchEvent(new Event("click", {
            bubbles: !0
        })), setTimeout(()=>{
            if (this.rangePlugin = this.picker.PluginManager.getInstance("RangePlugin"), this.rangePlugin || !this.picker.options.autoApply) {
                const t = this.picker.ui.container.querySelector(".day.selected");
                t && setTimeout(()=>{
                    t.focus();
                });
            }
        }));
    }
    onMouseEnter(t) {
        t.target.classList.contains("day") && setTimeout(()=>{
            const t = this.picker.ui.shadowRoot.activeElement;
            t && t.dispatchEvent(new Event("mouseenter", {
                bubbles: !0
            }));
        });
    }
}
class $252a7d750dfe5974$export$57493a0dd8e3e25f extends $252a7d750dfe5974$var$o {
    rangePlugin;
    lockPlugin;
    priority = 10;
    binds = {
        onView: this.onView.bind(this),
        onColorScheme: this.onColorScheme.bind(this)
    };
    options = {
        dropdown: {
            months: !1,
            years: !1,
            minYear: 1950,
            maxYear: null
        },
        darkMode: !0,
        locale: {
            resetButton: '<svg xmlns="http://www.w3.org/2000/svg" height="24" width="24"><path d="M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"/></svg>'
        }
    };
    matchMedia;
    getName() {
        return "AmpPlugin";
    }
    onAttach() {
        this.options.darkMode && window && "matchMedia" in window && (this.matchMedia = window.matchMedia("(prefers-color-scheme: dark)"), this.matchMedia.matches && (this.picker.ui.container.dataset.theme = "dark"), this.matchMedia.addEventListener("change", this.binds.onColorScheme)), this.options.weekNumbers && this.picker.ui.container.classList.add("week-numbers"), this.picker.on("view", this.binds.onView);
    }
    onDetach() {
        this.options.darkMode && window && "matchMedia" in window && this.matchMedia.removeEventListener("change", this.binds.onColorScheme), this.picker.ui.container.removeAttribute("data-theme"), this.picker.ui.container.classList.remove("week-numbers"), this.picker.off("view", this.binds.onView);
    }
    onView(t) {
        this.lockPlugin = this.picker.PluginManager.getInstance("LockPlugin"), this.rangePlugin = this.picker.PluginManager.getInstance("RangePlugin"), this.handleDropdown(t), this.handleResetButton(t), this.handleWeekNumbers(t);
    }
    onColorScheme(t) {
        const e = t.matches ? "dark" : "light";
        this.picker.ui.container.dataset.theme = e;
    }
    handleDropdown(e) {
        const { view: i, target: n, date: s, index: o } = e.detail;
        if ("CalendarHeader" === i) {
            const e = n.querySelector(".month-name");
            if (this.options.dropdown.months) {
                e.childNodes[0].remove();
                const i = document.createElement("select");
                i.className = "month-name--select month-name--dropdown";
                for(let e = 0; e < 12; e += 1){
                    const n = document.createElement("option"), o = new $252a7d750dfe5974$export$82f9ebd9adeba146(new Date(s.getFullYear(), e, 2, 0, 0, 0)), a = new $252a7d750dfe5974$export$82f9ebd9adeba146(new Date(s.getFullYear(), e, 1, 0, 0, 0));
                    n.value = String(e), n.text = o.toLocaleString(this.picker.options.lang, {
                        month: "long"
                    }), this.lockPlugin && (n.disabled = this.lockPlugin.options.minDate && a.isBefore(new $252a7d750dfe5974$export$82f9ebd9adeba146(this.lockPlugin.options.minDate), "month") || this.lockPlugin.options.maxDate && a.isAfter(new $252a7d750dfe5974$export$82f9ebd9adeba146(this.lockPlugin.options.maxDate), "month")), n.selected = a.getMonth() === s.getMonth(), i.appendChild(n);
                }
                i.addEventListener("change", (t)=>{
                    const e = t.target;
                    this.picker.calendars[0].setDate(1), this.picker.calendars[0].setMonth(Number(e.value)), this.picker.renderAll();
                }), e.prepend(i);
            }
            if (this.options.dropdown.years) {
                e.childNodes[1].remove();
                const i = document.createElement("select");
                i.className = "month-name--select";
                const n = this.options.dropdown.minYear, o = this.options.dropdown.maxYear ? this.options.dropdown.maxYear : (new Date).getFullYear();
                if (s.getFullYear() > o) {
                    const t = document.createElement("option");
                    t.value = String(s.getFullYear()), t.text = String(s.getFullYear()), t.selected = !0, t.disabled = !0, i.appendChild(t);
                }
                for(let e = o; e >= n; e -= 1){
                    const n = document.createElement("option"), o = new $252a7d750dfe5974$export$82f9ebd9adeba146(new Date(e, 0, 1, 0, 0, 0));
                    n.value = String(e), n.text = String(e), this.lockPlugin && (n.disabled = this.lockPlugin.options.minDate && o.isBefore(new $252a7d750dfe5974$export$82f9ebd9adeba146(this.lockPlugin.options.minDate), "year") || this.lockPlugin.options.maxDate && o.isAfter(new $252a7d750dfe5974$export$82f9ebd9adeba146(this.lockPlugin.options.maxDate), "year")), n.selected = s.getFullYear() === e, i.appendChild(n);
                }
                if (s.getFullYear() < n) {
                    const t = document.createElement("option");
                    t.value = String(s.getFullYear()), t.text = String(s.getFullYear()), t.selected = !0, t.disabled = !0, i.appendChild(t);
                }
                if ("asc" === this.options.dropdown.years) {
                    const t = Array.prototype.slice.call(i.childNodes).reverse();
                    i.innerHTML = "", t.forEach((t)=>{
                        t.innerHTML = t.value, i.appendChild(t);
                    });
                }
                i.addEventListener("change", (t)=>{
                    const e = t.target;
                    this.picker.calendars[0].setFullYear(Number(e.value)), this.picker.renderAll();
                }), e.appendChild(i);
            }
        }
    }
    handleResetButton(t) {
        const { view: e, target: i } = t.detail;
        if ("CalendarHeader" === e && this.options.resetButton) {
            const t = document.createElement("button");
            t.className = "reset-button unit", t.innerHTML = this.options.locale.resetButton, t.addEventListener("click", (t)=>{
                t.preventDefault();
                let e = !0;
                "function" == typeof this.options.resetButton && (e = this.options.resetButton.call(this)), e && this.picker.clear();
            }), i.appendChild(t);
        }
    }
    handleWeekNumbers(e) {
        if (this.options.weekNumbers) {
            const { view: i, target: n } = e.detail;
            if ("CalendarDayNames" === i) {
                const t = document.createElement("div");
                t.className = "wnum-header", t.innerHTML = "Wk", n.prepend(t);
            }
            "CalendarDays" === i && [
                ...n.children
            ].forEach((e, i)=>{
                if (0 === i || i % 7 == 0) {
                    let i;
                    if (e.classList.contains("day")) i = new $252a7d750dfe5974$export$82f9ebd9adeba146(e.dataset.time);
                    else {
                        const e = n.querySelector(".day");
                        i = new $252a7d750dfe5974$export$82f9ebd9adeba146(e.dataset.time);
                    }
                    let s = i.getWeek(this.picker.options.firstDay);
                    53 === s && 0 === i.getMonth() && (s = "53/1");
                    const o = document.createElement("div");
                    o.className = "wnum-item", o.innerHTML = String(s), n.insertBefore(o, e);
                }
            });
        }
    }
}







const $c6e61c6d2571c3a5$var$daysOfWeek = (0, $4aa70e6322f04d6f$export$a33638efd29e46b)(true);
const $c6e61c6d2571c3a5$export$e8c2dc7d0af40a80 = ()=>{
    const unavailableDays = [];
    const venueData = (0, $6ab8eb33d1de4787$export$54eca3721020c605)("venue");
    // Check for closed days set in opening_times
    if (venueData.opening_times) Object.entries(venueData.opening_times).forEach(([key, value])=>{
        if ($c6e61c6d2571c3a5$var$daysOfWeek.includes(key) && !value.status && !unavailableDays.includes(key)) unavailableDays.push($c6e61c6d2571c3a5$var$daysOfWeek.indexOf(key));
    });
    return unavailableDays;
};
const $c6e61c6d2571c3a5$export$fcd89db5d09c9ad8 = ()=>{
    const unavailableDays = [];
    const venueData = (0, $6ab8eb33d1de4787$export$54eca3721020c605)("venue");
    const bookingType = (0, $6ab8eb33d1de4787$export$54eca3721020c605)("bookingType");
    if (bookingType && venueData.booking_types) Object.entries(venueData.booking_types).forEach(([key, value])=>{
        if (value.id == bookingType) Object.entries(value.booking_rules).forEach(([day, rules])=>{
            if ($c6e61c6d2571c3a5$var$daysOfWeek.includes(day) && !rules.booking_available && !unavailableDays.includes(day)) unavailableDays.push($c6e61c6d2571c3a5$var$daysOfWeek.indexOf(day));
        });
    });
    return unavailableDays;
};
const $c6e61c6d2571c3a5$export$df56ed9e9e88cafb = ()=>{
    let unavailableDates = [];
    const venueData = (0, $6ab8eb33d1de4787$export$54eca3721020c605)("venue");
    // Check for closed days set in opening_times
    if (venueData.opening_times) Object.entries(venueData.opening_times).forEach(([key, value])=>{
        if (!$c6e61c6d2571c3a5$var$daysOfWeek.includes(key) && !value.status && !unavailableDates.includes(key)) unavailableDates.push(key);
    });
    // Check for closed dates in booking_unavailable for all booking types
    if (venueData?.booking_unavailable?.all) venueData?.booking_unavailable?.all.forEach((item)=>{
        unavailableDates = $c6e61c6d2571c3a5$var$getDates(unavailableDates, item);
    });
    // Check for closed dates in booking_unavailable for the active booking type
    if (venueData?.booking_unavailable && (0, $6ab8eb33d1de4787$export$54eca3721020c605)("bookingType")) Object.entries(venueData.booking_unavailable).forEach(([key, items])=>{
        if (key === (0, $6ab8eb33d1de4787$export$54eca3721020c605)("bookingType")) items.forEach((item)=>{
            unavailableDates = $c6e61c6d2571c3a5$var$getDates(unavailableDates, item);
        });
    });
    // Check for closed days for the active booking type in booking_types.booking_type.booking_overrides
    const bookingType = (0, $6ab8eb33d1de4787$export$54eca3721020c605)("bookingType");
    if (bookingType && venueData.booking_types) Object.entries(venueData.booking_types).forEach(([key, value])=>{
        if (value.id == bookingType && value.booking_overrides) Object.entries(value.booking_overrides).forEach(([key, value])=>{
            if (!value.booking_available) unavailableDates = $c6e61c6d2571c3a5$var$getDates(unavailableDates, {
                unavailable_from: value.date_from,
                unavailable_to: value.date_to
            });
        });
    });
    return unavailableDates;
};
const $c6e61c6d2571c3a5$var$getDates = (dates, item)=>{
    const fromTime = item.unavailable_from_time ?? "";
    const toTime = item.unavailable_to_time ?? "";
    if (fromTime === "" && toTime === "") {
        const datesArr = (0, $4aa70e6322f04d6f$export$68b158e1f523791a)(item.unavailable_from, item.unavailable_to);
        if (datesArr.length > 0) datesArr.forEach((date)=>{
            if (!dates.includes(date)) dates.push(date);
        });
    }
    return dates;
};
const $c6e61c6d2571c3a5$export$6a8f8218ddbca53 = (closedDates, bookingTypeClosedDays)=>{
    const openDates = [];
    const venueOpenDates = [];
    const venueData = (0, $6ab8eb33d1de4787$export$54eca3721020c605)("venue");
    // Check for open days set in opening_times
    if (venueData.opening_times) Object.entries(venueData.opening_times).forEach(([key, value])=>{
        if (!$c6e61c6d2571c3a5$var$daysOfWeek.includes(key) && value.status) {
            openDates.push(key);
            venueOpenDates.push(key);
        }
    });
    // Check if vanue open dates are set on days when the booking type is unavailable
    if (venueOpenDates.length) venueOpenDates.forEach((date)=>{
        const dayOfWeek = (0, $4aa70e6322f04d6f$export$deb57dc8c2016a9)(date);
        // If dayOfWeek is in bookingTypeClosedDays, remove it from openDates
        if (bookingTypeClosedDays.includes(dayOfWeek)) openDates.splice(openDates.indexOf(date), 1);
    });
    // Check for open days for the active booking type in booking_types.booking_type.booking_overrides
    const bookingType = (0, $6ab8eb33d1de4787$export$54eca3721020c605)("bookingType");
    if (bookingType && venueData.booking_types) Object.entries(venueData.booking_types).forEach(([key, value])=>{
        if (value.id == bookingType && value.booking_overrides) Object.entries(value.booking_overrides).forEach(([key, value])=>{
            if (value.booking_available) {
                // Get all dates this override
                const bookingTypeOpenDates = $c6e61c6d2571c3a5$var$getDates([], {
                    unavailable_from: value.date_from,
                    unavailable_to: value.date_to
                });
                // Loop through all dates and check if they exist in the closedDates []
                bookingTypeOpenDates.forEach((date)=>{
                    if (!closedDates.includes(date)) // Date doesn't exist in the closed dates array so add it to the openDates array
                    openDates.push(date);
                });
            }
        });
    });
    return openDates;
};




let $6e1849155f6a2360$var$picker;
const $6e1849155f6a2360$export$66c7bcc2bba9ba5b = (widget, stage = "bookingDetails")=>{
    if (typeof $6e1849155f6a2360$var$picker !== "undefined") $6e1849155f6a2360$var$picker.destroy();
    $6e1849155f6a2360$var$picker = new (0, $252a7d750dfe5974$export$4a89e7a35daa0ff4).create($6e1849155f6a2360$var$getPickerOptions(widget, stage));
    return $6e1849155f6a2360$var$picker;
};
const $6e1849155f6a2360$var$getPickerOptions = (widget, stage = "bookingDetails")=>{
    const venueClosedDates = (0, $c6e61c6d2571c3a5$export$e8c2dc7d0af40a80)();
    const bookingTypeClosedDays = (0, $c6e61c6d2571c3a5$export$fcd89db5d09c9ad8)();
    const closedDays = [
        ...new Set([
            ...venueClosedDates,
            ...bookingTypeClosedDays
        ])
    ];
    const closedDates = (0, $c6e61c6d2571c3a5$export$df56ed9e9e88cafb)();
    const openDates = (0, $c6e61c6d2571c3a5$export$6a8f8218ddbca53)(closedDates, bookingTypeClosedDays);
    const bookingTypeDetails = (0, $6ab8eb33d1de4787$export$4cc47fe0ce792f33)();
    const advancedMaxDays = bookingTypeDetails.advance_bookings_max_days;
    let maxDate = false;
    if (advancedMaxDays) {
        let todayMax = new Date();
        maxDate = new Date(todayMax.setDate(todayMax.getDate() + advancedMaxDays));
    }
    return {
        element: widget.querySelector(".ig-dmn__form-datepicker"),
        css: [
            "https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css",
            "https://cdn.jsdelivr.net/npm/@easepick/lock-plugin@1.2.0/dist/index.css"
        ],
        zIndex: 10,
        format: "DD MMMM YYYY",
        LockPlugin: {
            minDate: new Date(),
            filter (date, picked) {
                let disabledDates = [];
                // Add any days from the closedDays []
                if (closedDays.length) {
                    if (closedDays.includes(date.getDay())) disabledDates.push(date.format("YYYY-MM-DD"));
                }
                // Add any specific dates from closedDates []
                if (closedDates.length) closedDates.forEach((closedDate)=>{
                    // Check that the date doesn't already exist in the disabledDates []
                    if (!disabledDates.includes(closedDate)) disabledDates.push(closedDate);
                });
                // Remove any dates that are set to be open in the override opening times
                disabledDates = disabledDates.filter((date)=>!openDates.includes(date));
                // Check if the max dates are set
                if (maxDate) {
                    if (date > maxDate) disabledDates.push(date.format("YYYY-MM-DD"));
                }
                // Disable all dates that are in the disabledDates []
                return disabledDates.includes(date.format("YYYY-MM-DD"));
            }
        },
        plugins: [
            (0, $252a7d750dfe5974$export$104e0eb2cfcc1787)
        ],
        setup (picker) {
            const venueId = (0, $6ab8eb33d1de4787$export$54eca3721020c605)("venue")._id;
            picker.on("select", (e)=>{
                const { date: date } = e.detail;
                (0, $cc943cf31e795207$export$56525cbb1fcd885c)(widget);
                // Update the booking forms hidden date field value
                const dateFormatted = (0, $4aa70e6322f04d6f$export$3ae94a2503e890a1)(date);
                widget.querySelector(".ig-dmn__form-date").value = dateFormatted;
                if (stage === "bookingDetails") // Validate the booking
                (0, $b91133fb1ec5c5cc$export$9bc346c2d77d670a)(widget, "calendar").then((response)=>{
                    // Init the booking validation triggers
                    (0, $f817778a02e4b83a$export$a1e23348e20cfcfe)(widget);
                    setTimeout(()=>{
                        (0, $cc943cf31e795207$export$5cee2c2772922923)(widget);
                    }, 400);
                });
            });
        }
    };
};


const $f817778a02e4b83a$export$cecabb3b2fe7f2f9 = async function(widget, validation, triggerType) {
    let minGuests;
    let maxGuests;
    let times = [];
    // Loop through the validation object and get the values needed to update the fields
    Object.entries(validation).forEach(([key, item])=>{
        if (key === "num_people") {
            const rules = item.rules;
            // Add min and max people rules if they aren't set
            minGuests = rules?.min ?? 1;
            maxGuests = rules?.max ?? 8;
        }
        if (key === "time") item.suggestedValues.forEach((valueObj)=>{
            if (valueObj.action !== "reject") times.push(valueObj.time);
        });
    });
    if (triggerType === "calendar" || triggerType === "time") await (0, $4aa70e6322f04d6f$export$f87dae7c5c825238)(widget, minGuests, maxGuests);
    if (triggerType === "calendar" || triggerType === "num_people") await (0, $4aa70e6322f04d6f$export$869dd14c14f4e57f)(widget, times);
};
const $f817778a02e4b83a$export$a1e23348e20cfcfe = (widget)=>{
    const triggers = widget.querySelectorAll(".ig-dmn__booking-form-trigger");
    if (triggers) triggers.forEach((trigger)=>{
        trigger.addEventListener("change", (event)=>{
            (0, $cc943cf31e795207$export$56525cbb1fcd885c)(widget);
            const venueId = $6ab8eb33d1de4787$export$54eca3721020c605("venue")._id;
            // Update the offers available for the options selected
            (0, $8f528785e5628694$export$e558ebf3c711c0e3)(widget, venueId).then((offers)=>{
                (0, $236d893478cc0ae9$export$c925ae8f8414d3e7)(widget, offers);
            });
            // Validate the booking
            (0, $b91133fb1ec5c5cc$export$9bc346c2d77d670a)(widget, trigger.getAttribute("name")).then((response)=>{
                // Hide the loader
                setTimeout(()=>{
                    (0, $cc943cf31e795207$export$5cee2c2772922923)(widget);
                }, 400);
            });
        });
    });
};
const $f817778a02e4b83a$export$a2e7c1fc61117ddd = (widget, bookingTypeId)=>{
    const bookingFormDisclaimer = widget.querySelector(".ig-dmn__form-disclaimer");
    // Hide the disclaimer
    if (bookingFormDisclaimer) bookingFormDisclaimer.classList.add("hidden");
    // Check if the booking type has restricted dates and show the discliamer if so
    const bookingTypeDetails = $6ab8eb33d1de4787$export$4cc47fe0ce792f33(bookingTypeId);
    if (bookingTypeDetails.advance_bookings_max_days || bookingTypeDetails.advance_bookings_min_days) {
        let disclaimerText = "";
        if (bookingTypeDetails.advance_bookings_max_days) disclaimerText = `Please note: You can only book up to ${bookingTypeDetails.advance_bookings_max_days} days in advance.`;
        if (bookingTypeDetails.advance_bookings_min_days) disclaimerText = `Please note: You can only book up to ${bookingTypeDetails.advance_bookings_min_days} days before the booking.`;
        if (bookingTypeDetails.advance_bookings_max_days && bookingTypeDetails.advance_bookings_min_days) disclaimerText = `Please note: You can only book up to ${bookingTypeDetails.advance_bookings_max_days} days in advance and up to ${bookingTypeDetails.advance_bookings_min_days} days before the booking.`;
        if (bookingFormDisclaimer) {
            // Set the disclaimer text
            bookingFormDisclaimer.innerHTML = disclaimerText;
            // Show the disclaimer
            bookingFormDisclaimer.classList.remove("hidden");
        }
    }
};
const $f817778a02e4b83a$export$a17c92b831a60ed2 = (widget)=>{
    const bookingForm = widget.querySelector(".ig-dmn__booking-form");
    if (bookingForm) {
        // Reset any existing values in the form
        $f817778a02e4b83a$export$6f32389b44e79c4d(widget);
        // Show the form
        bookingForm.classList.remove("hidden");
        // Initialize the calendar
        (0, $6e1849155f6a2360$export$66c7bcc2bba9ba5b)(widget);
        // Enable the enquiry button
        const enquireBtn = widget.querySelector('.ig-dmn__stage-trigger[data-stage="enquire"]');
        enquireBtn.classList.remove("!hidden", "ig-dmn-btn--disabled");
    }
};
const $f817778a02e4b83a$export$6f32389b44e79c4d = (widget)=>{
    // Reset any existing values in the form
    widget.querySelector(".ig-dmn__form-datepicker").value = "";
    widget.querySelector(".ig-dmn__form-date").value = "";
    widget.querySelector(".ig-dmn__form-guests").value = "";
    widget.querySelector(".ig-dmn__form-time").value = "";
    const numPeopleDropdown = widget.querySelector(".ig-dmn__form-guests");
    const timesDropdown = widget.querySelector(".ig-dmn__form-time");
    // Remove the options from the dropdowns
    numPeopleDropdown.innerHTML = '<option value="">Select number of people</option>';
    timesDropdown.innerHTML = '<option value="">Select a time</option>';
    // Add the disabled attribute to the dropdowns
    numPeopleDropdown.setAttribute("disabled", "");
    timesDropdown.setAttribute("disabled", "");
};
const $f817778a02e4b83a$export$35b13d9c5f196302 = (widget)=>{
    const bookingForm = widget.querySelector(".ig-dmn__booking-form");
    if (bookingForm) {
        const date = widget.querySelector(".ig-dmn__form-date").value;
        const guests = widget.querySelector(".ig-dmn__form-guests").value;
        const time = widget.querySelector(".ig-dmn__form-time").value;
        return date !== "" && guests !== "" && time !== "";
    }
    // Can't find the booking form so return false
    return false;
};







var $c5eccf4247c91eed$exports = {};
/*! choices.js v10.2.0 | © 2022 Josh Johnson | https://github.com/jshjohnson/Choices#readme */ (function webpackUniversalModuleDefinition(root, factory) {
    $c5eccf4247c91eed$exports = factory();
})(window, function() {
    return /******/ function() {
        /******/ "use strict";
        /******/ var __webpack_modules__ = {
            /***/ 282: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.clearChoices = exports.activateChoices = exports.filterChoices = exports.addChoice = void 0;
                var constants_1 = __webpack_require__(883);
                var addChoice = function(_a) {
                    var value = _a.value, label = _a.label, id = _a.id, groupId = _a.groupId, disabled = _a.disabled, elementId = _a.elementId, customProperties = _a.customProperties, placeholder = _a.placeholder, keyCode = _a.keyCode;
                    return {
                        type: constants_1.ACTION_TYPES.ADD_CHOICE,
                        value: value,
                        label: label,
                        id: id,
                        groupId: groupId,
                        disabled: disabled,
                        elementId: elementId,
                        customProperties: customProperties,
                        placeholder: placeholder,
                        keyCode: keyCode
                    };
                };
                exports.addChoice = addChoice;
                var filterChoices = function(results) {
                    return {
                        type: constants_1.ACTION_TYPES.FILTER_CHOICES,
                        results: results
                    };
                };
                exports.filterChoices = filterChoices;
                var activateChoices = function(active) {
                    if (active === void 0) active = true;
                    return {
                        type: constants_1.ACTION_TYPES.ACTIVATE_CHOICES,
                        active: active
                    };
                };
                exports.activateChoices = activateChoices;
                var clearChoices = function() {
                    return {
                        type: constants_1.ACTION_TYPES.CLEAR_CHOICES
                    };
                };
                exports.clearChoices = clearChoices;
            /***/ },
            /***/ 783: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.addGroup = void 0;
                var constants_1 = __webpack_require__(883);
                var addGroup = function(_a) {
                    var value = _a.value, id = _a.id, active = _a.active, disabled = _a.disabled;
                    return {
                        type: constants_1.ACTION_TYPES.ADD_GROUP,
                        value: value,
                        id: id,
                        active: active,
                        disabled: disabled
                    };
                };
                exports.addGroup = addGroup;
            /***/ },
            /***/ 464: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.highlightItem = exports.removeItem = exports.addItem = void 0;
                var constants_1 = __webpack_require__(883);
                var addItem = function(_a) {
                    var value = _a.value, label = _a.label, id = _a.id, choiceId = _a.choiceId, groupId = _a.groupId, customProperties = _a.customProperties, placeholder = _a.placeholder, keyCode = _a.keyCode;
                    return {
                        type: constants_1.ACTION_TYPES.ADD_ITEM,
                        value: value,
                        label: label,
                        id: id,
                        choiceId: choiceId,
                        groupId: groupId,
                        customProperties: customProperties,
                        placeholder: placeholder,
                        keyCode: keyCode
                    };
                };
                exports.addItem = addItem;
                var removeItem = function(id, choiceId) {
                    return {
                        type: constants_1.ACTION_TYPES.REMOVE_ITEM,
                        id: id,
                        choiceId: choiceId
                    };
                };
                exports.removeItem = removeItem;
                var highlightItem = function(id, highlighted) {
                    return {
                        type: constants_1.ACTION_TYPES.HIGHLIGHT_ITEM,
                        id: id,
                        highlighted: highlighted
                    };
                };
                exports.highlightItem = highlightItem;
            /***/ },
            /***/ 137: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.setIsLoading = exports.resetTo = exports.clearAll = void 0;
                var constants_1 = __webpack_require__(883);
                var clearAll = function() {
                    return {
                        type: constants_1.ACTION_TYPES.CLEAR_ALL
                    };
                };
                exports.clearAll = clearAll;
                var resetTo = function(state) {
                    return {
                        type: constants_1.ACTION_TYPES.RESET_TO,
                        state: state
                    };
                };
                exports.resetTo = resetTo;
                var setIsLoading = function(isLoading) {
                    return {
                        type: constants_1.ACTION_TYPES.SET_IS_LOADING,
                        isLoading: isLoading
                    };
                };
                exports.setIsLoading = setIsLoading;
            /***/ },
            /***/ 373: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var deepmerge_1 = __importDefault(__webpack_require__(996));
                /* eslint-disable @typescript-eslint/no-explicit-any */ var fuse_js_1 = __importDefault(__webpack_require__(221));
                var choices_1 = __webpack_require__(282);
                var groups_1 = __webpack_require__(783);
                var items_1 = __webpack_require__(464);
                var misc_1 = __webpack_require__(137);
                var components_1 = __webpack_require__(520);
                var constants_1 = __webpack_require__(883);
                var defaults_1 = __webpack_require__(789);
                var utils_1 = __webpack_require__(799);
                var reducers_1 = __webpack_require__(655);
                var store_1 = __importDefault(__webpack_require__(744));
                var templates_1 = __importDefault(__webpack_require__(686));
                /** @see {@link http://browserhacks.com/#hack-acea075d0ac6954f275a70023906050c} */ var IS_IE11 = "-ms-scroll-limit" in document.documentElement.style && "-ms-ime-align" in document.documentElement.style;
                var USER_DEFAULTS = {};
                /**
 * Choices
 * @author Josh Johnson<josh@joshuajohnson.co.uk>
 */ var Choices = /** @class */ function() {
                    function Choices(element, userConfig) {
                        if (element === void 0) element = "[data-choice]";
                        if (userConfig === void 0) userConfig = {};
                        var _this = this;
                        if (userConfig.allowHTML === undefined) console.warn("Deprecation warning: allowHTML will default to false in a future release. To render HTML in Choices, you will need to set it to true. Setting allowHTML will suppress this message.");
                        this.config = deepmerge_1.default.all([
                            defaults_1.DEFAULT_CONFIG,
                            Choices.defaults.options,
                            userConfig
                        ], // When merging array configs, replace with a copy of the userConfig array,
                        // instead of concatenating with the default array
                        {
                            arrayMerge: function(_, sourceArray) {
                                return __spreadArray([], sourceArray, true);
                            }
                        });
                        var invalidConfigOptions = (0, utils_1.diff)(this.config, defaults_1.DEFAULT_CONFIG);
                        if (invalidConfigOptions.length) console.warn("Unknown config option(s) passed", invalidConfigOptions.join(", "));
                        var passedElement = typeof element === "string" ? document.querySelector(element) : element;
                        if (!(passedElement instanceof HTMLInputElement || passedElement instanceof HTMLSelectElement)) throw TypeError("Expected one of the following types text|select-one|select-multiple");
                        this._isTextElement = passedElement.type === constants_1.TEXT_TYPE;
                        this._isSelectOneElement = passedElement.type === constants_1.SELECT_ONE_TYPE;
                        this._isSelectMultipleElement = passedElement.type === constants_1.SELECT_MULTIPLE_TYPE;
                        this._isSelectElement = this._isSelectOneElement || this._isSelectMultipleElement;
                        this.config.searchEnabled = this._isSelectMultipleElement || this.config.searchEnabled;
                        if (![
                            "auto",
                            "always"
                        ].includes("".concat(this.config.renderSelectedChoices))) this.config.renderSelectedChoices = "auto";
                        if (userConfig.addItemFilter && typeof userConfig.addItemFilter !== "function") {
                            var re = userConfig.addItemFilter instanceof RegExp ? userConfig.addItemFilter : new RegExp(userConfig.addItemFilter);
                            this.config.addItemFilter = re.test.bind(re);
                        }
                        if (this._isTextElement) this.passedElement = new components_1.WrappedInput({
                            element: passedElement,
                            classNames: this.config.classNames,
                            delimiter: this.config.delimiter
                        });
                        else this.passedElement = new components_1.WrappedSelect({
                            element: passedElement,
                            classNames: this.config.classNames,
                            template: function(data) {
                                return _this._templates.option(data);
                            }
                        });
                        this.initialised = false;
                        this._store = new store_1.default();
                        this._initialState = reducers_1.defaultState;
                        this._currentState = reducers_1.defaultState;
                        this._prevState = reducers_1.defaultState;
                        this._currentValue = "";
                        this._canSearch = !!this.config.searchEnabled;
                        this._isScrollingOnIe = false;
                        this._highlightPosition = 0;
                        this._wasTap = true;
                        this._placeholderValue = this._generatePlaceholderValue();
                        this._baseId = (0, utils_1.generateId)(this.passedElement.element, "choices-");
                        /**
     * setting direction in cases where it's explicitly set on passedElement
     * or when calculated direction is different from the document
     */ this._direction = this.passedElement.dir;
                        if (!this._direction) {
                            var elementDirection = window.getComputedStyle(this.passedElement.element).direction;
                            var documentDirection = window.getComputedStyle(document.documentElement).direction;
                            if (elementDirection !== documentDirection) this._direction = elementDirection;
                        }
                        this._idNames = {
                            itemChoice: "item-choice"
                        };
                        if (this._isSelectElement) {
                            // Assign preset groups from passed element
                            this._presetGroups = this.passedElement.optionGroups;
                            // Assign preset options from passed element
                            this._presetOptions = this.passedElement.options;
                        }
                        // Assign preset choices from passed object
                        this._presetChoices = this.config.choices;
                        // Assign preset items from passed object first
                        this._presetItems = this.config.items;
                        // Add any values passed from attribute
                        if (this.passedElement.value && this._isTextElement) {
                            var splitValues = this.passedElement.value.split(this.config.delimiter);
                            this._presetItems = this._presetItems.concat(splitValues);
                        }
                        // Create array of choices from option elements
                        if (this.passedElement.options) this.passedElement.options.forEach(function(option) {
                            _this._presetChoices.push({
                                value: option.value,
                                label: option.innerHTML,
                                selected: !!option.selected,
                                disabled: option.disabled || option.parentNode.disabled,
                                placeholder: option.value === "" || option.hasAttribute("placeholder"),
                                customProperties: (0, utils_1.parseCustomProperties)(option.dataset.customProperties)
                            });
                        });
                        this._render = this._render.bind(this);
                        this._onFocus = this._onFocus.bind(this);
                        this._onBlur = this._onBlur.bind(this);
                        this._onKeyUp = this._onKeyUp.bind(this);
                        this._onKeyDown = this._onKeyDown.bind(this);
                        this._onClick = this._onClick.bind(this);
                        this._onTouchMove = this._onTouchMove.bind(this);
                        this._onTouchEnd = this._onTouchEnd.bind(this);
                        this._onMouseDown = this._onMouseDown.bind(this);
                        this._onMouseOver = this._onMouseOver.bind(this);
                        this._onFormReset = this._onFormReset.bind(this);
                        this._onSelectKey = this._onSelectKey.bind(this);
                        this._onEnterKey = this._onEnterKey.bind(this);
                        this._onEscapeKey = this._onEscapeKey.bind(this);
                        this._onDirectionKey = this._onDirectionKey.bind(this);
                        this._onDeleteKey = this._onDeleteKey.bind(this);
                        // If element has already been initialised with Choices, fail silently
                        if (this.passedElement.isActive) {
                            if (!this.config.silent) console.warn("Trying to initialise Choices on element already initialised", {
                                element: element
                            });
                            this.initialised = true;
                            return;
                        }
                        // Let's go
                        this.init();
                    }
                    Object.defineProperty(Choices, "defaults", {
                        get: function() {
                            return Object.preventExtensions({
                                get options () {
                                    return USER_DEFAULTS;
                                },
                                get templates () {
                                    return templates_1.default;
                                }
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Choices.prototype.init = function() {
                        if (this.initialised) return;
                        this._createTemplates();
                        this._createElements();
                        this._createStructure();
                        this._store.subscribe(this._render);
                        this._render();
                        this._addEventListeners();
                        var shouldDisable = !this.config.addItems || this.passedElement.element.hasAttribute("disabled");
                        if (shouldDisable) this.disable();
                        this.initialised = true;
                        var callbackOnInit = this.config.callbackOnInit;
                        // Run callback if it is a function
                        if (callbackOnInit && typeof callbackOnInit === "function") callbackOnInit.call(this);
                    };
                    Choices.prototype.destroy = function() {
                        if (!this.initialised) return;
                        this._removeEventListeners();
                        this.passedElement.reveal();
                        this.containerOuter.unwrap(this.passedElement.element);
                        this.clearStore();
                        if (this._isSelectElement) this.passedElement.options = this._presetOptions;
                        this._templates = templates_1.default;
                        this.initialised = false;
                    };
                    Choices.prototype.enable = function() {
                        if (this.passedElement.isDisabled) this.passedElement.enable();
                        if (this.containerOuter.isDisabled) {
                            this._addEventListeners();
                            this.input.enable();
                            this.containerOuter.enable();
                        }
                        return this;
                    };
                    Choices.prototype.disable = function() {
                        if (!this.passedElement.isDisabled) this.passedElement.disable();
                        if (!this.containerOuter.isDisabled) {
                            this._removeEventListeners();
                            this.input.disable();
                            this.containerOuter.disable();
                        }
                        return this;
                    };
                    Choices.prototype.highlightItem = function(item, runEvent) {
                        if (runEvent === void 0) runEvent = true;
                        if (!item || !item.id) return this;
                        var id = item.id, _a = item.groupId, groupId = _a === void 0 ? -1 : _a, _b = item.value, value = _b === void 0 ? "" : _b, _c = item.label, label = _c === void 0 ? "" : _c;
                        var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        this._store.dispatch((0, items_1.highlightItem)(id, true));
                        if (runEvent) this.passedElement.triggerEvent(constants_1.EVENTS.highlightItem, {
                            id: id,
                            value: value,
                            label: label,
                            groupValue: group && group.value ? group.value : null
                        });
                        return this;
                    };
                    Choices.prototype.unhighlightItem = function(item) {
                        if (!item || !item.id) return this;
                        var id = item.id, _a = item.groupId, groupId = _a === void 0 ? -1 : _a, _b = item.value, value = _b === void 0 ? "" : _b, _c = item.label, label = _c === void 0 ? "" : _c;
                        var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        this._store.dispatch((0, items_1.highlightItem)(id, false));
                        this.passedElement.triggerEvent(constants_1.EVENTS.highlightItem, {
                            id: id,
                            value: value,
                            label: label,
                            groupValue: group && group.value ? group.value : null
                        });
                        return this;
                    };
                    Choices.prototype.highlightAll = function() {
                        var _this = this;
                        this._store.items.forEach(function(item) {
                            return _this.highlightItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.unhighlightAll = function() {
                        var _this = this;
                        this._store.items.forEach(function(item) {
                            return _this.unhighlightItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.removeActiveItemsByValue = function(value) {
                        var _this = this;
                        this._store.activeItems.filter(function(item) {
                            return item.value === value;
                        }).forEach(function(item) {
                            return _this._removeItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.removeActiveItems = function(excludedId) {
                        var _this = this;
                        this._store.activeItems.filter(function(_a) {
                            var id = _a.id;
                            return id !== excludedId;
                        }).forEach(function(item) {
                            return _this._removeItem(item);
                        });
                        return this;
                    };
                    Choices.prototype.removeHighlightedItems = function(runEvent) {
                        var _this = this;
                        if (runEvent === void 0) runEvent = false;
                        this._store.highlightedActiveItems.forEach(function(item) {
                            _this._removeItem(item);
                            // If this action was performed by the user
                            // trigger the event
                            if (runEvent) _this._triggerChange(item.value);
                        });
                        return this;
                    };
                    Choices.prototype.showDropdown = function(preventInputFocus) {
                        var _this = this;
                        if (this.dropdown.isActive) return this;
                        requestAnimationFrame(function() {
                            _this.dropdown.show();
                            _this.containerOuter.open(_this.dropdown.distanceFromTopWindow);
                            if (!preventInputFocus && _this._canSearch) _this.input.focus();
                            _this.passedElement.triggerEvent(constants_1.EVENTS.showDropdown, {});
                        });
                        return this;
                    };
                    Choices.prototype.hideDropdown = function(preventInputBlur) {
                        var _this = this;
                        if (!this.dropdown.isActive) return this;
                        requestAnimationFrame(function() {
                            _this.dropdown.hide();
                            _this.containerOuter.close();
                            if (!preventInputBlur && _this._canSearch) {
                                _this.input.removeActiveDescendant();
                                _this.input.blur();
                            }
                            _this.passedElement.triggerEvent(constants_1.EVENTS.hideDropdown, {});
                        });
                        return this;
                    };
                    Choices.prototype.getValue = function(valueOnly) {
                        if (valueOnly === void 0) valueOnly = false;
                        var values = this._store.activeItems.reduce(function(selectedItems, item) {
                            var itemValue = valueOnly ? item.value : item;
                            selectedItems.push(itemValue);
                            return selectedItems;
                        }, []);
                        return this._isSelectOneElement ? values[0] : values;
                    };
                    Choices.prototype.setValue = function(items) {
                        var _this = this;
                        if (!this.initialised) return this;
                        items.forEach(function(value) {
                            return _this._setChoiceOrItem(value);
                        });
                        return this;
                    };
                    Choices.prototype.setChoiceByValue = function(value) {
                        var _this = this;
                        if (!this.initialised || this._isTextElement) return this;
                        // If only one value has been passed, convert to array
                        var choiceValue = Array.isArray(value) ? value : [
                            value
                        ];
                        // Loop through each value and
                        choiceValue.forEach(function(val) {
                            return _this._findAndSelectChoiceByValue(val);
                        });
                        return this;
                    };
                    /**
   * Set choices of select input via an array of objects (or function that returns array of object or promise of it),
   * a value field name and a label field name.
   * This behaves the same as passing items via the choices option but can be called after initialising Choices.
   * This can also be used to add groups of choices (see example 2); Optionally pass a true `replaceChoices` value to remove any existing choices.
   * Optionally pass a `customProperties` object to add additional data to your choices (useful when searching/filtering etc).
   *
   * **Input types affected:** select-one, select-multiple
   *
   * @example
   * ```js
   * const example = new Choices(element);
   *
   * example.setChoices([
   *   {value: 'One', label: 'Label One', disabled: true},
   *   {value: 'Two', label: 'Label Two', selected: true},
   *   {value: 'Three', label: 'Label Three'},
   * ], 'value', 'label', false);
   * ```
   *
   * @example
   * ```js
   * const example = new Choices(element);
   *
   * example.setChoices(async () => {
   *   try {
   *      const items = await fetch('/items');
   *      return items.json()
   *   } catch(err) {
   *      console.error(err)
   *   }
   * });
   * ```
   *
   * @example
   * ```js
   * const example = new Choices(element);
   *
   * example.setChoices([{
   *   label: 'Group one',
   *   id: 1,
   *   disabled: false,
   *   choices: [
   *     {value: 'Child One', label: 'Child One', selected: true},
   *     {value: 'Child Two', label: 'Child Two',  disabled: true},
   *     {value: 'Child Three', label: 'Child Three'},
   *   ]
   * },
   * {
   *   label: 'Group two',
   *   id: 2,
   *   disabled: false,
   *   choices: [
   *     {value: 'Child Four', label: 'Child Four', disabled: true},
   *     {value: 'Child Five', label: 'Child Five'},
   *     {value: 'Child Six', label: 'Child Six', customProperties: {
   *       description: 'Custom description about child six',
   *       random: 'Another random custom property'
   *     }},
   *   ]
   * }], 'value', 'label', false);
   * ```
   */ Choices.prototype.setChoices = function(choicesArrayOrFetcher, value, label, replaceChoices) {
                        var _this = this;
                        if (choicesArrayOrFetcher === void 0) choicesArrayOrFetcher = [];
                        if (value === void 0) value = "value";
                        if (label === void 0) label = "label";
                        if (replaceChoices === void 0) replaceChoices = false;
                        if (!this.initialised) throw new ReferenceError("setChoices was called on a non-initialized instance of Choices");
                        if (!this._isSelectElement) throw new TypeError("setChoices can't be used with INPUT based Choices");
                        if (typeof value !== "string" || !value) throw new TypeError("value parameter must be a name of 'value' field in passed objects");
                        // Clear choices if needed
                        if (replaceChoices) this.clearChoices();
                        if (typeof choicesArrayOrFetcher === "function") {
                            // it's a choices fetcher function
                            var fetcher_1 = choicesArrayOrFetcher(this);
                            if (typeof Promise === "function" && fetcher_1 instanceof Promise) // that's a promise
                            // eslint-disable-next-line no-promise-executor-return
                            return new Promise(function(resolve) {
                                return requestAnimationFrame(resolve);
                            }).then(function() {
                                return _this._handleLoadingState(true);
                            }).then(function() {
                                return fetcher_1;
                            }).then(function(data) {
                                return _this.setChoices(data, value, label, replaceChoices);
                            }).catch(function(err) {
                                if (!_this.config.silent) console.error(err);
                            }).then(function() {
                                return _this._handleLoadingState(false);
                            }).then(function() {
                                return _this;
                            });
                            // function returned something else than promise, let's check if it's an array of choices
                            if (!Array.isArray(fetcher_1)) throw new TypeError(".setChoices first argument function must return either array of choices or Promise, got: ".concat(typeof fetcher_1));
                            // recursion with results, it's sync and choices were cleared already
                            return this.setChoices(fetcher_1, value, label, false);
                        }
                        if (!Array.isArray(choicesArrayOrFetcher)) throw new TypeError(".setChoices must be called either with array of choices with a function resulting into Promise of array of choices");
                        this.containerOuter.removeLoadingState();
                        this._startLoading();
                        choicesArrayOrFetcher.forEach(function(groupOrChoice) {
                            if (groupOrChoice.choices) _this._addGroup({
                                id: groupOrChoice.id ? parseInt("".concat(groupOrChoice.id), 10) : null,
                                group: groupOrChoice,
                                valueKey: value,
                                labelKey: label
                            });
                            else {
                                var choice = groupOrChoice;
                                _this._addChoice({
                                    value: choice[value],
                                    label: choice[label],
                                    isSelected: !!choice.selected,
                                    isDisabled: !!choice.disabled,
                                    placeholder: !!choice.placeholder,
                                    customProperties: choice.customProperties
                                });
                            }
                        });
                        this._stopLoading();
                        return this;
                    };
                    Choices.prototype.clearChoices = function() {
                        this._store.dispatch((0, choices_1.clearChoices)());
                        return this;
                    };
                    Choices.prototype.clearStore = function() {
                        this._store.dispatch((0, misc_1.clearAll)());
                        return this;
                    };
                    Choices.prototype.clearInput = function() {
                        var shouldSetInputWidth = !this._isSelectOneElement;
                        this.input.clear(shouldSetInputWidth);
                        if (!this._isTextElement && this._canSearch) {
                            this._isSearching = false;
                            this._store.dispatch((0, choices_1.activateChoices)(true));
                        }
                        return this;
                    };
                    Choices.prototype._render = function() {
                        if (this._store.isLoading()) return;
                        this._currentState = this._store.state;
                        var stateChanged = this._currentState.choices !== this._prevState.choices || this._currentState.groups !== this._prevState.groups || this._currentState.items !== this._prevState.items;
                        var shouldRenderChoices = this._isSelectElement;
                        var shouldRenderItems = this._currentState.items !== this._prevState.items;
                        if (!stateChanged) return;
                        if (shouldRenderChoices) this._renderChoices();
                        if (shouldRenderItems) this._renderItems();
                        this._prevState = this._currentState;
                    };
                    Choices.prototype._renderChoices = function() {
                        var _this = this;
                        var _a = this._store, activeGroups = _a.activeGroups, activeChoices = _a.activeChoices;
                        var choiceListFragment = document.createDocumentFragment();
                        this.choiceList.clear();
                        if (this.config.resetScrollPosition) requestAnimationFrame(function() {
                            return _this.choiceList.scrollToTop();
                        });
                        // If we have grouped options
                        if (activeGroups.length >= 1 && !this._isSearching) {
                            // If we have a placeholder choice along with groups
                            var activePlaceholders = activeChoices.filter(function(activeChoice) {
                                return activeChoice.placeholder === true && activeChoice.groupId === -1;
                            });
                            if (activePlaceholders.length >= 1) choiceListFragment = this._createChoicesFragment(activePlaceholders, choiceListFragment);
                            choiceListFragment = this._createGroupsFragment(activeGroups, activeChoices, choiceListFragment);
                        } else if (activeChoices.length >= 1) choiceListFragment = this._createChoicesFragment(activeChoices, choiceListFragment);
                        // If we have choices to show
                        if (choiceListFragment.childNodes && choiceListFragment.childNodes.length > 0) {
                            var activeItems = this._store.activeItems;
                            var canAddItem = this._canAddItem(activeItems, this.input.value);
                            // ...and we can select them
                            if (canAddItem.response) {
                                // ...append them and highlight the first choice
                                this.choiceList.append(choiceListFragment);
                                this._highlightChoice();
                            } else {
                                var notice = this._getTemplate("notice", canAddItem.notice);
                                this.choiceList.append(notice);
                            }
                        } else {
                            // Otherwise show a notice
                            var dropdownItem = void 0;
                            var notice = void 0;
                            if (this._isSearching) {
                                notice = typeof this.config.noResultsText === "function" ? this.config.noResultsText() : this.config.noResultsText;
                                dropdownItem = this._getTemplate("notice", notice, "no-results");
                            } else {
                                notice = typeof this.config.noChoicesText === "function" ? this.config.noChoicesText() : this.config.noChoicesText;
                                dropdownItem = this._getTemplate("notice", notice, "no-choices");
                            }
                            this.choiceList.append(dropdownItem);
                        }
                    };
                    Choices.prototype._renderItems = function() {
                        var activeItems = this._store.activeItems || [];
                        this.itemList.clear();
                        // Create a fragment to store our list items
                        // (so we don't have to update the DOM for each item)
                        var itemListFragment = this._createItemsFragment(activeItems);
                        // If we have items to add, append them
                        if (itemListFragment.childNodes) this.itemList.append(itemListFragment);
                    };
                    Choices.prototype._createGroupsFragment = function(groups, choices, fragment) {
                        var _this = this;
                        if (fragment === void 0) fragment = document.createDocumentFragment();
                        var getGroupChoices = function(group) {
                            return choices.filter(function(choice) {
                                if (_this._isSelectOneElement) return choice.groupId === group.id;
                                return choice.groupId === group.id && (_this.config.renderSelectedChoices === "always" || !choice.selected);
                            });
                        };
                        // If sorting is enabled, filter groups
                        if (this.config.shouldSort) groups.sort(this.config.sorter);
                        groups.forEach(function(group) {
                            var groupChoices = getGroupChoices(group);
                            if (groupChoices.length >= 1) {
                                var dropdownGroup = _this._getTemplate("choiceGroup", group);
                                fragment.appendChild(dropdownGroup);
                                _this._createChoicesFragment(groupChoices, fragment, true);
                            }
                        });
                        return fragment;
                    };
                    Choices.prototype._createChoicesFragment = function(choices, fragment, withinGroup) {
                        var _this = this;
                        if (fragment === void 0) fragment = document.createDocumentFragment();
                        if (withinGroup === void 0) withinGroup = false;
                        // Create a fragment to store our list items (so we don't have to update the DOM for each item)
                        var _a = this.config, renderSelectedChoices = _a.renderSelectedChoices, searchResultLimit = _a.searchResultLimit, renderChoiceLimit = _a.renderChoiceLimit;
                        var filter = this._isSearching ? utils_1.sortByScore : this.config.sorter;
                        var appendChoice = function(choice) {
                            var shouldRender = renderSelectedChoices === "auto" ? _this._isSelectOneElement || !choice.selected : true;
                            if (shouldRender) {
                                var dropdownItem = _this._getTemplate("choice", choice, _this.config.itemSelectText);
                                fragment.appendChild(dropdownItem);
                            }
                        };
                        var rendererableChoices = choices;
                        if (renderSelectedChoices === "auto" && !this._isSelectOneElement) rendererableChoices = choices.filter(function(choice) {
                            return !choice.selected;
                        });
                        // Split array into placeholders and "normal" choices
                        var _b = rendererableChoices.reduce(function(acc, choice) {
                            if (choice.placeholder) acc.placeholderChoices.push(choice);
                            else acc.normalChoices.push(choice);
                            return acc;
                        }, {
                            placeholderChoices: [],
                            normalChoices: []
                        }), placeholderChoices = _b.placeholderChoices, normalChoices = _b.normalChoices;
                        // If sorting is enabled or the user is searching, filter choices
                        if (this.config.shouldSort || this._isSearching) normalChoices.sort(filter);
                        var choiceLimit = rendererableChoices.length;
                        // Prepend placeholeder
                        var sortedChoices = this._isSelectOneElement ? __spreadArray(__spreadArray([], placeholderChoices, true), normalChoices, true) : normalChoices;
                        if (this._isSearching) choiceLimit = searchResultLimit;
                        else if (renderChoiceLimit && renderChoiceLimit > 0 && !withinGroup) choiceLimit = renderChoiceLimit;
                        // Add each choice to dropdown within range
                        for(var i = 0; i < choiceLimit; i += 1)if (sortedChoices[i]) appendChoice(sortedChoices[i]);
                        return fragment;
                    };
                    Choices.prototype._createItemsFragment = function(items, fragment) {
                        var _this = this;
                        if (fragment === void 0) fragment = document.createDocumentFragment();
                        // Create fragment to add elements to
                        var _a = this.config, shouldSortItems = _a.shouldSortItems, sorter = _a.sorter, removeItemButton = _a.removeItemButton;
                        // If sorting is enabled, filter items
                        if (shouldSortItems && !this._isSelectOneElement) items.sort(sorter);
                        if (this._isTextElement) // Update the value of the hidden input
                        this.passedElement.value = items.map(function(_a) {
                            var value = _a.value;
                            return value;
                        }).join(this.config.delimiter);
                        else // Update the options of the hidden input
                        this.passedElement.options = items;
                        var addItemToFragment = function(item) {
                            // Create new list element
                            var listItem = _this._getTemplate("item", item, removeItemButton);
                            // Append it to list
                            fragment.appendChild(listItem);
                        };
                        // Add each list item to list
                        items.forEach(addItemToFragment);
                        return fragment;
                    };
                    Choices.prototype._triggerChange = function(value) {
                        if (value === undefined || value === null) return;
                        this.passedElement.triggerEvent(constants_1.EVENTS.change, {
                            value: value
                        });
                    };
                    Choices.prototype._selectPlaceholderChoice = function(placeholderChoice) {
                        this._addItem({
                            value: placeholderChoice.value,
                            label: placeholderChoice.label,
                            choiceId: placeholderChoice.id,
                            groupId: placeholderChoice.groupId,
                            placeholder: placeholderChoice.placeholder
                        });
                        this._triggerChange(placeholderChoice.value);
                    };
                    Choices.prototype._handleButtonAction = function(activeItems, element) {
                        if (!activeItems || !element || !this.config.removeItems || !this.config.removeItemButton) return;
                        var itemId = element.parentNode && element.parentNode.dataset.id;
                        var itemToRemove = itemId && activeItems.find(function(item) {
                            return item.id === parseInt(itemId, 10);
                        });
                        if (!itemToRemove) return;
                        // Remove item associated with button
                        this._removeItem(itemToRemove);
                        this._triggerChange(itemToRemove.value);
                        if (this._isSelectOneElement && this._store.placeholderChoice) this._selectPlaceholderChoice(this._store.placeholderChoice);
                    };
                    Choices.prototype._handleItemAction = function(activeItems, element, hasShiftKey) {
                        var _this = this;
                        if (hasShiftKey === void 0) hasShiftKey = false;
                        if (!activeItems || !element || !this.config.removeItems || this._isSelectOneElement) return;
                        var passedId = element.dataset.id;
                        // We only want to select one item with a click
                        // so we deselect any items that aren't the target
                        // unless shift is being pressed
                        activeItems.forEach(function(item) {
                            if (item.id === parseInt("".concat(passedId), 10) && !item.highlighted) _this.highlightItem(item);
                            else if (!hasShiftKey && item.highlighted) _this.unhighlightItem(item);
                        });
                        // Focus input as without focus, a user cannot do anything with a
                        // highlighted item
                        this.input.focus();
                    };
                    Choices.prototype._handleChoiceAction = function(activeItems, element) {
                        if (!activeItems || !element) return;
                        // If we are clicking on an option
                        var id = element.dataset.id;
                        var choice = id && this._store.getChoiceById(id);
                        if (!choice) return;
                        var passedKeyCode = activeItems[0] && activeItems[0].keyCode ? activeItems[0].keyCode : undefined;
                        var hasActiveDropdown = this.dropdown.isActive;
                        // Update choice keyCode
                        choice.keyCode = passedKeyCode;
                        this.passedElement.triggerEvent(constants_1.EVENTS.choice, {
                            choice: choice
                        });
                        if (!choice.selected && !choice.disabled) {
                            var canAddItem = this._canAddItem(activeItems, choice.value);
                            if (canAddItem.response) {
                                this._addItem({
                                    value: choice.value,
                                    label: choice.label,
                                    choiceId: choice.id,
                                    groupId: choice.groupId,
                                    customProperties: choice.customProperties,
                                    placeholder: choice.placeholder,
                                    keyCode: choice.keyCode
                                });
                                this._triggerChange(choice.value);
                            }
                        }
                        this.clearInput();
                        // We want to close the dropdown if we are dealing with a single select box
                        if (hasActiveDropdown && this._isSelectOneElement) {
                            this.hideDropdown(true);
                            this.containerOuter.focus();
                        }
                    };
                    Choices.prototype._handleBackspace = function(activeItems) {
                        if (!this.config.removeItems || !activeItems) return;
                        var lastItem = activeItems[activeItems.length - 1];
                        var hasHighlightedItems = activeItems.some(function(item) {
                            return item.highlighted;
                        });
                        // If editing the last item is allowed and there are not other selected items,
                        // we can edit the item value. Otherwise if we can remove items, remove all selected items
                        if (this.config.editItems && !hasHighlightedItems && lastItem) {
                            this.input.value = lastItem.value;
                            this.input.setWidth();
                            this._removeItem(lastItem);
                            this._triggerChange(lastItem.value);
                        } else {
                            if (!hasHighlightedItems) // Highlight last item if none already highlighted
                            this.highlightItem(lastItem, false);
                            this.removeHighlightedItems(true);
                        }
                    };
                    Choices.prototype._startLoading = function() {
                        this._store.dispatch((0, misc_1.setIsLoading)(true));
                    };
                    Choices.prototype._stopLoading = function() {
                        this._store.dispatch((0, misc_1.setIsLoading)(false));
                    };
                    Choices.prototype._handleLoadingState = function(setLoading) {
                        if (setLoading === void 0) setLoading = true;
                        var placeholderItem = this.itemList.getChild(".".concat(this.config.classNames.placeholder));
                        if (setLoading) {
                            this.disable();
                            this.containerOuter.addLoadingState();
                            if (this._isSelectOneElement) {
                                if (!placeholderItem) {
                                    placeholderItem = this._getTemplate("placeholder", this.config.loadingText);
                                    if (placeholderItem) this.itemList.append(placeholderItem);
                                } else placeholderItem.innerHTML = this.config.loadingText;
                            } else this.input.placeholder = this.config.loadingText;
                        } else {
                            this.enable();
                            this.containerOuter.removeLoadingState();
                            if (this._isSelectOneElement) {
                                if (placeholderItem) placeholderItem.innerHTML = this._placeholderValue || "";
                            } else this.input.placeholder = this._placeholderValue || "";
                        }
                    };
                    Choices.prototype._handleSearch = function(value) {
                        if (!this.input.isFocussed) return;
                        var choices = this._store.choices;
                        var _a = this.config, searchFloor = _a.searchFloor, searchChoices = _a.searchChoices;
                        var hasUnactiveChoices = choices.some(function(option) {
                            return !option.active;
                        });
                        // Check that we have a value to search and the input was an alphanumeric character
                        if (value !== null && typeof value !== "undefined" && value.length >= searchFloor) {
                            var resultCount = searchChoices ? this._searchChoices(value) : 0;
                            // Trigger search event
                            this.passedElement.triggerEvent(constants_1.EVENTS.search, {
                                value: value,
                                resultCount: resultCount
                            });
                        } else if (hasUnactiveChoices) {
                            // Otherwise reset choices to active
                            this._isSearching = false;
                            this._store.dispatch((0, choices_1.activateChoices)(true));
                        }
                    };
                    Choices.prototype._canAddItem = function(activeItems, value) {
                        var canAddItem = true;
                        var notice = typeof this.config.addItemText === "function" ? this.config.addItemText(value) : this.config.addItemText;
                        if (!this._isSelectOneElement) {
                            var isDuplicateValue = (0, utils_1.existsInArray)(activeItems, value);
                            if (this.config.maxItemCount > 0 && this.config.maxItemCount <= activeItems.length) {
                                // If there is a max entry limit and we have reached that limit
                                // don't update
                                canAddItem = false;
                                notice = typeof this.config.maxItemText === "function" ? this.config.maxItemText(this.config.maxItemCount) : this.config.maxItemText;
                            }
                            if (!this.config.duplicateItemsAllowed && isDuplicateValue && canAddItem) {
                                canAddItem = false;
                                notice = typeof this.config.uniqueItemText === "function" ? this.config.uniqueItemText(value) : this.config.uniqueItemText;
                            }
                            if (this._isTextElement && this.config.addItems && canAddItem && typeof this.config.addItemFilter === "function" && !this.config.addItemFilter(value)) {
                                canAddItem = false;
                                notice = typeof this.config.customAddItemText === "function" ? this.config.customAddItemText(value) : this.config.customAddItemText;
                            }
                        }
                        return {
                            response: canAddItem,
                            notice: notice
                        };
                    };
                    Choices.prototype._searchChoices = function(value) {
                        var newValue = typeof value === "string" ? value.trim() : value;
                        var currentValue = typeof this._currentValue === "string" ? this._currentValue.trim() : this._currentValue;
                        if (newValue.length < 1 && newValue === "".concat(currentValue, " ")) return 0;
                        // If new value matches the desired length and is not the same as the current value with a space
                        var haystack = this._store.searchableChoices;
                        var needle = newValue;
                        var options = Object.assign(this.config.fuseOptions, {
                            keys: __spreadArray([], this.config.searchFields, true),
                            includeMatches: true
                        });
                        var fuse = new fuse_js_1.default(haystack, options);
                        var results = fuse.search(needle); // see https://github.com/krisk/Fuse/issues/303
                        this._currentValue = newValue;
                        this._highlightPosition = 0;
                        this._isSearching = true;
                        this._store.dispatch((0, choices_1.filterChoices)(results));
                        return results.length;
                    };
                    Choices.prototype._addEventListeners = function() {
                        var documentElement = document.documentElement;
                        // capture events - can cancel event processing or propagation
                        documentElement.addEventListener("touchend", this._onTouchEnd, true);
                        this.containerOuter.element.addEventListener("keydown", this._onKeyDown, true);
                        this.containerOuter.element.addEventListener("mousedown", this._onMouseDown, true);
                        // passive events - doesn't call `preventDefault` or `stopPropagation`
                        documentElement.addEventListener("click", this._onClick, {
                            passive: true
                        });
                        documentElement.addEventListener("touchmove", this._onTouchMove, {
                            passive: true
                        });
                        this.dropdown.element.addEventListener("mouseover", this._onMouseOver, {
                            passive: true
                        });
                        if (this._isSelectOneElement) {
                            this.containerOuter.element.addEventListener("focus", this._onFocus, {
                                passive: true
                            });
                            this.containerOuter.element.addEventListener("blur", this._onBlur, {
                                passive: true
                            });
                        }
                        this.input.element.addEventListener("keyup", this._onKeyUp, {
                            passive: true
                        });
                        this.input.element.addEventListener("focus", this._onFocus, {
                            passive: true
                        });
                        this.input.element.addEventListener("blur", this._onBlur, {
                            passive: true
                        });
                        if (this.input.element.form) this.input.element.form.addEventListener("reset", this._onFormReset, {
                            passive: true
                        });
                        this.input.addEventListeners();
                    };
                    Choices.prototype._removeEventListeners = function() {
                        var documentElement = document.documentElement;
                        documentElement.removeEventListener("touchend", this._onTouchEnd, true);
                        this.containerOuter.element.removeEventListener("keydown", this._onKeyDown, true);
                        this.containerOuter.element.removeEventListener("mousedown", this._onMouseDown, true);
                        documentElement.removeEventListener("click", this._onClick);
                        documentElement.removeEventListener("touchmove", this._onTouchMove);
                        this.dropdown.element.removeEventListener("mouseover", this._onMouseOver);
                        if (this._isSelectOneElement) {
                            this.containerOuter.element.removeEventListener("focus", this._onFocus);
                            this.containerOuter.element.removeEventListener("blur", this._onBlur);
                        }
                        this.input.element.removeEventListener("keyup", this._onKeyUp);
                        this.input.element.removeEventListener("focus", this._onFocus);
                        this.input.element.removeEventListener("blur", this._onBlur);
                        if (this.input.element.form) this.input.element.form.removeEventListener("reset", this._onFormReset);
                        this.input.removeEventListeners();
                    };
                    Choices.prototype._onKeyDown = function(event) {
                        var keyCode = event.keyCode;
                        var activeItems = this._store.activeItems;
                        var hasFocusedInput = this.input.isFocussed;
                        var hasActiveDropdown = this.dropdown.isActive;
                        var hasItems = this.itemList.hasChildren();
                        var keyString = String.fromCharCode(keyCode);
                        // eslint-disable-next-line no-control-regex
                        var wasPrintableChar = /[^\x00-\x1F]/.test(keyString);
                        var BACK_KEY = constants_1.KEY_CODES.BACK_KEY, DELETE_KEY = constants_1.KEY_CODES.DELETE_KEY, ENTER_KEY = constants_1.KEY_CODES.ENTER_KEY, A_KEY = constants_1.KEY_CODES.A_KEY, ESC_KEY = constants_1.KEY_CODES.ESC_KEY, UP_KEY = constants_1.KEY_CODES.UP_KEY, DOWN_KEY = constants_1.KEY_CODES.DOWN_KEY, PAGE_UP_KEY = constants_1.KEY_CODES.PAGE_UP_KEY, PAGE_DOWN_KEY = constants_1.KEY_CODES.PAGE_DOWN_KEY;
                        if (!this._isTextElement && !hasActiveDropdown && wasPrintableChar) {
                            this.showDropdown();
                            if (!this.input.isFocussed) /*
          We update the input value with the pressed key as
          the input was not focussed at the time of key press
          therefore does not have the value of the key.
        */ this.input.value += event.key.toLowerCase();
                        }
                        switch(keyCode){
                            case A_KEY:
                                return this._onSelectKey(event, hasItems);
                            case ENTER_KEY:
                                return this._onEnterKey(event, activeItems, hasActiveDropdown);
                            case ESC_KEY:
                                return this._onEscapeKey(hasActiveDropdown);
                            case UP_KEY:
                            case PAGE_UP_KEY:
                            case DOWN_KEY:
                            case PAGE_DOWN_KEY:
                                return this._onDirectionKey(event, hasActiveDropdown);
                            case DELETE_KEY:
                            case BACK_KEY:
                                return this._onDeleteKey(event, activeItems, hasFocusedInput);
                            default:
                        }
                    };
                    Choices.prototype._onKeyUp = function(_a) {
                        var target = _a.target, keyCode = _a.keyCode;
                        var value = this.input.value;
                        var activeItems = this._store.activeItems;
                        var canAddItem = this._canAddItem(activeItems, value);
                        var backKey = constants_1.KEY_CODES.BACK_KEY, deleteKey = constants_1.KEY_CODES.DELETE_KEY;
                        // We are typing into a text input and have a value, we want to show a dropdown
                        // notice. Otherwise hide the dropdown
                        if (this._isTextElement) {
                            var canShowDropdownNotice = canAddItem.notice && value;
                            if (canShowDropdownNotice) {
                                var dropdownItem = this._getTemplate("notice", canAddItem.notice);
                                this.dropdown.element.innerHTML = dropdownItem.outerHTML;
                                this.showDropdown(true);
                            } else this.hideDropdown(true);
                        } else {
                            var wasRemovalKeyCode = keyCode === backKey || keyCode === deleteKey;
                            var userHasRemovedValue = wasRemovalKeyCode && target && !target.value;
                            var canReactivateChoices = !this._isTextElement && this._isSearching;
                            var canSearch = this._canSearch && canAddItem.response;
                            if (userHasRemovedValue && canReactivateChoices) {
                                this._isSearching = false;
                                this._store.dispatch((0, choices_1.activateChoices)(true));
                            } else if (canSearch) this._handleSearch(this.input.rawValue);
                        }
                        this._canSearch = this.config.searchEnabled;
                    };
                    Choices.prototype._onSelectKey = function(event, hasItems) {
                        var ctrlKey = event.ctrlKey, metaKey = event.metaKey;
                        var hasCtrlDownKeyPressed = ctrlKey || metaKey;
                        // If CTRL + A or CMD + A have been pressed and there are items to select
                        if (hasCtrlDownKeyPressed && hasItems) {
                            this._canSearch = false;
                            var shouldHightlightAll = this.config.removeItems && !this.input.value && this.input.element === document.activeElement;
                            if (shouldHightlightAll) this.highlightAll();
                        }
                    };
                    Choices.prototype._onEnterKey = function(event, activeItems, hasActiveDropdown) {
                        var target = event.target;
                        var enterKey = constants_1.KEY_CODES.ENTER_KEY;
                        var targetWasButton = target && target.hasAttribute("data-button");
                        if (this._isTextElement && target && target.value) {
                            var value = this.input.value;
                            var canAddItem = this._canAddItem(activeItems, value);
                            if (canAddItem.response) {
                                this.hideDropdown(true);
                                this._addItem({
                                    value: value
                                });
                                this._triggerChange(value);
                                this.clearInput();
                            }
                        }
                        if (targetWasButton) {
                            this._handleButtonAction(activeItems, target);
                            event.preventDefault();
                        }
                        if (hasActiveDropdown) {
                            var highlightedChoice = this.dropdown.getChild(".".concat(this.config.classNames.highlightedState));
                            if (highlightedChoice) {
                                // add enter keyCode value
                                if (activeItems[0]) activeItems[0].keyCode = enterKey; // eslint-disable-line no-param-reassign
                                this._handleChoiceAction(activeItems, highlightedChoice);
                            }
                            event.preventDefault();
                        } else if (this._isSelectOneElement) {
                            this.showDropdown();
                            event.preventDefault();
                        }
                    };
                    Choices.prototype._onEscapeKey = function(hasActiveDropdown) {
                        if (hasActiveDropdown) {
                            this.hideDropdown(true);
                            this.containerOuter.focus();
                        }
                    };
                    Choices.prototype._onDirectionKey = function(event, hasActiveDropdown) {
                        var keyCode = event.keyCode, metaKey = event.metaKey;
                        var downKey = constants_1.KEY_CODES.DOWN_KEY, pageUpKey = constants_1.KEY_CODES.PAGE_UP_KEY, pageDownKey = constants_1.KEY_CODES.PAGE_DOWN_KEY;
                        // If up or down key is pressed, traverse through options
                        if (hasActiveDropdown || this._isSelectOneElement) {
                            this.showDropdown();
                            this._canSearch = false;
                            var directionInt = keyCode === downKey || keyCode === pageDownKey ? 1 : -1;
                            var skipKey = metaKey || keyCode === pageDownKey || keyCode === pageUpKey;
                            var selectableChoiceIdentifier = "[data-choice-selectable]";
                            var nextEl = void 0;
                            if (skipKey) {
                                if (directionInt > 0) nextEl = this.dropdown.element.querySelector("".concat(selectableChoiceIdentifier, ":last-of-type"));
                                else nextEl = this.dropdown.element.querySelector(selectableChoiceIdentifier);
                            } else {
                                var currentEl = this.dropdown.element.querySelector(".".concat(this.config.classNames.highlightedState));
                                if (currentEl) nextEl = (0, utils_1.getAdjacentEl)(currentEl, selectableChoiceIdentifier, directionInt);
                                else nextEl = this.dropdown.element.querySelector(selectableChoiceIdentifier);
                            }
                            if (nextEl) {
                                // We prevent default to stop the cursor moving
                                // when pressing the arrow
                                if (!(0, utils_1.isScrolledIntoView)(nextEl, this.choiceList.element, directionInt)) this.choiceList.scrollToChildElement(nextEl, directionInt);
                                this._highlightChoice(nextEl);
                            }
                            // Prevent default to maintain cursor position whilst
                            // traversing dropdown options
                            event.preventDefault();
                        }
                    };
                    Choices.prototype._onDeleteKey = function(event, activeItems, hasFocusedInput) {
                        var target = event.target;
                        // If backspace or delete key is pressed and the input has no value
                        if (!this._isSelectOneElement && !target.value && hasFocusedInput) {
                            this._handleBackspace(activeItems);
                            event.preventDefault();
                        }
                    };
                    Choices.prototype._onTouchMove = function() {
                        if (this._wasTap) this._wasTap = false;
                    };
                    Choices.prototype._onTouchEnd = function(event) {
                        var target = (event || event.touches[0]).target;
                        var touchWasWithinContainer = this._wasTap && this.containerOuter.element.contains(target);
                        if (touchWasWithinContainer) {
                            var containerWasExactTarget = target === this.containerOuter.element || target === this.containerInner.element;
                            if (containerWasExactTarget) {
                                if (this._isTextElement) this.input.focus();
                                else if (this._isSelectMultipleElement) this.showDropdown();
                            }
                            // Prevents focus event firing
                            event.stopPropagation();
                        }
                        this._wasTap = true;
                    };
                    /**
   * Handles mousedown event in capture mode for containetOuter.element
   */ Choices.prototype._onMouseDown = function(event) {
                        var target = event.target;
                        if (!(target instanceof HTMLElement)) return;
                        // If we have our mouse down on the scrollbar and are on IE11...
                        if (IS_IE11 && this.choiceList.element.contains(target)) {
                            // check if click was on a scrollbar area
                            var firstChoice = this.choiceList.element.firstElementChild;
                            var isOnScrollbar = this._direction === "ltr" ? event.offsetX >= firstChoice.offsetWidth : event.offsetX < firstChoice.offsetLeft;
                            this._isScrollingOnIe = isOnScrollbar;
                        }
                        if (target === this.input.element) return;
                        var item = target.closest("[data-button],[data-item],[data-choice]");
                        if (item instanceof HTMLElement) {
                            var hasShiftKey = event.shiftKey;
                            var activeItems = this._store.activeItems;
                            var dataset = item.dataset;
                            if ("button" in dataset) this._handleButtonAction(activeItems, item);
                            else if ("item" in dataset) this._handleItemAction(activeItems, item, hasShiftKey);
                            else if ("choice" in dataset) this._handleChoiceAction(activeItems, item);
                        }
                        event.preventDefault();
                    };
                    /**
   * Handles mouseover event over this.dropdown
   * @param {MouseEvent} event
   */ Choices.prototype._onMouseOver = function(_a) {
                        var target = _a.target;
                        if (target instanceof HTMLElement && "choice" in target.dataset) this._highlightChoice(target);
                    };
                    Choices.prototype._onClick = function(_a) {
                        var target = _a.target;
                        var clickWasWithinContainer = this.containerOuter.element.contains(target);
                        if (clickWasWithinContainer) {
                            if (!this.dropdown.isActive && !this.containerOuter.isDisabled) {
                                if (this._isTextElement) {
                                    if (document.activeElement !== this.input.element) this.input.focus();
                                } else {
                                    this.showDropdown();
                                    this.containerOuter.focus();
                                }
                            } else if (this._isSelectOneElement && target !== this.input.element && !this.dropdown.element.contains(target)) this.hideDropdown();
                        } else {
                            var hasHighlightedItems = this._store.highlightedActiveItems.length > 0;
                            if (hasHighlightedItems) this.unhighlightAll();
                            this.containerOuter.removeFocusState();
                            this.hideDropdown(true);
                        }
                    };
                    Choices.prototype._onFocus = function(_a) {
                        var _b;
                        var _this = this;
                        var target = _a.target;
                        var focusWasWithinContainer = target && this.containerOuter.element.contains(target);
                        if (!focusWasWithinContainer) return;
                        var focusActions = (_b = {}, _b[constants_1.TEXT_TYPE] = function() {
                            if (target === _this.input.element) _this.containerOuter.addFocusState();
                        }, _b[constants_1.SELECT_ONE_TYPE] = function() {
                            _this.containerOuter.addFocusState();
                            if (target === _this.input.element) _this.showDropdown(true);
                        }, _b[constants_1.SELECT_MULTIPLE_TYPE] = function() {
                            if (target === _this.input.element) {
                                _this.showDropdown(true);
                                // If element is a select box, the focused element is the container and the dropdown
                                // isn't already open, focus and show dropdown
                                _this.containerOuter.addFocusState();
                            }
                        }, _b);
                        focusActions[this.passedElement.element.type]();
                    };
                    Choices.prototype._onBlur = function(_a) {
                        var _b;
                        var _this = this;
                        var target = _a.target;
                        var blurWasWithinContainer = target && this.containerOuter.element.contains(target);
                        if (blurWasWithinContainer && !this._isScrollingOnIe) {
                            var activeItems = this._store.activeItems;
                            var hasHighlightedItems_1 = activeItems.some(function(item) {
                                return item.highlighted;
                            });
                            var blurActions = (_b = {}, _b[constants_1.TEXT_TYPE] = function() {
                                if (target === _this.input.element) {
                                    _this.containerOuter.removeFocusState();
                                    if (hasHighlightedItems_1) _this.unhighlightAll();
                                    _this.hideDropdown(true);
                                }
                            }, _b[constants_1.SELECT_ONE_TYPE] = function() {
                                _this.containerOuter.removeFocusState();
                                if (target === _this.input.element || target === _this.containerOuter.element && !_this._canSearch) _this.hideDropdown(true);
                            }, _b[constants_1.SELECT_MULTIPLE_TYPE] = function() {
                                if (target === _this.input.element) {
                                    _this.containerOuter.removeFocusState();
                                    _this.hideDropdown(true);
                                    if (hasHighlightedItems_1) _this.unhighlightAll();
                                }
                            }, _b);
                            blurActions[this.passedElement.element.type]();
                        } else {
                            // On IE11, clicking the scollbar blurs our input and thus
                            // closes the dropdown. To stop this, we refocus our input
                            // if we know we are on IE *and* are scrolling.
                            this._isScrollingOnIe = false;
                            this.input.element.focus();
                        }
                    };
                    Choices.prototype._onFormReset = function() {
                        this._store.dispatch((0, misc_1.resetTo)(this._initialState));
                    };
                    Choices.prototype._highlightChoice = function(el) {
                        var _this = this;
                        if (el === void 0) el = null;
                        var choices = Array.from(this.dropdown.element.querySelectorAll("[data-choice-selectable]"));
                        if (!choices.length) return;
                        var passedEl = el;
                        var highlightedChoices = Array.from(this.dropdown.element.querySelectorAll(".".concat(this.config.classNames.highlightedState)));
                        // Remove any highlighted choices
                        highlightedChoices.forEach(function(choice) {
                            choice.classList.remove(_this.config.classNames.highlightedState);
                            choice.setAttribute("aria-selected", "false");
                        });
                        if (passedEl) this._highlightPosition = choices.indexOf(passedEl);
                        else {
                            // Highlight choice based on last known highlight location
                            if (choices.length > this._highlightPosition) // If we have an option to highlight
                            passedEl = choices[this._highlightPosition];
                            else // Otherwise highlight the option before
                            passedEl = choices[choices.length - 1];
                            if (!passedEl) passedEl = choices[0];
                        }
                        passedEl.classList.add(this.config.classNames.highlightedState);
                        passedEl.setAttribute("aria-selected", "true");
                        this.passedElement.triggerEvent(constants_1.EVENTS.highlightChoice, {
                            el: passedEl
                        });
                        if (this.dropdown.isActive) {
                            // IE11 ignores aria-label and blocks virtual keyboard
                            // if aria-activedescendant is set without a dropdown
                            this.input.setActiveDescendant(passedEl.id);
                            this.containerOuter.setActiveDescendant(passedEl.id);
                        }
                    };
                    Choices.prototype._addItem = function(_a) {
                        var value = _a.value, _b = _a.label, label = _b === void 0 ? null : _b, _c = _a.choiceId, choiceId = _c === void 0 ? -1 : _c, _d = _a.groupId, groupId = _d === void 0 ? -1 : _d, _e = _a.customProperties, customProperties = _e === void 0 ? {} : _e, _f = _a.placeholder, placeholder = _f === void 0 ? false : _f, _g = _a.keyCode, keyCode = _g === void 0 ? -1 : _g;
                        var passedValue = typeof value === "string" ? value.trim() : value;
                        var items = this._store.items;
                        var passedLabel = label || passedValue;
                        var passedOptionId = choiceId || -1;
                        var group = groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        var id = items ? items.length + 1 : 1;
                        // If a prepended value has been passed, prepend it
                        if (this.config.prependValue) passedValue = this.config.prependValue + passedValue.toString();
                        // If an appended value has been passed, append it
                        if (this.config.appendValue) passedValue += this.config.appendValue.toString();
                        this._store.dispatch((0, items_1.addItem)({
                            value: passedValue,
                            label: passedLabel,
                            id: id,
                            choiceId: passedOptionId,
                            groupId: groupId,
                            customProperties: customProperties,
                            placeholder: placeholder,
                            keyCode: keyCode
                        }));
                        if (this._isSelectOneElement) this.removeActiveItems(id);
                        // Trigger change event
                        this.passedElement.triggerEvent(constants_1.EVENTS.addItem, {
                            id: id,
                            value: passedValue,
                            label: passedLabel,
                            customProperties: customProperties,
                            groupValue: group && group.value ? group.value : null,
                            keyCode: keyCode
                        });
                    };
                    Choices.prototype._removeItem = function(item) {
                        var id = item.id, value = item.value, label = item.label, customProperties = item.customProperties, choiceId = item.choiceId, groupId = item.groupId;
                        var group = groupId && groupId >= 0 ? this._store.getGroupById(groupId) : null;
                        if (!id || !choiceId) return;
                        this._store.dispatch((0, items_1.removeItem)(id, choiceId));
                        this.passedElement.triggerEvent(constants_1.EVENTS.removeItem, {
                            id: id,
                            value: value,
                            label: label,
                            customProperties: customProperties,
                            groupValue: group && group.value ? group.value : null
                        });
                    };
                    Choices.prototype._addChoice = function(_a) {
                        var value = _a.value, _b = _a.label, label = _b === void 0 ? null : _b, _c = _a.isSelected, isSelected = _c === void 0 ? false : _c, _d = _a.isDisabled, isDisabled = _d === void 0 ? false : _d, _e = _a.groupId, groupId = _e === void 0 ? -1 : _e, _f = _a.customProperties, customProperties = _f === void 0 ? {} : _f, _g = _a.placeholder, placeholder = _g === void 0 ? false : _g, _h = _a.keyCode, keyCode = _h === void 0 ? -1 : _h;
                        if (typeof value === "undefined" || value === null) return;
                        // Generate unique id
                        var choices = this._store.choices;
                        var choiceLabel = label || value;
                        var choiceId = choices ? choices.length + 1 : 1;
                        var choiceElementId = "".concat(this._baseId, "-").concat(this._idNames.itemChoice, "-").concat(choiceId);
                        this._store.dispatch((0, choices_1.addChoice)({
                            id: choiceId,
                            groupId: groupId,
                            elementId: choiceElementId,
                            value: value,
                            label: choiceLabel,
                            disabled: isDisabled,
                            customProperties: customProperties,
                            placeholder: placeholder,
                            keyCode: keyCode
                        }));
                        if (isSelected) this._addItem({
                            value: value,
                            label: choiceLabel,
                            choiceId: choiceId,
                            customProperties: customProperties,
                            placeholder: placeholder,
                            keyCode: keyCode
                        });
                    };
                    Choices.prototype._addGroup = function(_a) {
                        var _this = this;
                        var group = _a.group, id = _a.id, _b = _a.valueKey, valueKey = _b === void 0 ? "value" : _b, _c = _a.labelKey, labelKey = _c === void 0 ? "label" : _c;
                        var groupChoices = (0, utils_1.isType)("Object", group) ? group.choices : Array.from(group.getElementsByTagName("OPTION"));
                        var groupId = id || Math.floor(new Date().valueOf() * Math.random());
                        var isDisabled = group.disabled ? group.disabled : false;
                        if (groupChoices) {
                            this._store.dispatch((0, groups_1.addGroup)({
                                value: group.label,
                                id: groupId,
                                active: true,
                                disabled: isDisabled
                            }));
                            var addGroupChoices = function(choice) {
                                var isOptDisabled = choice.disabled || choice.parentNode && choice.parentNode.disabled;
                                _this._addChoice({
                                    value: choice[valueKey],
                                    label: (0, utils_1.isType)("Object", choice) ? choice[labelKey] : choice.innerHTML,
                                    isSelected: choice.selected,
                                    isDisabled: isOptDisabled,
                                    groupId: groupId,
                                    customProperties: choice.customProperties,
                                    placeholder: choice.placeholder
                                });
                            };
                            groupChoices.forEach(addGroupChoices);
                        } else this._store.dispatch((0, groups_1.addGroup)({
                            value: group.label,
                            id: group.id,
                            active: false,
                            disabled: group.disabled
                        }));
                    };
                    Choices.prototype._getTemplate = function(template) {
                        var _a;
                        var args = [];
                        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                        return (_a = this._templates[template]).call.apply(_a, __spreadArray([
                            this,
                            this.config
                        ], args, false));
                    };
                    Choices.prototype._createTemplates = function() {
                        var callbackOnCreateTemplates = this.config.callbackOnCreateTemplates;
                        var userTemplates = {};
                        if (callbackOnCreateTemplates && typeof callbackOnCreateTemplates === "function") userTemplates = callbackOnCreateTemplates.call(this, utils_1.strToEl);
                        this._templates = (0, deepmerge_1.default)(templates_1.default, userTemplates);
                    };
                    Choices.prototype._createElements = function() {
                        this.containerOuter = new components_1.Container({
                            element: this._getTemplate("containerOuter", this._direction, this._isSelectElement, this._isSelectOneElement, this.config.searchEnabled, this.passedElement.element.type, this.config.labelId),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type,
                            position: this.config.position
                        });
                        this.containerInner = new components_1.Container({
                            element: this._getTemplate("containerInner"),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type,
                            position: this.config.position
                        });
                        this.input = new components_1.Input({
                            element: this._getTemplate("input", this._placeholderValue),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type,
                            preventPaste: !this.config.paste
                        });
                        this.choiceList = new components_1.List({
                            element: this._getTemplate("choiceList", this._isSelectOneElement)
                        });
                        this.itemList = new components_1.List({
                            element: this._getTemplate("itemList", this._isSelectOneElement)
                        });
                        this.dropdown = new components_1.Dropdown({
                            element: this._getTemplate("dropdown"),
                            classNames: this.config.classNames,
                            type: this.passedElement.element.type
                        });
                    };
                    Choices.prototype._createStructure = function() {
                        // Hide original element
                        this.passedElement.conceal();
                        // Wrap input in container preserving DOM ordering
                        this.containerInner.wrap(this.passedElement.element);
                        // Wrapper inner container with outer container
                        this.containerOuter.wrap(this.containerInner.element);
                        if (this._isSelectOneElement) this.input.placeholder = this.config.searchPlaceholderValue || "";
                        else if (this._placeholderValue) {
                            this.input.placeholder = this._placeholderValue;
                            this.input.setWidth();
                        }
                        this.containerOuter.element.appendChild(this.containerInner.element);
                        this.containerOuter.element.appendChild(this.dropdown.element);
                        this.containerInner.element.appendChild(this.itemList.element);
                        if (!this._isTextElement) this.dropdown.element.appendChild(this.choiceList.element);
                        if (!this._isSelectOneElement) this.containerInner.element.appendChild(this.input.element);
                        else if (this.config.searchEnabled) this.dropdown.element.insertBefore(this.input.element, this.dropdown.element.firstChild);
                        if (this._isSelectElement) {
                            this._highlightPosition = 0;
                            this._isSearching = false;
                            this._startLoading();
                            if (this._presetGroups.length) this._addPredefinedGroups(this._presetGroups);
                            else this._addPredefinedChoices(this._presetChoices);
                            this._stopLoading();
                        }
                        if (this._isTextElement) this._addPredefinedItems(this._presetItems);
                    };
                    Choices.prototype._addPredefinedGroups = function(groups) {
                        var _this = this;
                        // If we have a placeholder option
                        var placeholderChoice = this.passedElement.placeholderOption;
                        if (placeholderChoice && placeholderChoice.parentNode && placeholderChoice.parentNode.tagName === "SELECT") this._addChoice({
                            value: placeholderChoice.value,
                            label: placeholderChoice.innerHTML,
                            isSelected: placeholderChoice.selected,
                            isDisabled: placeholderChoice.disabled,
                            placeholder: true
                        });
                        groups.forEach(function(group) {
                            return _this._addGroup({
                                group: group,
                                id: group.id || null
                            });
                        });
                    };
                    Choices.prototype._addPredefinedChoices = function(choices) {
                        var _this = this;
                        // If sorting is enabled or the user is searching, filter choices
                        if (this.config.shouldSort) choices.sort(this.config.sorter);
                        var hasSelectedChoice = choices.some(function(choice) {
                            return choice.selected;
                        });
                        var firstEnabledChoiceIndex = choices.findIndex(function(choice) {
                            return choice.disabled === undefined || !choice.disabled;
                        });
                        choices.forEach(function(choice, index) {
                            var _a = choice.value, value = _a === void 0 ? "" : _a, label = choice.label, customProperties = choice.customProperties, placeholder = choice.placeholder;
                            if (_this._isSelectElement) {
                                // If the choice is actually a group
                                if (choice.choices) _this._addGroup({
                                    group: choice,
                                    id: choice.id || null
                                });
                                else {
                                    /**
           * If there is a selected choice already or the choice is not the first in
           * the array, add each choice normally.
           *
           * Otherwise we pre-select the first enabled choice in the array ("select-one" only)
           */ var shouldPreselect = _this._isSelectOneElement && !hasSelectedChoice && index === firstEnabledChoiceIndex;
                                    var isSelected = shouldPreselect ? true : choice.selected;
                                    var isDisabled = choice.disabled;
                                    _this._addChoice({
                                        value: value,
                                        label: label,
                                        isSelected: !!isSelected,
                                        isDisabled: !!isDisabled,
                                        placeholder: !!placeholder,
                                        customProperties: customProperties
                                    });
                                }
                            } else _this._addChoice({
                                value: value,
                                label: label,
                                isSelected: !!choice.selected,
                                isDisabled: !!choice.disabled,
                                placeholder: !!choice.placeholder,
                                customProperties: customProperties
                            });
                        });
                    };
                    Choices.prototype._addPredefinedItems = function(items) {
                        var _this = this;
                        items.forEach(function(item) {
                            if (typeof item === "object" && item.value) _this._addItem({
                                value: item.value,
                                label: item.label,
                                choiceId: item.id,
                                customProperties: item.customProperties,
                                placeholder: item.placeholder
                            });
                            if (typeof item === "string") _this._addItem({
                                value: item
                            });
                        });
                    };
                    Choices.prototype._setChoiceOrItem = function(item) {
                        var _this = this;
                        var itemType = (0, utils_1.getType)(item).toLowerCase();
                        var handleType = {
                            object: function() {
                                if (!item.value) return;
                                // If we are dealing with a select input, we need to create an option first
                                // that is then selected. For text inputs we can just add items normally.
                                if (!_this._isTextElement) _this._addChoice({
                                    value: item.value,
                                    label: item.label,
                                    isSelected: true,
                                    isDisabled: false,
                                    customProperties: item.customProperties,
                                    placeholder: item.placeholder
                                });
                                else _this._addItem({
                                    value: item.value,
                                    label: item.label,
                                    choiceId: item.id,
                                    customProperties: item.customProperties,
                                    placeholder: item.placeholder
                                });
                            },
                            string: function() {
                                if (!_this._isTextElement) _this._addChoice({
                                    value: item,
                                    label: item,
                                    isSelected: true,
                                    isDisabled: false
                                });
                                else _this._addItem({
                                    value: item
                                });
                            }
                        };
                        handleType[itemType]();
                    };
                    Choices.prototype._findAndSelectChoiceByValue = function(value) {
                        var _this = this;
                        var choices = this._store.choices;
                        // Check 'value' property exists and the choice isn't already selected
                        var foundChoice = choices.find(function(choice) {
                            return _this.config.valueComparer(choice.value, value);
                        });
                        if (foundChoice && !foundChoice.selected) this._addItem({
                            value: foundChoice.value,
                            label: foundChoice.label,
                            choiceId: foundChoice.id,
                            groupId: foundChoice.groupId,
                            customProperties: foundChoice.customProperties,
                            placeholder: foundChoice.placeholder,
                            keyCode: foundChoice.keyCode
                        });
                    };
                    Choices.prototype._generatePlaceholderValue = function() {
                        if (this._isSelectElement && this.passedElement.placeholderOption) {
                            var placeholderOption = this.passedElement.placeholderOption;
                            return placeholderOption ? placeholderOption.text : null;
                        }
                        var _a = this.config, placeholder = _a.placeholder, placeholderValue = _a.placeholderValue;
                        var dataset = this.passedElement.element.dataset;
                        if (placeholder) {
                            if (placeholderValue) return placeholderValue;
                            if (dataset.placeholder) return dataset.placeholder;
                        }
                        return null;
                    };
                    return Choices;
                }();
                exports["default"] = Choices;
            /***/ },
            /***/ 613: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var utils_1 = __webpack_require__(799);
                var constants_1 = __webpack_require__(883);
                var Container = /** @class */ function() {
                    function Container(_a) {
                        var element = _a.element, type = _a.type, classNames = _a.classNames, position = _a.position;
                        this.element = element;
                        this.classNames = classNames;
                        this.type = type;
                        this.position = position;
                        this.isOpen = false;
                        this.isFlipped = false;
                        this.isFocussed = false;
                        this.isDisabled = false;
                        this.isLoading = false;
                        this._onFocus = this._onFocus.bind(this);
                        this._onBlur = this._onBlur.bind(this);
                    }
                    Container.prototype.addEventListeners = function() {
                        this.element.addEventListener("focus", this._onFocus);
                        this.element.addEventListener("blur", this._onBlur);
                    };
                    Container.prototype.removeEventListeners = function() {
                        this.element.removeEventListener("focus", this._onFocus);
                        this.element.removeEventListener("blur", this._onBlur);
                    };
                    /**
   * Determine whether container should be flipped based on passed
   * dropdown position
   */ Container.prototype.shouldFlip = function(dropdownPos) {
                        if (typeof dropdownPos !== "number") return false;
                        // If flip is enabled and the dropdown bottom position is
                        // greater than the window height flip the dropdown.
                        var shouldFlip = false;
                        if (this.position === "auto") shouldFlip = !window.matchMedia("(min-height: ".concat(dropdownPos + 1, "px)")).matches;
                        else if (this.position === "top") shouldFlip = true;
                        return shouldFlip;
                    };
                    Container.prototype.setActiveDescendant = function(activeDescendantID) {
                        this.element.setAttribute("aria-activedescendant", activeDescendantID);
                    };
                    Container.prototype.removeActiveDescendant = function() {
                        this.element.removeAttribute("aria-activedescendant");
                    };
                    Container.prototype.open = function(dropdownPos) {
                        this.element.classList.add(this.classNames.openState);
                        this.element.setAttribute("aria-expanded", "true");
                        this.isOpen = true;
                        if (this.shouldFlip(dropdownPos)) {
                            this.element.classList.add(this.classNames.flippedState);
                            this.isFlipped = true;
                        }
                    };
                    Container.prototype.close = function() {
                        this.element.classList.remove(this.classNames.openState);
                        this.element.setAttribute("aria-expanded", "false");
                        this.removeActiveDescendant();
                        this.isOpen = false;
                        // A dropdown flips if it does not have space within the page
                        if (this.isFlipped) {
                            this.element.classList.remove(this.classNames.flippedState);
                            this.isFlipped = false;
                        }
                    };
                    Container.prototype.focus = function() {
                        if (!this.isFocussed) this.element.focus();
                    };
                    Container.prototype.addFocusState = function() {
                        this.element.classList.add(this.classNames.focusState);
                    };
                    Container.prototype.removeFocusState = function() {
                        this.element.classList.remove(this.classNames.focusState);
                    };
                    Container.prototype.enable = function() {
                        this.element.classList.remove(this.classNames.disabledState);
                        this.element.removeAttribute("aria-disabled");
                        if (this.type === constants_1.SELECT_ONE_TYPE) this.element.setAttribute("tabindex", "0");
                        this.isDisabled = false;
                    };
                    Container.prototype.disable = function() {
                        this.element.classList.add(this.classNames.disabledState);
                        this.element.setAttribute("aria-disabled", "true");
                        if (this.type === constants_1.SELECT_ONE_TYPE) this.element.setAttribute("tabindex", "-1");
                        this.isDisabled = true;
                    };
                    Container.prototype.wrap = function(element) {
                        (0, utils_1.wrap)(element, this.element);
                    };
                    Container.prototype.unwrap = function(element) {
                        if (this.element.parentNode) {
                            // Move passed element outside this element
                            this.element.parentNode.insertBefore(element, this.element);
                            // Remove this element
                            this.element.parentNode.removeChild(this.element);
                        }
                    };
                    Container.prototype.addLoadingState = function() {
                        this.element.classList.add(this.classNames.loadingState);
                        this.element.setAttribute("aria-busy", "true");
                        this.isLoading = true;
                    };
                    Container.prototype.removeLoadingState = function() {
                        this.element.classList.remove(this.classNames.loadingState);
                        this.element.removeAttribute("aria-busy");
                        this.isLoading = false;
                    };
                    Container.prototype._onFocus = function() {
                        this.isFocussed = true;
                    };
                    Container.prototype._onBlur = function() {
                        this.isFocussed = false;
                    };
                    return Container;
                }();
                exports["default"] = Container;
            /***/ },
            /***/ 217: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var Dropdown = /** @class */ function() {
                    function Dropdown(_a) {
                        var element = _a.element, type = _a.type, classNames = _a.classNames;
                        this.element = element;
                        this.classNames = classNames;
                        this.type = type;
                        this.isActive = false;
                    }
                    Object.defineProperty(Dropdown.prototype, "distanceFromTopWindow", {
                        /**
     * Bottom position of dropdown in viewport coordinates
     */ get: function() {
                            return this.element.getBoundingClientRect().bottom;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Dropdown.prototype.getChild = function(selector) {
                        return this.element.querySelector(selector);
                    };
                    /**
   * Show dropdown to user by adding active state class
   */ Dropdown.prototype.show = function() {
                        this.element.classList.add(this.classNames.activeState);
                        this.element.setAttribute("aria-expanded", "true");
                        this.isActive = true;
                        return this;
                    };
                    /**
   * Hide dropdown from user
   */ Dropdown.prototype.hide = function() {
                        this.element.classList.remove(this.classNames.activeState);
                        this.element.setAttribute("aria-expanded", "false");
                        this.isActive = false;
                        return this;
                    };
                    return Dropdown;
                }();
                exports["default"] = Dropdown;
            /***/ },
            /***/ 520: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.WrappedSelect = exports.WrappedInput = exports.List = exports.Input = exports.Container = exports.Dropdown = void 0;
                var dropdown_1 = __importDefault(__webpack_require__(217));
                exports.Dropdown = dropdown_1.default;
                var container_1 = __importDefault(__webpack_require__(613));
                exports.Container = container_1.default;
                var input_1 = __importDefault(__webpack_require__(11));
                exports.Input = input_1.default;
                var list_1 = __importDefault(__webpack_require__(624));
                exports.List = list_1.default;
                var wrapped_input_1 = __importDefault(__webpack_require__(541));
                exports.WrappedInput = wrapped_input_1.default;
                var wrapped_select_1 = __importDefault(__webpack_require__(982));
                exports.WrappedSelect = wrapped_select_1.default;
            /***/ },
            /***/ 11: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var utils_1 = __webpack_require__(799);
                var constants_1 = __webpack_require__(883);
                var Input = /** @class */ function() {
                    function Input(_a) {
                        var element = _a.element, type = _a.type, classNames = _a.classNames, preventPaste = _a.preventPaste;
                        this.element = element;
                        this.type = type;
                        this.classNames = classNames;
                        this.preventPaste = preventPaste;
                        this.isFocussed = this.element.isEqualNode(document.activeElement);
                        this.isDisabled = element.disabled;
                        this._onPaste = this._onPaste.bind(this);
                        this._onInput = this._onInput.bind(this);
                        this._onFocus = this._onFocus.bind(this);
                        this._onBlur = this._onBlur.bind(this);
                    }
                    Object.defineProperty(Input.prototype, "placeholder", {
                        set: function(placeholder) {
                            this.element.placeholder = placeholder;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Input.prototype, "value", {
                        get: function() {
                            return (0, utils_1.sanitise)(this.element.value);
                        },
                        set: function(value) {
                            this.element.value = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Input.prototype, "rawValue", {
                        get: function() {
                            return this.element.value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Input.prototype.addEventListeners = function() {
                        this.element.addEventListener("paste", this._onPaste);
                        this.element.addEventListener("input", this._onInput, {
                            passive: true
                        });
                        this.element.addEventListener("focus", this._onFocus, {
                            passive: true
                        });
                        this.element.addEventListener("blur", this._onBlur, {
                            passive: true
                        });
                    };
                    Input.prototype.removeEventListeners = function() {
                        this.element.removeEventListener("input", this._onInput);
                        this.element.removeEventListener("paste", this._onPaste);
                        this.element.removeEventListener("focus", this._onFocus);
                        this.element.removeEventListener("blur", this._onBlur);
                    };
                    Input.prototype.enable = function() {
                        this.element.removeAttribute("disabled");
                        this.isDisabled = false;
                    };
                    Input.prototype.disable = function() {
                        this.element.setAttribute("disabled", "");
                        this.isDisabled = true;
                    };
                    Input.prototype.focus = function() {
                        if (!this.isFocussed) this.element.focus();
                    };
                    Input.prototype.blur = function() {
                        if (this.isFocussed) this.element.blur();
                    };
                    Input.prototype.clear = function(setWidth) {
                        if (setWidth === void 0) setWidth = true;
                        if (this.element.value) this.element.value = "";
                        if (setWidth) this.setWidth();
                        return this;
                    };
                    /**
   * Set the correct input width based on placeholder
   * value or input value
   */ Input.prototype.setWidth = function() {
                        // Resize input to contents or placeholder
                        var _a = this.element, style = _a.style, value = _a.value, placeholder = _a.placeholder;
                        style.minWidth = "".concat(placeholder.length + 1, "ch");
                        style.width = "".concat(value.length + 1, "ch");
                    };
                    Input.prototype.setActiveDescendant = function(activeDescendantID) {
                        this.element.setAttribute("aria-activedescendant", activeDescendantID);
                    };
                    Input.prototype.removeActiveDescendant = function() {
                        this.element.removeAttribute("aria-activedescendant");
                    };
                    Input.prototype._onInput = function() {
                        if (this.type !== constants_1.SELECT_ONE_TYPE) this.setWidth();
                    };
                    Input.prototype._onPaste = function(event) {
                        if (this.preventPaste) event.preventDefault();
                    };
                    Input.prototype._onFocus = function() {
                        this.isFocussed = true;
                    };
                    Input.prototype._onBlur = function() {
                        this.isFocussed = false;
                    };
                    return Input;
                }();
                exports["default"] = Input;
            /***/ },
            /***/ 624: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var constants_1 = __webpack_require__(883);
                var List = /** @class */ function() {
                    function List(_a) {
                        var element = _a.element;
                        this.element = element;
                        this.scrollPos = this.element.scrollTop;
                        this.height = this.element.offsetHeight;
                    }
                    List.prototype.clear = function() {
                        this.element.innerHTML = "";
                    };
                    List.prototype.append = function(node) {
                        this.element.appendChild(node);
                    };
                    List.prototype.getChild = function(selector) {
                        return this.element.querySelector(selector);
                    };
                    List.prototype.hasChildren = function() {
                        return this.element.hasChildNodes();
                    };
                    List.prototype.scrollToTop = function() {
                        this.element.scrollTop = 0;
                    };
                    List.prototype.scrollToChildElement = function(element, direction) {
                        var _this = this;
                        if (!element) return;
                        var listHeight = this.element.offsetHeight;
                        // Scroll position of dropdown
                        var listScrollPosition = this.element.scrollTop + listHeight;
                        var elementHeight = element.offsetHeight;
                        // Distance from bottom of element to top of parent
                        var elementPos = element.offsetTop + elementHeight;
                        // Difference between the element and scroll position
                        var destination = direction > 0 ? this.element.scrollTop + elementPos - listScrollPosition : element.offsetTop;
                        requestAnimationFrame(function() {
                            _this._animateScroll(destination, direction);
                        });
                    };
                    List.prototype._scrollDown = function(scrollPos, strength, destination) {
                        var easing = (destination - scrollPos) / strength;
                        var distance = easing > 1 ? easing : 1;
                        this.element.scrollTop = scrollPos + distance;
                    };
                    List.prototype._scrollUp = function(scrollPos, strength, destination) {
                        var easing = (scrollPos - destination) / strength;
                        var distance = easing > 1 ? easing : 1;
                        this.element.scrollTop = scrollPos - distance;
                    };
                    List.prototype._animateScroll = function(destination, direction) {
                        var _this = this;
                        var strength = constants_1.SCROLLING_SPEED;
                        var choiceListScrollTop = this.element.scrollTop;
                        var continueAnimation = false;
                        if (direction > 0) {
                            this._scrollDown(choiceListScrollTop, strength, destination);
                            if (choiceListScrollTop < destination) continueAnimation = true;
                        } else {
                            this._scrollUp(choiceListScrollTop, strength, destination);
                            if (choiceListScrollTop > destination) continueAnimation = true;
                        }
                        if (continueAnimation) requestAnimationFrame(function() {
                            _this._animateScroll(destination, direction);
                        });
                    };
                    return List;
                }();
                exports["default"] = List;
            /***/ },
            /***/ 730: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var utils_1 = __webpack_require__(799);
                var WrappedElement = /** @class */ function() {
                    function WrappedElement(_a) {
                        var element = _a.element, classNames = _a.classNames;
                        this.element = element;
                        this.classNames = classNames;
                        if (!(element instanceof HTMLInputElement) && !(element instanceof HTMLSelectElement)) throw new TypeError("Invalid element passed");
                        this.isDisabled = false;
                    }
                    Object.defineProperty(WrappedElement.prototype, "isActive", {
                        get: function() {
                            return this.element.dataset.choice === "active";
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedElement.prototype, "dir", {
                        get: function() {
                            return this.element.dir;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedElement.prototype, "value", {
                        get: function() {
                            return this.element.value;
                        },
                        set: function(value) {
                            // you must define setter here otherwise it will be readonly property
                            this.element.value = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    WrappedElement.prototype.conceal = function() {
                        // Hide passed input
                        this.element.classList.add(this.classNames.input);
                        this.element.hidden = true;
                        // Remove element from tab index
                        this.element.tabIndex = -1;
                        // Backup original styles if any
                        var origStyle = this.element.getAttribute("style");
                        if (origStyle) this.element.setAttribute("data-choice-orig-style", origStyle);
                        this.element.setAttribute("data-choice", "active");
                    };
                    WrappedElement.prototype.reveal = function() {
                        // Reinstate passed element
                        this.element.classList.remove(this.classNames.input);
                        this.element.hidden = false;
                        this.element.removeAttribute("tabindex");
                        // Recover original styles if any
                        var origStyle = this.element.getAttribute("data-choice-orig-style");
                        if (origStyle) {
                            this.element.removeAttribute("data-choice-orig-style");
                            this.element.setAttribute("style", origStyle);
                        } else this.element.removeAttribute("style");
                        this.element.removeAttribute("data-choice");
                        // Re-assign values - this is weird, I know
                        // @todo Figure out why we need to do this
                        this.element.value = this.element.value; // eslint-disable-line no-self-assign
                    };
                    WrappedElement.prototype.enable = function() {
                        this.element.removeAttribute("disabled");
                        this.element.disabled = false;
                        this.isDisabled = false;
                    };
                    WrappedElement.prototype.disable = function() {
                        this.element.setAttribute("disabled", "");
                        this.element.disabled = true;
                        this.isDisabled = true;
                    };
                    WrappedElement.prototype.triggerEvent = function(eventType, data) {
                        (0, utils_1.dispatchEvent)(this.element, eventType, data);
                    };
                    return WrappedElement;
                }();
                exports["default"] = WrappedElement;
            /***/ },
            /***/ 541: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var wrapped_element_1 = __importDefault(__webpack_require__(730));
                var WrappedInput = /** @class */ function(_super) {
                    __extends(WrappedInput, _super);
                    function WrappedInput(_a) {
                        var element = _a.element, classNames = _a.classNames, delimiter = _a.delimiter;
                        var _this = _super.call(this, {
                            element: element,
                            classNames: classNames
                        }) || this;
                        _this.delimiter = delimiter;
                        return _this;
                    }
                    Object.defineProperty(WrappedInput.prototype, "value", {
                        get: function() {
                            return this.element.value;
                        },
                        set: function(value) {
                            this.element.setAttribute("value", value);
                            this.element.value = value;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    return WrappedInput;
                }(wrapped_element_1.default);
                exports["default"] = WrappedInput;
            /***/ },
            /***/ 982: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __extends = this && this.__extends || function() {
                    var extendStatics = function(d, b) {
                        extendStatics = Object.setPrototypeOf || ({
                            __proto__: []
                        }) instanceof Array && function(d, b) {
                            d.__proto__ = b;
                        } || function(d, b) {
                            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                        };
                        return extendStatics(d, b);
                    };
                    return function(d, b) {
                        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                        extendStatics(d, b);
                        function __() {
                            this.constructor = d;
                        }
                        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                    };
                }();
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var wrapped_element_1 = __importDefault(__webpack_require__(730));
                var WrappedSelect = /** @class */ function(_super) {
                    __extends(WrappedSelect, _super);
                    function WrappedSelect(_a) {
                        var element = _a.element, classNames = _a.classNames, template = _a.template;
                        var _this = _super.call(this, {
                            element: element,
                            classNames: classNames
                        }) || this;
                        _this.template = template;
                        return _this;
                    }
                    Object.defineProperty(WrappedSelect.prototype, "placeholderOption", {
                        get: function() {
                            return this.element.querySelector('option[value=""]') || // Backward compatibility layer for the non-standard placeholder attribute supported in older versions.
                            this.element.querySelector("option[placeholder]");
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedSelect.prototype, "optionGroups", {
                        get: function() {
                            return Array.from(this.element.getElementsByTagName("OPTGROUP"));
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(WrappedSelect.prototype, "options", {
                        get: function() {
                            return Array.from(this.element.options);
                        },
                        set: function(options) {
                            var _this = this;
                            var fragment = document.createDocumentFragment();
                            var addOptionToFragment = function(data) {
                                // Create a standard select option
                                var option = _this.template(data);
                                // Append it to fragment
                                fragment.appendChild(option);
                            };
                            // Add each list item to list
                            options.forEach(function(optionData) {
                                return addOptionToFragment(optionData);
                            });
                            this.appendDocFragment(fragment);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    WrappedSelect.prototype.appendDocFragment = function(fragment) {
                        this.element.innerHTML = "";
                        this.element.appendChild(fragment);
                    };
                    return WrappedSelect;
                }(wrapped_element_1.default);
                exports["default"] = WrappedSelect;
            /***/ },
            /***/ 883: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SCROLLING_SPEED = exports.SELECT_MULTIPLE_TYPE = exports.SELECT_ONE_TYPE = exports.TEXT_TYPE = exports.KEY_CODES = exports.ACTION_TYPES = exports.EVENTS = void 0;
                exports.EVENTS = {
                    showDropdown: "showDropdown",
                    hideDropdown: "hideDropdown",
                    change: "change",
                    choice: "choice",
                    search: "search",
                    addItem: "addItem",
                    removeItem: "removeItem",
                    highlightItem: "highlightItem",
                    highlightChoice: "highlightChoice",
                    unhighlightItem: "unhighlightItem"
                };
                exports.ACTION_TYPES = {
                    ADD_CHOICE: "ADD_CHOICE",
                    FILTER_CHOICES: "FILTER_CHOICES",
                    ACTIVATE_CHOICES: "ACTIVATE_CHOICES",
                    CLEAR_CHOICES: "CLEAR_CHOICES",
                    ADD_GROUP: "ADD_GROUP",
                    ADD_ITEM: "ADD_ITEM",
                    REMOVE_ITEM: "REMOVE_ITEM",
                    HIGHLIGHT_ITEM: "HIGHLIGHT_ITEM",
                    CLEAR_ALL: "CLEAR_ALL",
                    RESET_TO: "RESET_TO",
                    SET_IS_LOADING: "SET_IS_LOADING"
                };
                exports.KEY_CODES = {
                    BACK_KEY: 46,
                    DELETE_KEY: 8,
                    ENTER_KEY: 13,
                    A_KEY: 65,
                    ESC_KEY: 27,
                    UP_KEY: 38,
                    DOWN_KEY: 40,
                    PAGE_UP_KEY: 33,
                    PAGE_DOWN_KEY: 34
                };
                exports.TEXT_TYPE = "text";
                exports.SELECT_ONE_TYPE = "select-one";
                exports.SELECT_MULTIPLE_TYPE = "select-multiple";
                exports.SCROLLING_SPEED = 4;
            /***/ },
            /***/ 789: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.DEFAULT_CONFIG = exports.DEFAULT_CLASSNAMES = void 0;
                var utils_1 = __webpack_require__(799);
                exports.DEFAULT_CLASSNAMES = {
                    containerOuter: "choices",
                    containerInner: "choices__inner",
                    input: "choices__input",
                    inputCloned: "choices__input--cloned",
                    list: "choices__list",
                    listItems: "choices__list--multiple",
                    listSingle: "choices__list--single",
                    listDropdown: "choices__list--dropdown",
                    item: "choices__item",
                    itemSelectable: "choices__item--selectable",
                    itemDisabled: "choices__item--disabled",
                    itemChoice: "choices__item--choice",
                    placeholder: "choices__placeholder",
                    group: "choices__group",
                    groupHeading: "choices__heading",
                    button: "choices__button",
                    activeState: "is-active",
                    focusState: "is-focused",
                    openState: "is-open",
                    disabledState: "is-disabled",
                    highlightedState: "is-highlighted",
                    selectedState: "is-selected",
                    flippedState: "is-flipped",
                    loadingState: "is-loading",
                    noResults: "has-no-results",
                    noChoices: "has-no-choices"
                };
                exports.DEFAULT_CONFIG = {
                    items: [],
                    choices: [],
                    silent: false,
                    renderChoiceLimit: -1,
                    maxItemCount: -1,
                    addItems: true,
                    addItemFilter: null,
                    removeItems: true,
                    removeItemButton: false,
                    editItems: false,
                    allowHTML: true,
                    duplicateItemsAllowed: true,
                    delimiter: ",",
                    paste: true,
                    searchEnabled: true,
                    searchChoices: true,
                    searchFloor: 1,
                    searchResultLimit: 4,
                    searchFields: [
                        "label",
                        "value"
                    ],
                    position: "auto",
                    resetScrollPosition: true,
                    shouldSort: true,
                    shouldSortItems: false,
                    sorter: utils_1.sortByAlpha,
                    placeholder: true,
                    placeholderValue: null,
                    searchPlaceholderValue: null,
                    prependValue: null,
                    appendValue: null,
                    renderSelectedChoices: "auto",
                    loadingText: "Loading...",
                    noResultsText: "No results found",
                    noChoicesText: "No choices to choose from",
                    itemSelectText: "Press to select",
                    uniqueItemText: "Only unique values can be added",
                    customAddItemText: "Only values matching specific conditions can be added",
                    addItemText: function(value) {
                        return 'Press Enter to add <b>"'.concat((0, utils_1.sanitise)(value), '"</b>');
                    },
                    maxItemText: function(maxItemCount) {
                        return "Only ".concat(maxItemCount, " values can be added");
                    },
                    valueComparer: function(value1, value2) {
                        return value1 === value2;
                    },
                    fuseOptions: {
                        includeScore: true
                    },
                    labelId: "",
                    callbackOnInit: null,
                    callbackOnCreateTemplates: null,
                    classNames: exports.DEFAULT_CLASSNAMES
                };
            /***/ },
            /***/ 18: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 978: /***/ function(__unused_webpack_module, exports) {
                /* eslint-disable @typescript-eslint/no-explicit-any */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 948: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 359: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 285: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 533: /***/ function(__unused_webpack_module, exports) {
                /* eslint-disable @typescript-eslint/no-explicit-any */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 187: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    var desc = Object.getOwnPropertyDescriptor(m, k);
                    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
                        enumerable: true,
                        get: function() {
                            return m[k];
                        }
                    };
                    Object.defineProperty(o, k2, desc);
                } : function(o, m, k, k2) {
                    if (k2 === undefined) k2 = k;
                    o[k2] = m[k];
                });
                var __exportStar = this && this.__exportStar || function(m, exports) {
                    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                __exportStar(__webpack_require__(18), exports);
                __exportStar(__webpack_require__(978), exports);
                __exportStar(__webpack_require__(948), exports);
                __exportStar(__webpack_require__(359), exports);
                __exportStar(__webpack_require__(285), exports);
                __exportStar(__webpack_require__(533), exports);
                __exportStar(__webpack_require__(287), exports);
                __exportStar(__webpack_require__(132), exports);
                __exportStar(__webpack_require__(837), exports);
                __exportStar(__webpack_require__(598), exports);
                __exportStar(__webpack_require__(369), exports);
                __exportStar(__webpack_require__(37), exports);
                __exportStar(__webpack_require__(47), exports);
                __exportStar(__webpack_require__(923), exports);
                __exportStar(__webpack_require__(876), exports);
            /***/ },
            /***/ 287: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 132: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 837: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 598: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 37: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 369: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 47: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 923: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 876: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /***/ },
            /***/ 799: /***/ function(__unused_webpack_module, exports) {
                /* eslint-disable @typescript-eslint/no-explicit-any */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.parseCustomProperties = exports.diff = exports.cloneObject = exports.existsInArray = exports.dispatchEvent = exports.sortByScore = exports.sortByAlpha = exports.strToEl = exports.sanitise = exports.isScrolledIntoView = exports.getAdjacentEl = exports.wrap = exports.isType = exports.getType = exports.generateId = exports.generateChars = exports.getRandomNumber = void 0;
                var getRandomNumber = function(min, max) {
                    return Math.floor(Math.random() * (max - min) + min);
                };
                exports.getRandomNumber = getRandomNumber;
                var generateChars = function(length) {
                    return Array.from({
                        length: length
                    }, function() {
                        return (0, exports.getRandomNumber)(0, 36).toString(36);
                    }).join("");
                };
                exports.generateChars = generateChars;
                var generateId = function(element, prefix) {
                    var id = element.id || element.name && "".concat(element.name, "-").concat((0, exports.generateChars)(2)) || (0, exports.generateChars)(4);
                    id = id.replace(/(:|\.|\[|\]|,)/g, "");
                    id = "".concat(prefix, "-").concat(id);
                    return id;
                };
                exports.generateId = generateId;
                var getType = function(obj) {
                    return Object.prototype.toString.call(obj).slice(8, -1);
                };
                exports.getType = getType;
                var isType = function(type, obj) {
                    return obj !== undefined && obj !== null && (0, exports.getType)(obj) === type;
                };
                exports.isType = isType;
                var wrap = function(element, wrapper) {
                    if (wrapper === void 0) wrapper = document.createElement("div");
                    if (element.parentNode) {
                        if (element.nextSibling) element.parentNode.insertBefore(wrapper, element.nextSibling);
                        else element.parentNode.appendChild(wrapper);
                    }
                    return wrapper.appendChild(element);
                };
                exports.wrap = wrap;
                var getAdjacentEl = function(startEl, selector, direction) {
                    if (direction === void 0) direction = 1;
                    var prop = "".concat(direction > 0 ? "next" : "previous", "ElementSibling");
                    var sibling = startEl[prop];
                    while(sibling){
                        if (sibling.matches(selector)) return sibling;
                        sibling = sibling[prop];
                    }
                    return sibling;
                };
                exports.getAdjacentEl = getAdjacentEl;
                var isScrolledIntoView = function(element, parent, direction) {
                    if (direction === void 0) direction = 1;
                    if (!element) return false;
                    var isVisible;
                    if (direction > 0) // In view from bottom
                    isVisible = parent.scrollTop + parent.offsetHeight >= element.offsetTop + element.offsetHeight;
                    else // In view from top
                    isVisible = element.offsetTop >= parent.scrollTop;
                    return isVisible;
                };
                exports.isScrolledIntoView = isScrolledIntoView;
                var sanitise = function(value) {
                    if (typeof value !== "string") return value;
                    return value.replace(/&/g, "&amp;").replace(/>/g, "&gt;").replace(/</g, "&lt;").replace(/"/g, "&quot;");
                };
                exports.sanitise = sanitise;
                exports.strToEl = function() {
                    var tmpEl = document.createElement("div");
                    return function(str) {
                        var cleanedInput = str.trim();
                        tmpEl.innerHTML = cleanedInput;
                        var firldChild = tmpEl.children[0];
                        while(tmpEl.firstChild)tmpEl.removeChild(tmpEl.firstChild);
                        return firldChild;
                    };
                }();
                var sortByAlpha = function(_a, _b) {
                    var value = _a.value, _c = _a.label, label = _c === void 0 ? value : _c;
                    var value2 = _b.value, _d = _b.label, label2 = _d === void 0 ? value2 : _d;
                    return label.localeCompare(label2, [], {
                        sensitivity: "base",
                        ignorePunctuation: true,
                        numeric: true
                    });
                };
                exports.sortByAlpha = sortByAlpha;
                var sortByScore = function(a, b) {
                    var _a = a.score, scoreA = _a === void 0 ? 0 : _a;
                    var _b = b.score, scoreB = _b === void 0 ? 0 : _b;
                    return scoreA - scoreB;
                };
                exports.sortByScore = sortByScore;
                var dispatchEvent = function(element, type, customArgs) {
                    if (customArgs === void 0) customArgs = null;
                    var event = new CustomEvent(type, {
                        detail: customArgs,
                        bubbles: true,
                        cancelable: true
                    });
                    return element.dispatchEvent(event);
                };
                exports.dispatchEvent = dispatchEvent;
                var existsInArray = function(array, value, key) {
                    if (key === void 0) key = "value";
                    return array.some(function(item) {
                        if (typeof value === "string") return item[key] === value.trim();
                        return item[key] === value;
                    });
                };
                exports.existsInArray = existsInArray;
                var cloneObject = function(obj) {
                    return JSON.parse(JSON.stringify(obj));
                };
                exports.cloneObject = cloneObject;
                /**
 * Returns an array of keys present on the first but missing on the second object
 */ var diff = function(a, b) {
                    var aKeys = Object.keys(a).sort();
                    var bKeys = Object.keys(b).sort();
                    return aKeys.filter(function(i) {
                        return bKeys.indexOf(i) < 0;
                    });
                };
                exports.diff = diff;
                var parseCustomProperties = function(customProperties) {
                    if (typeof customProperties !== "undefined") try {
                        return JSON.parse(customProperties);
                    } catch (e) {
                        return customProperties;
                    }
                    return {};
                };
                exports.parseCustomProperties = parseCustomProperties;
            /***/ },
            /***/ 273: /***/ function(__unused_webpack_module, exports) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = [];
                function choices(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case "ADD_CHOICE":
                            var addChoiceAction = action;
                            var choice = {
                                id: addChoiceAction.id,
                                elementId: addChoiceAction.elementId,
                                groupId: addChoiceAction.groupId,
                                value: addChoiceAction.value,
                                label: addChoiceAction.label || addChoiceAction.value,
                                disabled: addChoiceAction.disabled || false,
                                selected: false,
                                active: true,
                                score: 9999,
                                customProperties: addChoiceAction.customProperties,
                                placeholder: addChoiceAction.placeholder || false
                            };
                            /*
          A disabled choice appears in the choice dropdown but cannot be selected
          A selected choice has been added to the passed input's value (added as an item)
          An active choice appears within the choice dropdown
        */ return __spreadArray(__spreadArray([], state, true), [
                                choice
                            ], false);
                        case "ADD_ITEM":
                            var addItemAction_1 = action;
                            // When an item is added and it has an associated choice,
                            // we want to disable it so it can't be chosen again
                            if (addItemAction_1.choiceId > -1) return state.map(function(obj) {
                                var choice = obj;
                                if (choice.id === parseInt("".concat(addItemAction_1.choiceId), 10)) choice.selected = true;
                                return choice;
                            });
                            return state;
                        case "REMOVE_ITEM":
                            var removeItemAction_1 = action;
                            // When an item is removed and it has an associated choice,
                            // we want to re-enable it so it can be chosen again
                            if (removeItemAction_1.choiceId && removeItemAction_1.choiceId > -1) return state.map(function(obj) {
                                var choice = obj;
                                if (choice.id === parseInt("".concat(removeItemAction_1.choiceId), 10)) choice.selected = false;
                                return choice;
                            });
                            return state;
                        case "FILTER_CHOICES":
                            var filterChoicesAction_1 = action;
                            return state.map(function(obj) {
                                var choice = obj;
                                // Set active state based on whether choice is
                                // within filtered results
                                choice.active = filterChoicesAction_1.results.some(function(_a) {
                                    var item = _a.item, score = _a.score;
                                    if (item.id === choice.id) {
                                        choice.score = score;
                                        return true;
                                    }
                                    return false;
                                });
                                return choice;
                            });
                        case "ACTIVATE_CHOICES":
                            var activateChoicesAction_1 = action;
                            return state.map(function(obj) {
                                var choice = obj;
                                choice.active = activateChoicesAction_1.active;
                                return choice;
                            });
                        case "CLEAR_CHOICES":
                            return exports.defaultState;
                        default:
                            return state;
                    }
                }
                exports["default"] = choices;
            /***/ },
            /***/ 871: /***/ function(__unused_webpack_module, exports) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = [];
                function groups(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case "ADD_GROUP":
                            var addGroupAction = action;
                            return __spreadArray(__spreadArray([], state, true), [
                                {
                                    id: addGroupAction.id,
                                    value: addGroupAction.value,
                                    active: addGroupAction.active,
                                    disabled: addGroupAction.disabled
                                }
                            ], false);
                        case "CLEAR_CHOICES":
                            return [];
                        default:
                            return state;
                    }
                }
                exports["default"] = groups;
            /***/ },
            /***/ 655: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                var redux_1 = __webpack_require__(791);
                var items_1 = __importDefault(__webpack_require__(52));
                var groups_1 = __importDefault(__webpack_require__(871));
                var choices_1 = __importDefault(__webpack_require__(273));
                var loading_1 = __importDefault(__webpack_require__(502));
                var utils_1 = __webpack_require__(799);
                exports.defaultState = {
                    groups: [],
                    items: [],
                    choices: [],
                    loading: false
                };
                var appReducer = (0, redux_1.combineReducers)({
                    items: items_1.default,
                    groups: groups_1.default,
                    choices: choices_1.default,
                    loading: loading_1.default
                });
                var rootReducer = function(passedState, action) {
                    var state = passedState;
                    // If we are clearing all items, groups and options we reassign
                    // state and then pass that state to our proper reducer. This isn't
                    // mutating our actual state
                    // See: http://stackoverflow.com/a/35641992
                    if (action.type === "CLEAR_ALL") state = exports.defaultState;
                    else if (action.type === "RESET_TO") return (0, utils_1.cloneObject)(action.state);
                    return appReducer(state, action);
                };
                exports["default"] = rootReducer;
            /***/ },
            /***/ 52: /***/ function(__unused_webpack_module, exports) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = [];
                function items(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case "ADD_ITEM":
                            var addItemAction = action;
                            // Add object to items array
                            var newState = __spreadArray(__spreadArray([], state, true), [
                                {
                                    id: addItemAction.id,
                                    choiceId: addItemAction.choiceId,
                                    groupId: addItemAction.groupId,
                                    value: addItemAction.value,
                                    label: addItemAction.label,
                                    active: true,
                                    highlighted: false,
                                    customProperties: addItemAction.customProperties,
                                    placeholder: addItemAction.placeholder || false,
                                    keyCode: null
                                }
                            ], false);
                            return newState.map(function(obj) {
                                var item = obj;
                                item.highlighted = false;
                                return item;
                            });
                        case "REMOVE_ITEM":
                            // Set item to inactive
                            return state.map(function(obj) {
                                var item = obj;
                                if (item.id === action.id) item.active = false;
                                return item;
                            });
                        case "HIGHLIGHT_ITEM":
                            var highlightItemAction_1 = action;
                            return state.map(function(obj) {
                                var item = obj;
                                if (item.id === highlightItemAction_1.id) item.highlighted = highlightItemAction_1.highlighted;
                                return item;
                            });
                        default:
                            return state;
                    }
                }
                exports["default"] = items;
            /***/ },
            /***/ 502: /***/ function(__unused_webpack_module, exports) {
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.defaultState = void 0;
                exports.defaultState = false;
                var general = function(state, action) {
                    if (state === void 0) state = exports.defaultState;
                    if (action === void 0) action = {};
                    switch(action.type){
                        case "SET_IS_LOADING":
                            return action.isLoading;
                        default:
                            return state;
                    }
                };
                exports["default"] = general;
            /***/ },
            /***/ 744: /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                var __spreadArray = this && this.__spreadArray || function(to, from, pack) {
                    if (pack || arguments.length === 2) {
                        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                            ar[i] = from[i];
                        }
                    }
                    return to.concat(ar || Array.prototype.slice.call(from));
                };
                var __importDefault = this && this.__importDefault || function(mod) {
                    return mod && mod.__esModule ? mod : {
                        "default": mod
                    };
                };
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                /* eslint-disable @typescript-eslint/no-explicit-any */ var redux_1 = __webpack_require__(791);
                var index_1 = __importDefault(__webpack_require__(655));
                var Store = /** @class */ function() {
                    function Store() {
                        this._store = (0, redux_1.createStore)(index_1.default, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
                    }
                    /**
   * Subscribe store to function call (wrapped Redux method)
   */ Store.prototype.subscribe = function(onChange) {
                        this._store.subscribe(onChange);
                    };
                    /**
   * Dispatch event to store (wrapped Redux method)
   */ Store.prototype.dispatch = function(action) {
                        this._store.dispatch(action);
                    };
                    Object.defineProperty(Store.prototype, "state", {
                        /**
     * Get store object (wrapping Redux method)
     */ get: function() {
                            return this._store.getState();
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "items", {
                        /**
     * Get items from store
     */ get: function() {
                            return this.state.items;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "activeItems", {
                        /**
     * Get active items from store
     */ get: function() {
                            return this.items.filter(function(item) {
                                return item.active === true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "highlightedActiveItems", {
                        /**
     * Get highlighted items from store
     */ get: function() {
                            return this.items.filter(function(item) {
                                return item.active && item.highlighted;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "choices", {
                        /**
     * Get choices from store
     */ get: function() {
                            return this.state.choices;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "activeChoices", {
                        /**
     * Get active choices from store
     */ get: function() {
                            return this.choices.filter(function(choice) {
                                return choice.active === true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "selectableChoices", {
                        /**
     * Get selectable choices from store
     */ get: function() {
                            return this.choices.filter(function(choice) {
                                return choice.disabled !== true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "searchableChoices", {
                        /**
     * Get choices that can be searched (excluding placeholders)
     */ get: function() {
                            return this.selectableChoices.filter(function(choice) {
                                return choice.placeholder !== true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "placeholderChoice", {
                        /**
     * Get placeholder choice from store
     */ get: function() {
                            return __spreadArray([], this.choices, true).reverse().find(function(choice) {
                                return choice.placeholder === true;
                            });
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "groups", {
                        /**
     * Get groups from store
     */ get: function() {
                            return this.state.groups;
                        },
                        enumerable: false,
                        configurable: true
                    });
                    Object.defineProperty(Store.prototype, "activeGroups", {
                        /**
     * Get active groups from store
     */ get: function() {
                            var _a = this, groups = _a.groups, choices = _a.choices;
                            return groups.filter(function(group) {
                                var isActive = group.active === true && group.disabled === false;
                                var hasActiveOptions = choices.some(function(choice) {
                                    return choice.active === true && choice.disabled === false;
                                });
                                return isActive && hasActiveOptions;
                            }, []);
                        },
                        enumerable: false,
                        configurable: true
                    });
                    /**
   * Get loading state from store
   */ Store.prototype.isLoading = function() {
                        return this.state.loading;
                    };
                    /**
   * Get single choice by it's ID
   */ Store.prototype.getChoiceById = function(id) {
                        return this.activeChoices.find(function(choice) {
                            return choice.id === parseInt(id, 10);
                        });
                    };
                    /**
   * Get group by group id
   */ Store.prototype.getGroupById = function(id) {
                        return this.groups.find(function(group) {
                            return group.id === id;
                        });
                    };
                    return Store;
                }();
                exports["default"] = Store;
            /***/ },
            /***/ 686: /***/ function(__unused_webpack_module, exports) {
                /**
 * Helpers to create HTML elements used by Choices
 * Can be overridden by providing `callbackOnCreateTemplates` option
 */ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                var templates = {
                    containerOuter: function(_a, dir, isSelectElement, isSelectOneElement, searchEnabled, passedElementType, labelId) {
                        var containerOuter = _a.classNames.containerOuter;
                        var div = Object.assign(document.createElement("div"), {
                            className: containerOuter
                        });
                        div.dataset.type = passedElementType;
                        if (dir) div.dir = dir;
                        if (isSelectOneElement) div.tabIndex = 0;
                        if (isSelectElement) {
                            div.setAttribute("role", searchEnabled ? "combobox" : "listbox");
                            if (searchEnabled) div.setAttribute("aria-autocomplete", "list");
                        }
                        div.setAttribute("aria-haspopup", "true");
                        div.setAttribute("aria-expanded", "false");
                        if (labelId) div.setAttribute("aria-labelledby", labelId);
                        return div;
                    },
                    containerInner: function(_a) {
                        var containerInner = _a.classNames.containerInner;
                        return Object.assign(document.createElement("div"), {
                            className: containerInner
                        });
                    },
                    itemList: function(_a, isSelectOneElement) {
                        var _b = _a.classNames, list = _b.list, listSingle = _b.listSingle, listItems = _b.listItems;
                        return Object.assign(document.createElement("div"), {
                            className: "".concat(list, " ").concat(isSelectOneElement ? listSingle : listItems)
                        });
                    },
                    placeholder: function(_a, value) {
                        var _b;
                        var allowHTML = _a.allowHTML, placeholder = _a.classNames.placeholder;
                        return Object.assign(document.createElement("div"), (_b = {
                            className: placeholder
                        }, _b[allowHTML ? "innerHTML" : "innerText"] = value, _b));
                    },
                    item: function(_a, _b, removeItemButton) {
                        var _c, _d;
                        var allowHTML = _a.allowHTML, _e = _a.classNames, item = _e.item, button = _e.button, highlightedState = _e.highlightedState, itemSelectable = _e.itemSelectable, placeholder = _e.placeholder;
                        var id = _b.id, value = _b.value, label = _b.label, customProperties = _b.customProperties, active = _b.active, disabled = _b.disabled, highlighted = _b.highlighted, isPlaceholder = _b.placeholder;
                        var div = Object.assign(document.createElement("div"), (_c = {
                            className: item
                        }, _c[allowHTML ? "innerHTML" : "innerText"] = label, _c));
                        Object.assign(div.dataset, {
                            item: "",
                            id: id,
                            value: value,
                            customProperties: customProperties
                        });
                        if (active) div.setAttribute("aria-selected", "true");
                        if (disabled) div.setAttribute("aria-disabled", "true");
                        if (isPlaceholder) div.classList.add(placeholder);
                        div.classList.add(highlighted ? highlightedState : itemSelectable);
                        if (removeItemButton) {
                            if (disabled) div.classList.remove(itemSelectable);
                            div.dataset.deletable = "";
                            /** @todo This MUST be localizable, not hardcoded! */ var REMOVE_ITEM_TEXT = "Remove item";
                            var removeButton = Object.assign(document.createElement("button"), (_d = {
                                type: "button",
                                className: button
                            }, _d[allowHTML ? "innerHTML" : "innerText"] = REMOVE_ITEM_TEXT, _d));
                            removeButton.setAttribute("aria-label", "".concat(REMOVE_ITEM_TEXT, ": '").concat(value, "'"));
                            removeButton.dataset.button = "";
                            div.appendChild(removeButton);
                        }
                        return div;
                    },
                    choiceList: function(_a, isSelectOneElement) {
                        var list = _a.classNames.list;
                        var div = Object.assign(document.createElement("div"), {
                            className: list
                        });
                        if (!isSelectOneElement) div.setAttribute("aria-multiselectable", "true");
                        div.setAttribute("role", "listbox");
                        return div;
                    },
                    choiceGroup: function(_a, _b) {
                        var _c;
                        var allowHTML = _a.allowHTML, _d = _a.classNames, group = _d.group, groupHeading = _d.groupHeading, itemDisabled = _d.itemDisabled;
                        var id = _b.id, value = _b.value, disabled = _b.disabled;
                        var div = Object.assign(document.createElement("div"), {
                            className: "".concat(group, " ").concat(disabled ? itemDisabled : "")
                        });
                        div.setAttribute("role", "group");
                        Object.assign(div.dataset, {
                            group: "",
                            id: id,
                            value: value
                        });
                        if (disabled) div.setAttribute("aria-disabled", "true");
                        div.appendChild(Object.assign(document.createElement("div"), (_c = {
                            className: groupHeading
                        }, _c[allowHTML ? "innerHTML" : "innerText"] = value, _c)));
                        return div;
                    },
                    choice: function(_a, _b, selectText) {
                        var _c;
                        var allowHTML = _a.allowHTML, _d = _a.classNames, item = _d.item, itemChoice = _d.itemChoice, itemSelectable = _d.itemSelectable, selectedState = _d.selectedState, itemDisabled = _d.itemDisabled, placeholder = _d.placeholder;
                        var id = _b.id, value = _b.value, label = _b.label, groupId = _b.groupId, elementId = _b.elementId, isDisabled = _b.disabled, isSelected = _b.selected, isPlaceholder = _b.placeholder;
                        var div = Object.assign(document.createElement("div"), (_c = {
                            id: elementId
                        }, _c[allowHTML ? "innerHTML" : "innerText"] = label, _c.className = "".concat(item, " ").concat(itemChoice), _c));
                        if (isSelected) div.classList.add(selectedState);
                        if (isPlaceholder) div.classList.add(placeholder);
                        div.setAttribute("role", groupId && groupId > 0 ? "treeitem" : "option");
                        Object.assign(div.dataset, {
                            choice: "",
                            id: id,
                            value: value,
                            selectText: selectText
                        });
                        if (isDisabled) {
                            div.classList.add(itemDisabled);
                            div.dataset.choiceDisabled = "";
                            div.setAttribute("aria-disabled", "true");
                        } else {
                            div.classList.add(itemSelectable);
                            div.dataset.choiceSelectable = "";
                        }
                        return div;
                    },
                    input: function(_a, placeholderValue) {
                        var _b = _a.classNames, input = _b.input, inputCloned = _b.inputCloned;
                        var inp = Object.assign(document.createElement("input"), {
                            type: "search",
                            name: "search_terms",
                            className: "".concat(input, " ").concat(inputCloned),
                            autocomplete: "off",
                            autocapitalize: "off",
                            spellcheck: false
                        });
                        inp.setAttribute("role", "textbox");
                        inp.setAttribute("aria-autocomplete", "list");
                        inp.setAttribute("aria-label", placeholderValue);
                        return inp;
                    },
                    dropdown: function(_a) {
                        var _b = _a.classNames, list = _b.list, listDropdown = _b.listDropdown;
                        var div = document.createElement("div");
                        div.classList.add(list, listDropdown);
                        div.setAttribute("aria-expanded", "false");
                        return div;
                    },
                    notice: function(_a, innerText, type) {
                        var _b;
                        var allowHTML = _a.allowHTML, _c = _a.classNames, item = _c.item, itemChoice = _c.itemChoice, noResults = _c.noResults, noChoices = _c.noChoices;
                        if (type === void 0) type = "";
                        var classes = [
                            item,
                            itemChoice
                        ];
                        if (type === "no-choices") classes.push(noChoices);
                        else if (type === "no-results") classes.push(noResults);
                        return Object.assign(document.createElement("div"), (_b = {}, _b[allowHTML ? "innerHTML" : "innerText"] = innerText, _b.className = classes.join(" "), _b));
                    },
                    option: function(_a) {
                        var label = _a.label, value = _a.value, customProperties = _a.customProperties, active = _a.active, disabled = _a.disabled;
                        var opt = new Option(label, value, false, active);
                        if (customProperties) opt.dataset.customProperties = "".concat(customProperties);
                        opt.disabled = !!disabled;
                        return opt;
                    }
                };
                exports["default"] = templates;
            /***/ },
            /***/ 996: /***/ function(module1) {
                var isMergeableObject = function isMergeableObject(value) {
                    return isNonNullObject(value) && !isSpecial(value);
                };
                function isNonNullObject(value) {
                    return !!value && typeof value === "object";
                }
                function isSpecial(value) {
                    var stringValue = Object.prototype.toString.call(value);
                    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || isReactElement(value);
                }
                // see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
                var canUseSymbol = typeof Symbol === "function" && Symbol.for;
                var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for("react.element") : 0xeac7;
                function isReactElement(value) {
                    return value.$$typeof === REACT_ELEMENT_TYPE;
                }
                function emptyTarget(val) {
                    return Array.isArray(val) ? [] : {};
                }
                function cloneUnlessOtherwiseSpecified(value, options) {
                    return options.clone !== false && options.isMergeableObject(value) ? deepmerge(emptyTarget(value), value, options) : value;
                }
                function defaultArrayMerge(target, source, options) {
                    return target.concat(source).map(function(element) {
                        return cloneUnlessOtherwiseSpecified(element, options);
                    });
                }
                function getMergeFunction(key, options) {
                    if (!options.customMerge) return deepmerge;
                    var customMerge = options.customMerge(key);
                    return typeof customMerge === "function" ? customMerge : deepmerge;
                }
                function getEnumerableOwnPropertySymbols(target) {
                    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
                        return target.propertyIsEnumerable(symbol);
                    }) : [];
                }
                function getKeys(target) {
                    return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target));
                }
                function propertyIsOnObject(object, property) {
                    try {
                        return property in object;
                    } catch (_) {
                        return false;
                    }
                }
                // Protects from prototype poisoning and unexpected merging up the prototype chain.
                function propertyIsUnsafe(target, key) {
                    return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
                     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
                     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
                    );
                }
                function mergeObject(target, source, options) {
                    var destination = {};
                    if (options.isMergeableObject(target)) getKeys(target).forEach(function(key) {
                        destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
                    });
                    getKeys(source).forEach(function(key) {
                        if (propertyIsUnsafe(target, key)) return;
                        if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
                        else destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
                    });
                    return destination;
                }
                function deepmerge(target, source, options) {
                    options = options || {};
                    options.arrayMerge = options.arrayMerge || defaultArrayMerge;
                    options.isMergeableObject = options.isMergeableObject || isMergeableObject;
                    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
                    // implementations can use it. The caller may not replace it.
                    options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;
                    var sourceIsArray = Array.isArray(source);
                    var targetIsArray = Array.isArray(target);
                    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
                    if (!sourceAndTargetTypesMatch) return cloneUnlessOtherwiseSpecified(source, options);
                    else if (sourceIsArray) return options.arrayMerge(target, source, options);
                    else return mergeObject(target, source, options);
                }
                deepmerge.all = function deepmergeAll(array, options) {
                    if (!Array.isArray(array)) throw new Error("first argument should be an array");
                    return array.reduce(function(prev, next) {
                        return deepmerge(prev, next, options);
                    }, {});
                };
                var deepmerge_1 = deepmerge;
                module1.exports = deepmerge_1;
            /***/ },
            /***/ 221: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                __webpack_require__.r(__webpack_exports__);
                /* harmony export */ __webpack_require__.d(__webpack_exports__, {
                    /* harmony export */ "default": function() {
                        return /* binding */ Fuse;
                    }
                });
                /**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */ function isArray(value) {
                    return !Array.isArray ? getTag(value) === "[object Array]" : Array.isArray(value);
                }
                // Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
                const INFINITY = 1 / 0;
                function baseToString(value) {
                    // Exit early for strings to avoid a performance hit in some environments.
                    if (typeof value == "string") return value;
                    let result = value + "";
                    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
                }
                function toString(value) {
                    return value == null ? "" : baseToString(value);
                }
                function isString(value) {
                    return typeof value === "string";
                }
                function isNumber(value) {
                    return typeof value === "number";
                }
                // Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
                function isBoolean(value) {
                    return value === true || value === false || isObjectLike(value) && getTag(value) == "[object Boolean]";
                }
                function isObject(value) {
                    return typeof value === "object";
                }
                // Checks if `value` is object-like.
                function isObjectLike(value) {
                    return isObject(value) && value !== null;
                }
                function isDefined(value) {
                    return value !== undefined && value !== null;
                }
                function isBlank(value) {
                    return !value.trim().length;
                }
                // Gets the `toStringTag` of `value`.
                // Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
                function getTag(value) {
                    return value == null ? value === undefined ? "[object Undefined]" : "[object Null]" : Object.prototype.toString.call(value);
                }
                const EXTENDED_SEARCH_UNAVAILABLE = "Extended search is not available";
                const INCORRECT_INDEX_TYPE = "Incorrect 'index' type";
                const LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key)=>`Invalid value for key ${key}`;
                const PATTERN_LENGTH_TOO_LARGE = (max)=>`Pattern length exceeds max of ${max}.`;
                const MISSING_KEY_PROPERTY = (name)=>`Missing ${name} property in key`;
                const INVALID_KEY_WEIGHT_VALUE = (key)=>`Property 'weight' in key '${key}' must be a positive integer`;
                const hasOwn = Object.prototype.hasOwnProperty;
                class KeyStore {
                    constructor(keys){
                        this._keys = [];
                        this._keyMap = {};
                        let totalWeight = 0;
                        keys.forEach((key)=>{
                            let obj = createKey(key);
                            totalWeight += obj.weight;
                            this._keys.push(obj);
                            this._keyMap[obj.id] = obj;
                            totalWeight += obj.weight;
                        });
                        // Normalize weights so that their sum is equal to 1
                        this._keys.forEach((key)=>{
                            key.weight /= totalWeight;
                        });
                    }
                    get(keyId) {
                        return this._keyMap[keyId];
                    }
                    keys() {
                        return this._keys;
                    }
                    toJSON() {
                        return JSON.stringify(this._keys);
                    }
                }
                function createKey(key) {
                    let path = null;
                    let id = null;
                    let src = null;
                    let weight = 1;
                    let getFn = null;
                    if (isString(key) || isArray(key)) {
                        src = key;
                        path = createKeyPath(key);
                        id = createKeyId(key);
                    } else {
                        if (!hasOwn.call(key, "name")) throw new Error(MISSING_KEY_PROPERTY("name"));
                        const name = key.name;
                        src = name;
                        if (hasOwn.call(key, "weight")) {
                            weight = key.weight;
                            if (weight <= 0) throw new Error(INVALID_KEY_WEIGHT_VALUE(name));
                        }
                        path = createKeyPath(name);
                        id = createKeyId(name);
                        getFn = key.getFn;
                    }
                    return {
                        path: path,
                        id: id,
                        weight: weight,
                        src: src,
                        getFn: getFn
                    };
                }
                function createKeyPath(key) {
                    return isArray(key) ? key : key.split(".");
                }
                function createKeyId(key) {
                    return isArray(key) ? key.join(".") : key;
                }
                function get(obj, path) {
                    let list = [];
                    let arr = false;
                    const deepGet = (obj, path, index)=>{
                        if (!isDefined(obj)) return;
                        if (!path[index]) // If there's no path left, we've arrived at the object we care about.
                        list.push(obj);
                        else {
                            let key = path[index];
                            const value = obj[key];
                            if (!isDefined(value)) return;
                            // If we're at the last value in the path, and if it's a string/number/bool,
                            // add it to the list
                            if (index === path.length - 1 && (isString(value) || isNumber(value) || isBoolean(value))) list.push(toString(value));
                            else if (isArray(value)) {
                                arr = true;
                                // Search each item in the array.
                                for(let i = 0, len = value.length; i < len; i += 1)deepGet(value[i], path, index + 1);
                            } else if (path.length) // An object. Recurse further.
                            deepGet(value, path, index + 1);
                        }
                    };
                    // Backwards compatibility (since path used to be a string)
                    deepGet(obj, isString(path) ? path.split(".") : path, 0);
                    return arr ? list : list[0];
                }
                const MatchOptions = {
                    // Whether the matches should be included in the result set. When `true`, each record in the result
                    // set will include the indices of the matched characters.
                    // These can consequently be used for highlighting purposes.
                    includeMatches: false,
                    // When `true`, the matching function will continue to the end of a search pattern even if
                    // a perfect match has already been located in the string.
                    findAllMatches: false,
                    // Minimum number of characters that must be matched before a result is considered a match
                    minMatchCharLength: 1
                };
                const BasicOptions = {
                    // When `true`, the algorithm continues searching to the end of the input even if a perfect
                    // match is found before the end of the same input.
                    isCaseSensitive: false,
                    // When true, the matching function will continue to the end of a search pattern even if
                    includeScore: false,
                    // List of properties that will be searched. This also supports nested properties.
                    keys: [],
                    // Whether to sort the result list, by score
                    shouldSort: true,
                    // Default sort function: sort by ascending score, ascending index
                    sortFn: (a, b)=>a.score === b.score ? a.idx < b.idx ? -1 : 1 : a.score < b.score ? -1 : 1
                };
                const FuzzyOptions = {
                    // Approximately where in the text is the pattern expected to be found?
                    location: 0,
                    // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
                    // (of both letters and location), a threshold of '1.0' would match anything.
                    threshold: 0.6,
                    // Determines how close the match must be to the fuzzy location (specified above).
                    // An exact letter match which is 'distance' characters away from the fuzzy location
                    // would score as a complete mismatch. A distance of '0' requires the match be at
                    // the exact location specified, a threshold of '1000' would require a perfect match
                    // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
                    distance: 100
                };
                const AdvancedOptions = {
                    // When `true`, it enables the use of unix-like search commands
                    useExtendedSearch: false,
                    // The get function to use when fetching an object's properties.
                    // The default will search nested paths *ie foo.bar.baz*
                    getFn: get,
                    // When `true`, search will ignore `location` and `distance`, so it won't matter
                    // where in the string the pattern appears.
                    // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
                    ignoreLocation: false,
                    // When `true`, the calculation for the relevance score (used for sorting) will
                    // ignore the field-length norm.
                    // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
                    ignoreFieldNorm: false,
                    // The weight to determine how much field length norm effects scoring.
                    fieldNormWeight: 1
                };
                var Config = {
                    ...BasicOptions,
                    ...MatchOptions,
                    ...FuzzyOptions,
                    ...AdvancedOptions
                };
                const SPACE = /[^ ]+/g;
                // Field-length norm: the shorter the field, the higher the weight.
                // Set to 3 decimals to reduce index size.
                function norm(weight = 1, mantissa = 3) {
                    const cache = new Map();
                    const m = Math.pow(10, mantissa);
                    return {
                        get (value) {
                            const numTokens = value.match(SPACE).length;
                            if (cache.has(numTokens)) return cache.get(numTokens);
                            // Default function is 1/sqrt(x), weight makes that variable
                            const norm = 1 / Math.pow(numTokens, 0.5 * weight);
                            // In place of `toFixed(mantissa)`, for faster computation
                            const n = parseFloat(Math.round(norm * m) / m);
                            cache.set(numTokens, n);
                            return n;
                        },
                        clear () {
                            cache.clear();
                        }
                    };
                }
                class FuseIndex {
                    constructor({ getFn: getFn = Config.getFn, fieldNormWeight: fieldNormWeight = Config.fieldNormWeight } = {}){
                        this.norm = norm(fieldNormWeight, 3);
                        this.getFn = getFn;
                        this.isCreated = false;
                        this.setIndexRecords();
                    }
                    setSources(docs = []) {
                        this.docs = docs;
                    }
                    setIndexRecords(records = []) {
                        this.records = records;
                    }
                    setKeys(keys = []) {
                        this.keys = keys;
                        this._keysMap = {};
                        keys.forEach((key, idx)=>{
                            this._keysMap[key.id] = idx;
                        });
                    }
                    create() {
                        if (this.isCreated || !this.docs.length) return;
                        this.isCreated = true;
                        // List is Array<String>
                        if (isString(this.docs[0])) this.docs.forEach((doc, docIndex)=>{
                            this._addString(doc, docIndex);
                        });
                        else // List is Array<Object>
                        this.docs.forEach((doc, docIndex)=>{
                            this._addObject(doc, docIndex);
                        });
                        this.norm.clear();
                    }
                    // Adds a doc to the end of the index
                    add(doc) {
                        const idx = this.size();
                        if (isString(doc)) this._addString(doc, idx);
                        else this._addObject(doc, idx);
                    }
                    // Removes the doc at the specified index of the index
                    removeAt(idx) {
                        this.records.splice(idx, 1);
                        // Change ref index of every subsquent doc
                        for(let i = idx, len = this.size(); i < len; i += 1)this.records[i].i -= 1;
                    }
                    getValueForItemAtKeyId(item, keyId) {
                        return item[this._keysMap[keyId]];
                    }
                    size() {
                        return this.records.length;
                    }
                    _addString(doc, docIndex) {
                        if (!isDefined(doc) || isBlank(doc)) return;
                        let record = {
                            v: doc,
                            i: docIndex,
                            n: this.norm.get(doc)
                        };
                        this.records.push(record);
                    }
                    _addObject(doc, docIndex) {
                        let record = {
                            i: docIndex,
                            $: {}
                        };
                        // Iterate over every key (i.e, path), and fetch the value at that key
                        this.keys.forEach((key, keyIndex)=>{
                            let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);
                            if (!isDefined(value)) return;
                            if (isArray(value)) {
                                let subRecords = [];
                                const stack = [
                                    {
                                        nestedArrIndex: -1,
                                        value: value
                                    }
                                ];
                                while(stack.length){
                                    const { nestedArrIndex: nestedArrIndex, value: value } = stack.pop();
                                    if (!isDefined(value)) continue;
                                    if (isString(value) && !isBlank(value)) {
                                        let subRecord = {
                                            v: value,
                                            i: nestedArrIndex,
                                            n: this.norm.get(value)
                                        };
                                        subRecords.push(subRecord);
                                    } else if (isArray(value)) value.forEach((item, k)=>{
                                        stack.push({
                                            nestedArrIndex: k,
                                            value: item
                                        });
                                    });
                                }
                                record.$[keyIndex] = subRecords;
                            } else if (isString(value) && !isBlank(value)) {
                                let subRecord = {
                                    v: value,
                                    n: this.norm.get(value)
                                };
                                record.$[keyIndex] = subRecord;
                            }
                        });
                        this.records.push(record);
                    }
                    toJSON() {
                        return {
                            keys: this.keys,
                            records: this.records
                        };
                    }
                }
                function createIndex(keys, docs, { getFn: getFn = Config.getFn, fieldNormWeight: fieldNormWeight = Config.fieldNormWeight } = {}) {
                    const myIndex = new FuseIndex({
                        getFn: getFn,
                        fieldNormWeight: fieldNormWeight
                    });
                    myIndex.setKeys(keys.map(createKey));
                    myIndex.setSources(docs);
                    myIndex.create();
                    return myIndex;
                }
                function parseIndex(data, { getFn: getFn = Config.getFn, fieldNormWeight: fieldNormWeight = Config.fieldNormWeight } = {}) {
                    const { keys: keys, records: records } = data;
                    const myIndex = new FuseIndex({
                        getFn: getFn,
                        fieldNormWeight: fieldNormWeight
                    });
                    myIndex.setKeys(keys);
                    myIndex.setIndexRecords(records);
                    return myIndex;
                }
                function computeScore$1(pattern, { errors: errors = 0, currentLocation: currentLocation = 0, expectedLocation: expectedLocation = 0, distance: distance = Config.distance, ignoreLocation: ignoreLocation = Config.ignoreLocation } = {}) {
                    const accuracy = errors / pattern.length;
                    if (ignoreLocation) return accuracy;
                    const proximity = Math.abs(expectedLocation - currentLocation);
                    if (!distance) // Dodge divide by zero error.
                    return proximity ? 1.0 : accuracy;
                    return accuracy + proximity / distance;
                }
                function convertMaskToIndices(matchmask = [], minMatchCharLength = Config.minMatchCharLength) {
                    let indices = [];
                    let start = -1;
                    let end = -1;
                    let i = 0;
                    for(let len = matchmask.length; i < len; i += 1){
                        let match = matchmask[i];
                        if (match && start === -1) start = i;
                        else if (!match && start !== -1) {
                            end = i - 1;
                            if (end - start + 1 >= minMatchCharLength) indices.push([
                                start,
                                end
                            ]);
                            start = -1;
                        }
                    }
                    // (i-1 - start) + 1 => i - start
                    if (matchmask[i - 1] && i - start >= minMatchCharLength) indices.push([
                        start,
                        i - 1
                    ]);
                    return indices;
                }
                // Machine word size
                const MAX_BITS = 32;
                function search(text, pattern, patternAlphabet, { location: location = Config.location, distance: distance = Config.distance, threshold: threshold = Config.threshold, findAllMatches: findAllMatches = Config.findAllMatches, minMatchCharLength: minMatchCharLength = Config.minMatchCharLength, includeMatches: includeMatches = Config.includeMatches, ignoreLocation: ignoreLocation = Config.ignoreLocation } = {}) {
                    if (pattern.length > MAX_BITS) throw new Error(PATTERN_LENGTH_TOO_LARGE(MAX_BITS));
                    const patternLen = pattern.length;
                    // Set starting location at beginning text and initialize the alphabet.
                    const textLen = text.length;
                    // Handle the case when location > text.length
                    const expectedLocation = Math.max(0, Math.min(location, textLen));
                    // Highest score beyond which we give up.
                    let currentThreshold = threshold;
                    // Is there a nearby exact match? (speedup)
                    let bestLocation = expectedLocation;
                    // Performance: only computer matches when the minMatchCharLength > 1
                    // OR if `includeMatches` is true.
                    const computeMatches = minMatchCharLength > 1 || includeMatches;
                    // A mask of the matches, used for building the indices
                    const matchMask = computeMatches ? Array(textLen) : [];
                    let index;
                    // Get all exact matches, here for speed up
                    while((index = text.indexOf(pattern, bestLocation)) > -1){
                        let score = computeScore$1(pattern, {
                            currentLocation: index,
                            expectedLocation: expectedLocation,
                            distance: distance,
                            ignoreLocation: ignoreLocation
                        });
                        currentThreshold = Math.min(score, currentThreshold);
                        bestLocation = index + patternLen;
                        if (computeMatches) {
                            let i = 0;
                            while(i < patternLen){
                                matchMask[index + i] = 1;
                                i += 1;
                            }
                        }
                    }
                    // Reset the best location
                    bestLocation = -1;
                    let lastBitArr = [];
                    let finalScore = 1;
                    let binMax = patternLen + textLen;
                    const mask = 1 << patternLen - 1;
                    for(let i = 0; i < patternLen; i += 1){
                        // Scan for the best match; each iteration allows for one more error.
                        // Run a binary search to determine how far from the match location we can stray
                        // at this error level.
                        let binMin = 0;
                        let binMid = binMax;
                        while(binMin < binMid){
                            const score = computeScore$1(pattern, {
                                errors: i,
                                currentLocation: expectedLocation + binMid,
                                expectedLocation: expectedLocation,
                                distance: distance,
                                ignoreLocation: ignoreLocation
                            });
                            if (score <= currentThreshold) binMin = binMid;
                            else binMax = binMid;
                            binMid = Math.floor((binMax - binMin) / 2 + binMin);
                        }
                        // Use the result from this iteration as the maximum for the next.
                        binMax = binMid;
                        let start = Math.max(1, expectedLocation - binMid + 1);
                        let finish = findAllMatches ? textLen : Math.min(expectedLocation + binMid, textLen) + patternLen;
                        // Initialize the bit array
                        let bitArr = Array(finish + 2);
                        bitArr[finish + 1] = (1 << i) - 1;
                        for(let j = finish; j >= start; j -= 1){
                            let currentLocation = j - 1;
                            let charMatch = patternAlphabet[text.charAt(currentLocation)];
                            if (computeMatches) // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
                            matchMask[currentLocation] = +!!charMatch;
                            // First pass: exact match
                            bitArr[j] = (bitArr[j + 1] << 1 | 1) & charMatch;
                            // Subsequent passes: fuzzy match
                            if (i) bitArr[j] |= (lastBitArr[j + 1] | lastBitArr[j]) << 1 | 1 | lastBitArr[j + 1];
                            if (bitArr[j] & mask) {
                                finalScore = computeScore$1(pattern, {
                                    errors: i,
                                    currentLocation: currentLocation,
                                    expectedLocation: expectedLocation,
                                    distance: distance,
                                    ignoreLocation: ignoreLocation
                                });
                                // This match will almost certainly be better than any existing match.
                                // But check anyway.
                                if (finalScore <= currentThreshold) {
                                    // Indeed it is
                                    currentThreshold = finalScore;
                                    bestLocation = currentLocation;
                                    // Already passed `loc`, downhill from here on in.
                                    if (bestLocation <= expectedLocation) break;
                                    // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
                                    start = Math.max(1, 2 * expectedLocation - bestLocation);
                                }
                            }
                        }
                        // No hope for a (better) match at greater error levels.
                        const score = computeScore$1(pattern, {
                            errors: i + 1,
                            currentLocation: expectedLocation,
                            expectedLocation: expectedLocation,
                            distance: distance,
                            ignoreLocation: ignoreLocation
                        });
                        if (score > currentThreshold) break;
                        lastBitArr = bitArr;
                    }
                    const result = {
                        isMatch: bestLocation >= 0,
                        // Count exact matches (those with a score of 0) to be "almost" exact
                        score: Math.max(0.001, finalScore)
                    };
                    if (computeMatches) {
                        const indices = convertMaskToIndices(matchMask, minMatchCharLength);
                        if (!indices.length) result.isMatch = false;
                        else if (includeMatches) result.indices = indices;
                    }
                    return result;
                }
                function createPatternAlphabet(pattern) {
                    let mask = {};
                    for(let i = 0, len = pattern.length; i < len; i += 1){
                        const char = pattern.charAt(i);
                        mask[char] = (mask[char] || 0) | 1 << len - i - 1;
                    }
                    return mask;
                }
                class BitapSearch {
                    constructor(pattern, { location: location = Config.location, threshold: threshold = Config.threshold, distance: distance = Config.distance, includeMatches: includeMatches = Config.includeMatches, findAllMatches: findAllMatches = Config.findAllMatches, minMatchCharLength: minMatchCharLength = Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = Config.isCaseSensitive, ignoreLocation: ignoreLocation = Config.ignoreLocation } = {}){
                        this.options = {
                            location: location,
                            threshold: threshold,
                            distance: distance,
                            includeMatches: includeMatches,
                            findAllMatches: findAllMatches,
                            minMatchCharLength: minMatchCharLength,
                            isCaseSensitive: isCaseSensitive,
                            ignoreLocation: ignoreLocation
                        };
                        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
                        this.chunks = [];
                        if (!this.pattern.length) return;
                        const addChunk = (pattern, startIndex)=>{
                            this.chunks.push({
                                pattern: pattern,
                                alphabet: createPatternAlphabet(pattern),
                                startIndex: startIndex
                            });
                        };
                        const len = this.pattern.length;
                        if (len > MAX_BITS) {
                            let i = 0;
                            const remainder = len % MAX_BITS;
                            const end = len - remainder;
                            while(i < end){
                                addChunk(this.pattern.substr(i, MAX_BITS), i);
                                i += MAX_BITS;
                            }
                            if (remainder) {
                                const startIndex = len - MAX_BITS;
                                addChunk(this.pattern.substr(startIndex), startIndex);
                            }
                        } else addChunk(this.pattern, 0);
                    }
                    searchIn(text) {
                        const { isCaseSensitive: isCaseSensitive, includeMatches: includeMatches } = this.options;
                        if (!isCaseSensitive) text = text.toLowerCase();
                        // Exact match
                        if (this.pattern === text) {
                            let result = {
                                isMatch: true,
                                score: 0
                            };
                            if (includeMatches) result.indices = [
                                [
                                    0,
                                    text.length - 1
                                ]
                            ];
                            return result;
                        }
                        // Otherwise, use Bitap algorithm
                        const { location: location, distance: distance, threshold: threshold, findAllMatches: findAllMatches, minMatchCharLength: minMatchCharLength, ignoreLocation: ignoreLocation } = this.options;
                        let allIndices = [];
                        let totalScore = 0;
                        let hasMatches = false;
                        this.chunks.forEach(({ pattern: pattern, alphabet: alphabet, startIndex: startIndex })=>{
                            const { isMatch: isMatch, score: score, indices: indices } = search(text, pattern, alphabet, {
                                location: location + startIndex,
                                distance: distance,
                                threshold: threshold,
                                findAllMatches: findAllMatches,
                                minMatchCharLength: minMatchCharLength,
                                includeMatches: includeMatches,
                                ignoreLocation: ignoreLocation
                            });
                            if (isMatch) hasMatches = true;
                            totalScore += score;
                            if (isMatch && indices) allIndices = [
                                ...allIndices,
                                ...indices
                            ];
                        });
                        let result = {
                            isMatch: hasMatches,
                            score: hasMatches ? totalScore / this.chunks.length : 1
                        };
                        if (hasMatches && includeMatches) result.indices = allIndices;
                        return result;
                    }
                }
                class BaseMatch {
                    constructor(pattern){
                        this.pattern = pattern;
                    }
                    static isMultiMatch(pattern) {
                        return getMatch(pattern, this.multiRegex);
                    }
                    static isSingleMatch(pattern) {
                        return getMatch(pattern, this.singleRegex);
                    }
                    search() {}
                }
                function getMatch(pattern, exp) {
                    const matches = pattern.match(exp);
                    return matches ? matches[1] : null;
                }
                // Token: 'file
                class ExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return "exact";
                    }
                    static get multiRegex() {
                        return /^="(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^=(.*)$/;
                    }
                    search(text) {
                        const isMatch = text === this.pattern;
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                this.pattern.length - 1
                            ]
                        };
                    }
                }
                // Token: !fire
                class InverseExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return "inverse-exact";
                    }
                    static get multiRegex() {
                        return /^!"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^!(.*)$/;
                    }
                    search(text) {
                        const index = text.indexOf(this.pattern);
                        const isMatch = index === -1;
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                text.length - 1
                            ]
                        };
                    }
                }
                // Token: ^file
                class PrefixExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return "prefix-exact";
                    }
                    static get multiRegex() {
                        return /^\^"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^\^(.*)$/;
                    }
                    search(text) {
                        const isMatch = text.startsWith(this.pattern);
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                this.pattern.length - 1
                            ]
                        };
                    }
                }
                // Token: !^fire
                class InversePrefixExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return "inverse-prefix-exact";
                    }
                    static get multiRegex() {
                        return /^!\^"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^!\^(.*)$/;
                    }
                    search(text) {
                        const isMatch = !text.startsWith(this.pattern);
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                text.length - 1
                            ]
                        };
                    }
                }
                // Token: .file$
                class SuffixExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return "suffix-exact";
                    }
                    static get multiRegex() {
                        return /^"(.*)"\$$/;
                    }
                    static get singleRegex() {
                        return /^(.*)\$$/;
                    }
                    search(text) {
                        const isMatch = text.endsWith(this.pattern);
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                text.length - this.pattern.length,
                                text.length - 1
                            ]
                        };
                    }
                }
                // Token: !.file$
                class InverseSuffixExactMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return "inverse-suffix-exact";
                    }
                    static get multiRegex() {
                        return /^!"(.*)"\$$/;
                    }
                    static get singleRegex() {
                        return /^!(.*)\$$/;
                    }
                    search(text) {
                        const isMatch = !text.endsWith(this.pattern);
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: [
                                0,
                                text.length - 1
                            ]
                        };
                    }
                }
                class FuzzyMatch extends BaseMatch {
                    constructor(pattern, { location: location = Config.location, threshold: threshold = Config.threshold, distance: distance = Config.distance, includeMatches: includeMatches = Config.includeMatches, findAllMatches: findAllMatches = Config.findAllMatches, minMatchCharLength: minMatchCharLength = Config.minMatchCharLength, isCaseSensitive: isCaseSensitive = Config.isCaseSensitive, ignoreLocation: ignoreLocation = Config.ignoreLocation } = {}){
                        super(pattern);
                        this._bitapSearch = new BitapSearch(pattern, {
                            location: location,
                            threshold: threshold,
                            distance: distance,
                            includeMatches: includeMatches,
                            findAllMatches: findAllMatches,
                            minMatchCharLength: minMatchCharLength,
                            isCaseSensitive: isCaseSensitive,
                            ignoreLocation: ignoreLocation
                        });
                    }
                    static get type() {
                        return "fuzzy";
                    }
                    static get multiRegex() {
                        return /^"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^(.*)$/;
                    }
                    search(text) {
                        return this._bitapSearch.searchIn(text);
                    }
                }
                // Token: 'file
                class IncludeMatch extends BaseMatch {
                    constructor(pattern){
                        super(pattern);
                    }
                    static get type() {
                        return "include";
                    }
                    static get multiRegex() {
                        return /^'"(.*)"$/;
                    }
                    static get singleRegex() {
                        return /^'(.*)$/;
                    }
                    search(text) {
                        let location = 0;
                        let index;
                        const indices = [];
                        const patternLen = this.pattern.length;
                        // Get all exact matches
                        while((index = text.indexOf(this.pattern, location)) > -1){
                            location = index + patternLen;
                            indices.push([
                                index,
                                location - 1
                            ]);
                        }
                        const isMatch = !!indices.length;
                        return {
                            isMatch: isMatch,
                            score: isMatch ? 0 : 1,
                            indices: indices
                        };
                    }
                }
                // ❗Order is important. DO NOT CHANGE.
                const searchers = [
                    ExactMatch,
                    IncludeMatch,
                    PrefixExactMatch,
                    InversePrefixExactMatch,
                    InverseSuffixExactMatch,
                    SuffixExactMatch,
                    InverseExactMatch,
                    FuzzyMatch
                ];
                const searchersLen = searchers.length;
                // Regex to split by spaces, but keep anything in quotes together
                const SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
                const OR_TOKEN = "|";
                // Return a 2D array representation of the query, for simpler parsing.
                // Example:
                // "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
                function parseQuery(pattern, options = {}) {
                    return pattern.split(OR_TOKEN).map((item)=>{
                        let query = item.trim().split(SPACE_RE).filter((item)=>item && !!item.trim());
                        let results = [];
                        for(let i = 0, len = query.length; i < len; i += 1){
                            const queryItem = query[i];
                            // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
                            let found = false;
                            let idx = -1;
                            while(!found && ++idx < searchersLen){
                                const searcher = searchers[idx];
                                let token = searcher.isMultiMatch(queryItem);
                                if (token) {
                                    results.push(new searcher(token, options));
                                    found = true;
                                }
                            }
                            if (found) continue;
                            // 2. Handle single query matches (i.e, once that are *not* quoted)
                            idx = -1;
                            while(++idx < searchersLen){
                                const searcher = searchers[idx];
                                let token = searcher.isSingleMatch(queryItem);
                                if (token) {
                                    results.push(new searcher(token, options));
                                    break;
                                }
                            }
                        }
                        return results;
                    });
                }
                // These extended matchers can return an array of matches, as opposed
                // to a singl match
                const MultiMatchSet = new Set([
                    FuzzyMatch.type,
                    IncludeMatch.type
                ]);
                /**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */ class ExtendedSearch {
                    constructor(pattern, { isCaseSensitive: isCaseSensitive = Config.isCaseSensitive, includeMatches: includeMatches = Config.includeMatches, minMatchCharLength: minMatchCharLength = Config.minMatchCharLength, ignoreLocation: ignoreLocation = Config.ignoreLocation, findAllMatches: findAllMatches = Config.findAllMatches, location: location = Config.location, threshold: threshold = Config.threshold, distance: distance = Config.distance } = {}){
                        this.query = null;
                        this.options = {
                            isCaseSensitive: isCaseSensitive,
                            includeMatches: includeMatches,
                            minMatchCharLength: minMatchCharLength,
                            findAllMatches: findAllMatches,
                            ignoreLocation: ignoreLocation,
                            location: location,
                            threshold: threshold,
                            distance: distance
                        };
                        this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
                        this.query = parseQuery(this.pattern, this.options);
                    }
                    static condition(_, options) {
                        return options.useExtendedSearch;
                    }
                    searchIn(text) {
                        const query = this.query;
                        if (!query) return {
                            isMatch: false,
                            score: 1
                        };
                        const { includeMatches: includeMatches, isCaseSensitive: isCaseSensitive } = this.options;
                        text = isCaseSensitive ? text : text.toLowerCase();
                        let numMatches = 0;
                        let allIndices = [];
                        let totalScore = 0;
                        // ORs
                        for(let i = 0, qLen = query.length; i < qLen; i += 1){
                            const searchers = query[i];
                            // Reset indices
                            allIndices.length = 0;
                            numMatches = 0;
                            // ANDs
                            for(let j = 0, pLen = searchers.length; j < pLen; j += 1){
                                const searcher = searchers[j];
                                const { isMatch: isMatch, indices: indices, score: score } = searcher.search(text);
                                if (isMatch) {
                                    numMatches += 1;
                                    totalScore += score;
                                    if (includeMatches) {
                                        const type = searcher.constructor.type;
                                        if (MultiMatchSet.has(type)) allIndices = [
                                            ...allIndices,
                                            ...indices
                                        ];
                                        else allIndices.push(indices);
                                    }
                                } else {
                                    totalScore = 0;
                                    numMatches = 0;
                                    allIndices.length = 0;
                                    break;
                                }
                            }
                            // OR condition, so if TRUE, return
                            if (numMatches) {
                                let result = {
                                    isMatch: true,
                                    score: totalScore / numMatches
                                };
                                if (includeMatches) result.indices = allIndices;
                                return result;
                            }
                        }
                        // Nothing was matched
                        return {
                            isMatch: false,
                            score: 1
                        };
                    }
                }
                const registeredSearchers = [];
                function register(...args) {
                    registeredSearchers.push(...args);
                }
                function createSearcher(pattern, options) {
                    for(let i = 0, len = registeredSearchers.length; i < len; i += 1){
                        let searcherClass = registeredSearchers[i];
                        if (searcherClass.condition(pattern, options)) return new searcherClass(pattern, options);
                    }
                    return new BitapSearch(pattern, options);
                }
                const LogicalOperator = {
                    AND: "$and",
                    OR: "$or"
                };
                const KeyType = {
                    PATH: "$path",
                    PATTERN: "$val"
                };
                const isExpression = (query)=>!!(query[LogicalOperator.AND] || query[LogicalOperator.OR]);
                const isPath = (query)=>!!query[KeyType.PATH];
                const isLeaf = (query)=>!isArray(query) && isObject(query) && !isExpression(query);
                const convertToExplicit = (query)=>({
                        [LogicalOperator.AND]: Object.keys(query).map((key)=>({
                                [key]: query[key]
                            }))
                    });
                // When `auto` is `true`, the parse function will infer and initialize and add
                // the appropriate `Searcher` instance
                function parse(query, options, { auto: auto = true } = {}) {
                    const next = (query)=>{
                        let keys = Object.keys(query);
                        const isQueryPath = isPath(query);
                        if (!isQueryPath && keys.length > 1 && !isExpression(query)) return next(convertToExplicit(query));
                        if (isLeaf(query)) {
                            const key = isQueryPath ? query[KeyType.PATH] : keys[0];
                            const pattern = isQueryPath ? query[KeyType.PATTERN] : query[key];
                            if (!isString(pattern)) throw new Error(LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key));
                            const obj = {
                                keyId: createKeyId(key),
                                pattern: pattern
                            };
                            if (auto) obj.searcher = createSearcher(pattern, options);
                            return obj;
                        }
                        let node = {
                            children: [],
                            operator: keys[0]
                        };
                        keys.forEach((key)=>{
                            const value = query[key];
                            if (isArray(value)) value.forEach((item)=>{
                                node.children.push(next(item));
                            });
                        });
                        return node;
                    };
                    if (!isExpression(query)) query = convertToExplicit(query);
                    return next(query);
                }
                // Practical scoring function
                function computeScore(results, { ignoreFieldNorm: ignoreFieldNorm = Config.ignoreFieldNorm }) {
                    results.forEach((result)=>{
                        let totalScore = 1;
                        result.matches.forEach(({ key: key, norm: norm, score: score })=>{
                            const weight = key ? key.weight : null;
                            totalScore *= Math.pow(score === 0 && weight ? Number.EPSILON : score, (weight || 1) * (ignoreFieldNorm ? 1 : norm));
                        });
                        result.score = totalScore;
                    });
                }
                function transformMatches(result, data) {
                    const matches = result.matches;
                    data.matches = [];
                    if (!isDefined(matches)) return;
                    matches.forEach((match)=>{
                        if (!isDefined(match.indices) || !match.indices.length) return;
                        const { indices: indices, value: value } = match;
                        let obj = {
                            indices: indices,
                            value: value
                        };
                        if (match.key) obj.key = match.key.src;
                        if (match.idx > -1) obj.refIndex = match.idx;
                        data.matches.push(obj);
                    });
                }
                function transformScore(result, data) {
                    data.score = result.score;
                }
                function format(results, docs, { includeMatches: includeMatches = Config.includeMatches, includeScore: includeScore = Config.includeScore } = {}) {
                    const transformers = [];
                    if (includeMatches) transformers.push(transformMatches);
                    if (includeScore) transformers.push(transformScore);
                    return results.map((result)=>{
                        const { idx: idx } = result;
                        const data = {
                            item: docs[idx],
                            refIndex: idx
                        };
                        if (transformers.length) transformers.forEach((transformer)=>{
                            transformer(result, data);
                        });
                        return data;
                    });
                }
                class Fuse {
                    constructor(docs, options = {}, index){
                        this.options = {
                            ...Config,
                            ...options
                        };
                        this.options.useExtendedSearch;
                        this._keyStore = new KeyStore(this.options.keys);
                        this.setCollection(docs, index);
                    }
                    setCollection(docs, index) {
                        this._docs = docs;
                        if (index && !(index instanceof FuseIndex)) throw new Error(INCORRECT_INDEX_TYPE);
                        this._myIndex = index || createIndex(this.options.keys, this._docs, {
                            getFn: this.options.getFn,
                            fieldNormWeight: this.options.fieldNormWeight
                        });
                    }
                    add(doc) {
                        if (!isDefined(doc)) return;
                        this._docs.push(doc);
                        this._myIndex.add(doc);
                    }
                    remove(predicate = ()=>false) {
                        const results = [];
                        for(let i = 0, len = this._docs.length; i < len; i += 1){
                            const doc = this._docs[i];
                            if (predicate(doc, i)) {
                                this.removeAt(i);
                                i -= 1;
                                len -= 1;
                                results.push(doc);
                            }
                        }
                        return results;
                    }
                    removeAt(idx) {
                        this._docs.splice(idx, 1);
                        this._myIndex.removeAt(idx);
                    }
                    getIndex() {
                        return this._myIndex;
                    }
                    search(query, { limit: limit = -1 } = {}) {
                        const { includeMatches: includeMatches, includeScore: includeScore, shouldSort: shouldSort, sortFn: sortFn, ignoreFieldNorm: ignoreFieldNorm } = this.options;
                        let results = isString(query) ? isString(this._docs[0]) ? this._searchStringList(query) : this._searchObjectList(query) : this._searchLogical(query);
                        computeScore(results, {
                            ignoreFieldNorm: ignoreFieldNorm
                        });
                        if (shouldSort) results.sort(sortFn);
                        if (isNumber(limit) && limit > -1) results = results.slice(0, limit);
                        return format(results, this._docs, {
                            includeMatches: includeMatches,
                            includeScore: includeScore
                        });
                    }
                    _searchStringList(query) {
                        const searcher = createSearcher(query, this.options);
                        const { records: records } = this._myIndex;
                        const results = [];
                        // Iterate over every string in the index
                        records.forEach(({ v: text, i: idx, n: norm })=>{
                            if (!isDefined(text)) return;
                            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
                            if (isMatch) results.push({
                                item: text,
                                idx: idx,
                                matches: [
                                    {
                                        score: score,
                                        value: text,
                                        norm: norm,
                                        indices: indices
                                    }
                                ]
                            });
                        });
                        return results;
                    }
                    _searchLogical(query) {
                        const expression = parse(query, this.options);
                        const evaluate = (node, item, idx)=>{
                            if (!node.children) {
                                const { keyId: keyId, searcher: searcher } = node;
                                const matches = this._findMatches({
                                    key: this._keyStore.get(keyId),
                                    value: this._myIndex.getValueForItemAtKeyId(item, keyId),
                                    searcher: searcher
                                });
                                if (matches && matches.length) return [
                                    {
                                        idx: idx,
                                        item: item,
                                        matches: matches
                                    }
                                ];
                                return [];
                            }
                            const res = [];
                            for(let i = 0, len = node.children.length; i < len; i += 1){
                                const child = node.children[i];
                                const result = evaluate(child, item, idx);
                                if (result.length) res.push(...result);
                                else if (node.operator === LogicalOperator.AND) return [];
                            }
                            return res;
                        };
                        const records = this._myIndex.records;
                        const resultMap = {};
                        const results = [];
                        records.forEach(({ $: item, i: idx })=>{
                            if (isDefined(item)) {
                                let expResults = evaluate(expression, item, idx);
                                if (expResults.length) {
                                    // Dedupe when adding
                                    if (!resultMap[idx]) {
                                        resultMap[idx] = {
                                            idx: idx,
                                            item: item,
                                            matches: []
                                        };
                                        results.push(resultMap[idx]);
                                    }
                                    expResults.forEach(({ matches: matches })=>{
                                        resultMap[idx].matches.push(...matches);
                                    });
                                }
                            }
                        });
                        return results;
                    }
                    _searchObjectList(query) {
                        const searcher = createSearcher(query, this.options);
                        const { keys: keys, records: records } = this._myIndex;
                        const results = [];
                        // List is Array<Object>
                        records.forEach(({ $: item, i: idx })=>{
                            if (!isDefined(item)) return;
                            let matches = [];
                            // Iterate over every key (i.e, path), and fetch the value at that key
                            keys.forEach((key, keyIndex)=>{
                                matches.push(...this._findMatches({
                                    key: key,
                                    value: item[keyIndex],
                                    searcher: searcher
                                }));
                            });
                            if (matches.length) results.push({
                                idx: idx,
                                item: item,
                                matches: matches
                            });
                        });
                        return results;
                    }
                    _findMatches({ key: key, value: value, searcher: searcher }) {
                        if (!isDefined(value)) return [];
                        let matches = [];
                        if (isArray(value)) value.forEach(({ v: text, i: idx, n: norm })=>{
                            if (!isDefined(text)) return;
                            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
                            if (isMatch) matches.push({
                                score: score,
                                key: key,
                                value: text,
                                idx: idx,
                                norm: norm,
                                indices: indices
                            });
                        });
                        else {
                            const { v: text, n: norm } = value;
                            const { isMatch: isMatch, score: score, indices: indices } = searcher.searchIn(text);
                            if (isMatch) matches.push({
                                score: score,
                                key: key,
                                value: text,
                                norm: norm,
                                indices: indices
                            });
                        }
                        return matches;
                    }
                }
                Fuse.version = "6.6.2";
                Fuse.createIndex = createIndex;
                Fuse.parseIndex = parseIndex;
                Fuse.config = Config;
                Fuse.parseQuery = parse;
                register(ExtendedSearch);
            /***/ },
            /***/ 791: /***/ function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {
                // ESM COMPAT FLAG
                __webpack_require__.r(__webpack_exports__);
                // EXPORTS
                __webpack_require__.d(__webpack_exports__, {
                    "__DO_NOT_USE__ActionTypes": function() {
                        return /* binding */ ActionTypes;
                    },
                    "applyMiddleware": function() {
                        return /* binding */ applyMiddleware;
                    },
                    "bindActionCreators": function() {
                        return /* binding */ bindActionCreators;
                    },
                    "combineReducers": function() {
                        return /* binding */ combineReducers;
                    },
                    "compose": function() {
                        return /* binding */ compose;
                    },
                    "createStore": function() {
                        return /* binding */ createStore;
                    },
                    "legacy_createStore": function() {
                        return /* binding */ legacy_createStore;
                    }
                });
                function _typeof(obj) {
                    "@babel/helpers - typeof";
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
                        return typeof obj;
                    } : function(obj) {
                        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                    }, _typeof(obj);
                }
                function _toPrimitive(input, hint) {
                    if (_typeof(input) !== "object" || input === null) return input;
                    var prim = input[Symbol.toPrimitive];
                    if (prim !== undefined) {
                        var res = prim.call(input, hint || "default");
                        if (_typeof(res) !== "object") return res;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return (hint === "string" ? String : Number)(input);
                }
                function _toPropertyKey(arg) {
                    var key = _toPrimitive(arg, "string");
                    return _typeof(key) === "symbol" ? key : String(key);
                }
                function _defineProperty(obj, key, value) {
                    key = _toPropertyKey(key);
                    if (key in obj) Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                    else obj[key] = value;
                    return obj;
                }
                function ownKeys(object, enumerableOnly) {
                    var keys = Object.keys(object);
                    if (Object.getOwnPropertySymbols) {
                        var symbols = Object.getOwnPropertySymbols(object);
                        enumerableOnly && (symbols = symbols.filter(function(sym) {
                            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
                        })), keys.push.apply(keys, symbols);
                    }
                    return keys;
                }
                function _objectSpread2(target) {
                    for(var i = 1; i < arguments.length; i++){
                        var source = null != arguments[i] ? arguments[i] : {};
                        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
                            _defineProperty(target, key, source[key]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
                            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
                        });
                    }
                    return target;
                }
                /**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function formatProdErrorMessage(code) {
                    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
                }
                // Inlined version of the `symbol-observable` polyfill
                var $$observable = function() {
                    return typeof Symbol === "function" && Symbol.observable || "@@observable";
                }();
                /**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var randomString = function randomString() {
                    return Math.random().toString(36).substring(7).split("").join(".");
                };
                var ActionTypes = {
                    INIT: "@@redux/INIT" + randomString(),
                    REPLACE: "@@redux/REPLACE" + randomString(),
                    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
                        return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
                    }
                };
                /**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function isPlainObject(obj) {
                    if (typeof obj !== "object" || obj === null) return false;
                    var proto = obj;
                    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
                    return Object.getPrototypeOf(obj) === proto;
                }
                // Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
                function miniKindOf(val) {
                    if (val === void 0) return "undefined";
                    if (val === null) return "null";
                    var type = typeof val;
                    switch(type){
                        case "boolean":
                        case "string":
                        case "number":
                        case "symbol":
                        case "function":
                            return type;
                    }
                    if (Array.isArray(val)) return "array";
                    if (isDate(val)) return "date";
                    if (isError(val)) return "error";
                    var constructorName = ctorName(val);
                    switch(constructorName){
                        case "Symbol":
                        case "Promise":
                        case "WeakMap":
                        case "WeakSet":
                        case "Map":
                        case "Set":
                            return constructorName;
                    } // other
                    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
                }
                function ctorName(val) {
                    return typeof val.constructor === "function" ? val.constructor.name : null;
                }
                function isError(val) {
                    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
                }
                function isDate(val) {
                    if (val instanceof Date) return true;
                    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
                }
                function kindOf(val) {
                    var typeOfVal = typeof val;
                    return typeOfVal;
                }
                /**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function createStore(reducer, preloadedState, enhancer) {
                    var _ref2;
                    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error(formatProdErrorMessage(0));
                    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
                        enhancer = preloadedState;
                        preloadedState = undefined;
                    }
                    if (typeof enhancer !== "undefined") {
                        if (typeof enhancer !== "function") throw new Error(formatProdErrorMessage(1));
                        return enhancer(createStore)(reducer, preloadedState);
                    }
                    if (typeof reducer !== "function") throw new Error(formatProdErrorMessage(2));
                    var currentReducer = reducer;
                    var currentState = preloadedState;
                    var currentListeners = [];
                    var nextListeners = currentListeners;
                    var isDispatching = false;
                    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
                        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
                    }
                    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
                        if (isDispatching) throw new Error(formatProdErrorMessage(3));
                        return currentState;
                    }
                    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
                        if (typeof listener !== "function") throw new Error(formatProdErrorMessage(4));
                        if (isDispatching) throw new Error(formatProdErrorMessage(5));
                        var isSubscribed = true;
                        ensureCanMutateNextListeners();
                        nextListeners.push(listener);
                        return function unsubscribe() {
                            if (!isSubscribed) return;
                            if (isDispatching) throw new Error(formatProdErrorMessage(6));
                            isSubscribed = false;
                            ensureCanMutateNextListeners();
                            var index = nextListeners.indexOf(listener);
                            nextListeners.splice(index, 1);
                            currentListeners = null;
                        };
                    }
                    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
                        if (!isPlainObject(action)) throw new Error(formatProdErrorMessage(7));
                        if (typeof action.type === "undefined") throw new Error(formatProdErrorMessage(8));
                        if (isDispatching) throw new Error(formatProdErrorMessage(9));
                        try {
                            isDispatching = true;
                            currentState = currentReducer(currentState, action);
                        } finally{
                            isDispatching = false;
                        }
                        var listeners = currentListeners = nextListeners;
                        for(var i = 0; i < listeners.length; i++){
                            var listener = listeners[i];
                            listener();
                        }
                        return action;
                    }
                    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
                        if (typeof nextReducer !== "function") throw new Error(formatProdErrorMessage(10));
                        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
                        // Any reducers that existed in both the new and old rootReducer
                        // will receive the previous state. This effectively populates
                        // the new state tree with any relevant data from the old one.
                        dispatch({
                            type: ActionTypes.REPLACE
                        });
                    }
                    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
                        var _ref;
                        var outerSubscribe = subscribe;
                        return _ref = {
                            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                                if (typeof observer !== "object" || observer === null) throw new Error(formatProdErrorMessage(11));
                                function observeState() {
                                    if (observer.next) observer.next(getState());
                                }
                                observeState();
                                var unsubscribe = outerSubscribe(observeState);
                                return {
                                    unsubscribe: unsubscribe
                                };
                            }
                        }, _ref[$$observable] = function() {
                            return this;
                        }, _ref;
                    } // When a store is created, an "INIT" action is dispatched so that every
                    // reducer returns their initial state. This effectively populates
                    // the initial state tree.
                    dispatch({
                        type: ActionTypes.INIT
                    });
                    return _ref2 = {
                        dispatch: dispatch,
                        subscribe: subscribe,
                        getState: getState,
                        replaceReducer: replaceReducer
                    }, _ref2[$$observable] = observable, _ref2;
                }
                /**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var legacy_createStore = createStore;
                /**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function warning(message) {
                    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
                    /* eslint-enable no-console */ try {
                        // This error was thrown as a convenience so that if you enable
                        // "break on all exceptions" in your console,
                        // it would pause the execution at this line.
                        throw new Error(message);
                    } catch (e) {} // eslint-disable-line no-empty
                }
                function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
                    var reducerKeys = Object.keys(reducers);
                    var argumentName = action && action.type === ActionTypes.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
                    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
                    if (!isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
                    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
                        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
                    });
                    unexpectedKeys.forEach(function(key) {
                        unexpectedKeyCache[key] = true;
                    });
                    if (action && action.type === ActionTypes.REPLACE) return;
                    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
                }
                function assertReducerShape(reducers) {
                    Object.keys(reducers).forEach(function(key) {
                        var reducer = reducers[key];
                        var initialState = reducer(undefined, {
                            type: ActionTypes.INIT
                        });
                        if (typeof initialState === "undefined") throw new Error(formatProdErrorMessage(12));
                        if (typeof reducer(undefined, {
                            type: ActionTypes.PROBE_UNKNOWN_ACTION()
                        }) === "undefined") throw new Error(formatProdErrorMessage(13));
                    });
                }
                /**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function combineReducers(reducers) {
                    var reducerKeys = Object.keys(reducers);
                    var finalReducers = {};
                    for(var i = 0; i < reducerKeys.length; i++){
                        var key = reducerKeys[i];
                        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
                    }
                    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
                    // keys multiple times.
                    var unexpectedKeyCache;
                    var shapeAssertionError;
                    try {
                        assertReducerShape(finalReducers);
                    } catch (e) {
                        shapeAssertionError = e;
                    }
                    return function combination(state, action) {
                        if (state === void 0) state = {};
                        if (shapeAssertionError) throw shapeAssertionError;
                        var warningMessage;
                        var hasChanged = false;
                        var nextState = {};
                        for(var _i = 0; _i < finalReducerKeys.length; _i++){
                            var _key = finalReducerKeys[_i];
                            var reducer = finalReducers[_key];
                            var previousStateForKey = state[_key];
                            var nextStateForKey = reducer(previousStateForKey, action);
                            if (typeof nextStateForKey === "undefined") {
                                var actionType = action && action.type;
                                throw new Error(formatProdErrorMessage(14));
                            }
                            nextState[_key] = nextStateForKey;
                            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
                        }
                        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
                        return hasChanged ? nextState : state;
                    };
                }
                function bindActionCreator(actionCreator, dispatch) {
                    return function() {
                        return dispatch(actionCreator.apply(this, arguments));
                    };
                }
                /**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function bindActionCreators(actionCreators, dispatch) {
                    if (typeof actionCreators === "function") return bindActionCreator(actionCreators, dispatch);
                    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error(formatProdErrorMessage(16));
                    var boundActionCreators = {};
                    for(var key in actionCreators){
                        var actionCreator = actionCreators[key];
                        if (typeof actionCreator === "function") boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
                    }
                    return boundActionCreators;
                }
                /**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function compose() {
                    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
                    if (funcs.length === 0) return function(arg) {
                        return arg;
                    };
                    if (funcs.length === 1) return funcs[0];
                    return funcs.reduce(function(a, b) {
                        return function() {
                            return a(b.apply(void 0, arguments));
                        };
                    });
                }
                /**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function applyMiddleware() {
                    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
                    return function(createStore) {
                        return function() {
                            var store = createStore.apply(void 0, arguments);
                            var _dispatch = function dispatch() {
                                throw new Error(formatProdErrorMessage(15));
                            };
                            var middlewareAPI = {
                                getState: store.getState,
                                dispatch: function dispatch() {
                                    return _dispatch.apply(void 0, arguments);
                                }
                            };
                            var chain = middlewares.map(function(middleware) {
                                return middleware(middlewareAPI);
                            });
                            _dispatch = compose.apply(void 0, chain)(store.dispatch);
                            return _objectSpread2(_objectSpread2({}, store), {}, {
                                dispatch: _dispatch
                            });
                        };
                    };
                }
                /*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */ function isCrushed() {}
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/compat get default export */ /******/ !function() {
            /******/ // getDefaultExport function for compatibility with non-harmony modules
            /******/ __webpack_require__.n = function(module1) {
                /******/ var getter = module1 && module1.__esModule ? /******/ function() {
                    return module1["default"];
                } : /******/ function() {
                    return module1;
                };
                /******/ __webpack_require__.d(getter, {
                    a: getter
                });
                /******/ return getter;
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/define property getters */ /******/ !function() {
            /******/ // define getter functions for harmony exports
            /******/ __webpack_require__.d = function(exports, definition) {
                /******/ for(var key in definition)/******/ if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) /******/ Object.defineProperty(exports, key, {
                    enumerable: true,
                    get: definition[key]
                });
            /******/ };
        /******/ }();
        /******/ /******/ /* webpack/runtime/hasOwnProperty shorthand */ /******/ !function() {
            /******/ __webpack_require__.o = function(obj, prop) {
                return Object.prototype.hasOwnProperty.call(obj, prop);
            };
        /******/ }();
        /******/ /******/ /* webpack/runtime/make namespace object */ /******/ !function() {
            /******/ // define __esModule on exports
            /******/ __webpack_require__.r = function(exports) {
                /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                    value: "Module"
                });
                /******/ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
            /******/ };
        /******/ }();
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
        !function() {
            /* harmony import */ var _scripts_choices__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(373);
            /* harmony import */ var _scripts_choices__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(_scripts_choices__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _scripts_interfaces__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(187);
            /* harmony import */ var _scripts_interfaces__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(_scripts_interfaces__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _scripts_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);
            /* harmony import */ var _scripts_defaults__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(789);
            /* harmony import */ var _scripts_templates__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(686);
            /* harmony default export */ __webpack_exports__["default"] = _scripts_choices__WEBPACK_IMPORTED_MODULE_0___default();
        }();
        __webpack_exports__ = __webpack_exports__["default"];
        /******/ return __webpack_exports__;
    /******/ }();
});




let $003ff03f477e680c$var$bookingTypeDropdown;
const $003ff03f477e680c$var$defaultOptions = {
    allowHTML: false,
    itemSelectText: "",
    searchEnabled: false,
    shouldSort: false
};
const $003ff03f477e680c$export$ba5e5b5a4ca3ce0c = (widget)=>{
    const element = widget.querySelector(".ig-dmn__booking-type-filter-dropdown");
    if (element) {
        const options = {
            ...$003ff03f477e680c$var$defaultOptions,
            labelId: "Booking Type Category Filter Dropdown",
            placeholder: false
        };
        const choices = new (0, (/*@__PURE__*/$parcel$interopDefault($c5eccf4247c91eed$exports)))(element, options);
        // Add a change event listener to filter the booking types on change
        element.addEventListener("change", (event)=>{
            const category = event.detail.value;
            (0, $bde3b974cc47c9fd$export$5bd7387d413ca6f4)(category);
        }, false);
        return choices;
    }
};



const $bde3b974cc47c9fd$export$ca52c79ee00d63e7 = async (widget, bookingTypes, type)=>{
    if (type === "Specific") {
        const bookingTypeId = widget.getAttribute("data-booking-type-id");
        const filteredTypesArray = [];
        let bookingTypeCat;
        // Create a new array which just contains the id and name for the specific booking type
        bookingTypes.forEach((bookingType)=>{
            if (bookingType.id === bookingTypeId) {
                filteredTypesArray.push({
                    id: bookingType.id,
                    name: bookingType.name
                });
                bookingTypeCat = $bde3b974cc47c9fd$var$getCategoryFromName(bookingType.name);
            }
        });
        const filteredTypes = $bde3b974cc47c9fd$var$categorizeArray(filteredTypesArray, bookingTypeCat);
        return filteredTypes;
    } else {
        // Create a new array which just contains the id and name for each booking type
        const filteredTypesArray = bookingTypes.map((type)=>{
            return {
                id: type.id,
                name: type.name
            };
        });
        // Categorise the above array
        const filteredTypes = $bde3b974cc47c9fd$var$categorizeArray(filteredTypesArray, type);
        return filteredTypes;
    }
};
const $bde3b974cc47c9fd$var$getCategoryFromName = (fullName)=>{
    // Split the name of the item using '_' as the separator
    const nameArr = fullName.split("_");
    return nameArr[0];
};
const $bde3b974cc47c9fd$export$98f06c4eeebe0b65 = (fullName)=>{
    // Split the name of the item using '_' as the separator
    const [category, subcategory, name] = fullName.split("_");
    return name ? `${subcategory} ${name}` : subcategory;
};
const $bde3b974cc47c9fd$var$categorizeArray = (inputArray, type)=>{
    // Initialize an empty object to store the categorized items
    const result = {};
    // Iterate through each item in the input array
    inputArray.forEach((item)=>{
        // Split the name of the item using '_' as the separator
        const [category, subcategory, name] = item.name.split("_");
        // Only carry on if the category matches the type given
        if (category === type) {
            // Determine the category name based on whether a subcategory is present
            const categoryName = name ? subcategory : category;
            // If the category does not exist in the result object, create an empty array for it
            if (!result[categoryName]) result[categoryName] = [];
            // Create a new item with the desired structure
            const newItem = {
                id: item.id,
                name: name ? name : subcategory
            };
            // Add the new item to the corresponding category in the result object
            result[categoryName].push(newItem);
        }
    });
    // Return the final result object
    return result;
};
const $bde3b974cc47c9fd$export$86d02590a16a49fd = async (bookingTypes, type)=>{
    let formData = new FormData();
    formData.append("type", type);
    formData.append("booking_types", JSON.stringify(bookingTypes));
    formData.append("action", "getBookingTypesHtml");
    const response = await fetch(igniteDmnJsVars.ajaxUrl, {
        method: "POST",
        body: formData
    });
    if (!response.ok) throw new Error(`[${response.status}] ${response.statusText}`);
    const bookingTypesHTML = await response.json();
    return bookingTypesHTML;
};
const $bde3b974cc47c9fd$export$904c957131a01a24 = (widget)=>{
    const tabs = widget.querySelectorAll(".ig-dmn__booking-type-filter-tab");
    if (tabs) tabs.forEach((tab)=>{
        tab.addEventListener("click", (event)=>{
            event.preventDefault();
            (0, $cc943cf31e795207$export$56525cbb1fcd885c)(widget);
            const category = tab.getAttribute("data-booking-type-category");
            // Update the active tab
            $bde3b974cc47c9fd$var$updateActiveTab(widget, tab);
            // Filter the booking types based ont he category selected
            $bde3b974cc47c9fd$export$5bd7387d413ca6f4(widget, category);
            setTimeout(()=>{
                (0, $cc943cf31e795207$export$5cee2c2772922923)(widget);
            }, 400);
        });
    });
    // Initialize the choices.js instance for the booking type filter dropdwon
    (0, $003ff03f477e680c$export$ba5e5b5a4ca3ce0c)(widget);
};
const $bde3b974cc47c9fd$var$updateActiveTab = (widget, tab)=>{
    const tabs = widget.querySelectorAll(".ig-dmn__booking-type-filter-tab");
    // Remove the active class from all tabs
    tabs.forEach((filterTab)=>{
        filterTab.classList.remove("active");
    });
    // Add the active class to the tab that was clicked
    tab.classList.add("active");
};
const $bde3b974cc47c9fd$export$5bd7387d413ca6f4 = (widget, category)=>{
    const bookingForm = widget.querySelector(".ig-dmn__booking-form");
    const bookingTypes = widget.querySelectorAll(".ig-dmn__booking-type-trigger");
    // Remove any active offers
    $6ab8eb33d1de4787$export$dff0f9677dbdb644(null);
    // Clear the booking form
    (0, $f817778a02e4b83a$export$6f32389b44e79c4d)(widget);
    // Hide the booking form
    bookingForm.classList.add("hidden");
    // Hide the offers section
    widget.querySelector(".ig-dmn__offers").classList.add("hidden");
    // Reset the booking type data
    $bde3b974cc47c9fd$var$setBookingTypeData(widget).then(()=>{
        // Hide the offers section
        widget.querySelector(".ig-dmn__offers").classList.add("hidden");
        if (bookingTypes) {
            bookingTypes.forEach((type)=>{
                const bookingTypeCat = type.getAttribute("data-category");
                if (bookingTypeCat === category) // Show the bookingType
                type.classList.remove("!hidden");
                else // Hide the bookingType
                type.classList.add("!hidden");
            });
            // Clear the active class from any booking types
            bookingTypes.forEach((type)=>{
                // Remove the active class from all booking types
                type.classList.remove("active");
                // Revert the select text back to select for all booking types
                type.querySelector(".ig-dmn__booking-type-select").innerHTML = "Select";
            });
        }
    });
};
const $bde3b974cc47c9fd$export$6d4ad9ac3284536d = (widget, venueId = null)=>{
    const triggers = widget.querySelectorAll(".ig-dmn__booking-type-trigger");
    if (triggers) triggers.forEach((trigger)=>{
        trigger.addEventListener("click", (event)=>{
            event.preventDefault();
            if (!event.target.classList.contains("ig-dmn__booking-type-vtour-icon") && !event.target.classList.contains("ig-dmn__booking-type-vtour-icon-wrapper")) {
                // Only run if the virtual tour icon isn't clicked
                const bookingTypeId = trigger.getAttribute("data-booking-type-id");
                (0, $cc943cf31e795207$export$56525cbb1fcd885c)(widget);
                // Set the booking type data
                $bde3b974cc47c9fd$var$setBookingTypeData(widget, bookingTypeId, venueId).then(()=>{
                    // Show/hide the form disclaimer
                    (0, $f817778a02e4b83a$export$a2e7c1fc61117ddd)(widget, bookingTypeId);
                    // Show the booking form and navigation
                    (0, $f817778a02e4b83a$export$a17c92b831a60ed2)(widget);
                    // Scroll the widget down to the booking form
                    (0, $4aa70e6322f04d6f$export$187631d3cc65a5c3)(widget, ".ig-dmn__booking-form");
                    setTimeout(()=>{
                        (0, $cc943cf31e795207$export$5cee2c2772922923)(widget);
                    }, 400);
                });
                triggers.forEach((trig)=>{
                    // Remove the active class from all booking types
                    trig.classList.remove("active");
                    // Revert the select text back to select for all booking types
                    trig.querySelector(".ig-dmn__booking-type-select").innerHTML = "Select";
                });
                // Add the active class to the booking type selected
                trigger.classList.add("active");
                // Update the select text to say selected on the selected booking type
                trigger.querySelector(".ig-dmn__booking-type-select").innerHTML = "Selected";
            }
        });
    });
};
const $bde3b974cc47c9fd$var$setBookingTypeData = async (widget, bookingTypeId = null, venueId = null)=>{
    let bookingVenueId = venueId;
    if (bookingVenueId == null) bookingVenueId = $6ab8eb33d1de4787$export$54eca3721020c605("venue")._id;
    // Store the bookingType in localStorage
    $6ab8eb33d1de4787$export$f8ec9f12bd4a3e45(bookingTypeId);
    // Update the form bookingType value
    widget.querySelector(".ig-dmn__form-dmn-type").value = bookingTypeId;
    // Get any offers that are available
    await (0, $8f528785e5628694$export$e558ebf3c711c0e3)(widget, bookingVenueId).then((offers)=>{
        (0, $236d893478cc0ae9$export$c925ae8f8414d3e7)(widget, offers);
    });
    // Hide the deposit section
    (0, $24588bd5abad6871$export$d8a437c87f927f7)(widget);
    // Reset the nav button visibility/state
    (0, $24eadea78386e142$export$4c212154abb8b633)(widget);
};
const $bde3b974cc47c9fd$export$174a3933f2ecb932 = (bookingTypeId)=>{
    const bookingType = $6ab8eb33d1de4787$export$4cc47fe0ce792f33(bookingTypeId);
    const nameArr = bookingType.name.split("_");
    return nameArr[0];
};











const $d3be021a89f42c3f$export$e71745bb8ca1eaa9 = async (widget, bookingDetails)=>{
    const env = (0, $cc943cf31e795207$export$42d1a34989af9d5c)(widget);
    // If the widget is using the test environment for the formType to use the API
    const formType = env === "test" ? "api" : bookingDetails.formType;
    const formData = new FormData();
    formData.append("submit_type", formType);
    formData.append("action", "getCustomerDetailsFormHtml");
    if (formType === "web") {
        // Need to proeed with the web route so return the iframe yrl for this.
        const stylesheet = `&stylesheet=${igniteDmnJsVars.stylesheet}`;
        const returnUrl = `&return_url=${igniteDmnJsVars.returnUrl}`;
        const iframeUrl = `${$6ab8eb33d1de4787$export$54eca3721020c605("bookingDetails").url}${stylesheet}${returnUrl}`;
        const validatedIframeUrl = (0, $4aa70e6322f04d6f$export$427d387d87736bfd)(iframeUrl);
        // Load the DMN Booking URL directly if the debug URL parameter equals true
        if ((0, $4aa70e6322f04d6f$export$e60f3efd19f0b6f1)("debug-dmn") && (0, $4aa70e6322f04d6f$export$37c42e52ae3e39ff)("debug-dmn") === "true") window.location.href = validatedIframeUrl;
        formData.append("iframe_url", validatedIframeUrl);
    } else {
        // Grab the activeOffer from localStorage if set
        const offer = $6ab8eb33d1de4787$export$54eca3721020c605("activeOffer");
        // Get any packages avialable
        const packages = await (0, $8967bc42bf098e48$export$c7e818e6afe71b1a)();
        // Get the marketing preferences
        const marketingPreferences = await (0, $8967bc42bf098e48$export$7109cb6850612023)();
        // Get the booking policy from the booking rules
        const bookingRules = await (0, $4633da21d666e450$export$c2afb403ff7aee9a)(widget);
        const bookingPolicy = bookingRules.booking_notes;
        // Check if DOB is required for this booking type
        const bookingType = $6ab8eb33d1de4787$export$4cc47fe0ce792f33();
        const typeOfBooking = (0, $bde3b974cc47c9fd$export$174a3933f2ecb932)(bookingType.id) === "Occasions" ? "space_booking_" : "table_booking_";
        // Append form data with values we've just got
        formData.append("offer", offer);
        formData.append("packages", JSON.stringify(packages));
        if (bookingType.dob_required) formData.append("dob", true);
        formData.append("marketing_preferences", JSON.stringify(marketingPreferences));
        formData.append("booking_policy", bookingPolicy);
        formData.append("type_of_booking", typeOfBooking);
        // Add the booking details to the form data
        Object.entries(bookingDetails).forEach(([key, value])=>{
            formData.append(key, value);
        });
    }
    const formHTML = await (0, $551afe4eb57f5422$export$6fb38195a7366394)(formData);
    return formHTML;
};


const $e626bb069be7ce59$export$2935a9f5dd5ca99d = async (bookingDetails)=>{
    const bookingTypeDetails = $6ab8eb33d1de4787$export$4cc47fe0ce792f33();
    const bookingType = (0, $bde3b974cc47c9fd$export$98f06c4eeebe0b65)(bookingTypeDetails.name);
    const peopleText = bookingDetails.num_people === 1 ? "person" : "people";
    const description = `You are making a ${bookingType} booking for ${bookingDetails.num_people} ${peopleText} at ${bookingDetails.time} on ${(0, $4aa70e6322f04d6f$export$f132f811af620c86)(bookingDetails.date)}`;
    return description;
};
const $e626bb069be7ce59$export$d25ba62a45f0c44d = async function(widget) {
    const bookingDetails = $6ab8eb33d1de4787$export$54eca3721020c605("bookingDetails");
    const formHTML = await (0, $d3be021a89f42c3f$export$e71745bb8ca1eaa9)(widget, bookingDetails);
    await (0, $4aa70e6322f04d6f$export$ce85b5fea1553a6)(widget, ".ig-dmn__inner", formHTML);
    const bookingDescription = await $e626bb069be7ce59$export$2935a9f5dd5ca99d(bookingDetails);
    await (0, $4aa70e6322f04d6f$export$ce85b5fea1553a6)(widget, ".ig-dmn__details-booking-description-text", bookingDescription);
};
const $e626bb069be7ce59$export$36d6e057347bc8b7 = (widget)=>{
    const form = widget.querySelector(".ig-dmn__details-form");
    const env = (0, $cc943cf31e795207$export$42d1a34989af9d5c)(widget);
    form.addEventListener("submit", (event)=>{
        event.preventDefault();
        // Show the loader
        (0, $cc943cf31e795207$export$56525cbb1fcd885c)(widget);
        const errorElem = form.querySelector(".ig-dmn-form-error");
        // Clear any active error messages
        errorElem.classList.add("hidden");
        const isValid = (0, $4aa70e6322f04d6f$export$5fa1f25e8ff4f893)(form);
        if (isValid) {
            // Check if DOB is set to be required and update the hidden field if so
            if (form.querySelector(".ig-dmn__form-dates")) {
                const day = form.querySelector(".ig-dmn__form-dob-day").value;
                const month = form.querySelector(".ig-dmn__form-dob-month").value;
                const year = form.querySelector(".ig-dmn__form-dob-year").value;
                const dob = `${year}-${month}-${day}`;
                form.querySelector(".ig-dmn__form-dob").value = dob;
            }
            // Run the submitBooking function
            (0, $3590469e1f0cdfd9$export$85e58a4b0352fe9b)(env, form).then((booking)=>{
                // Scroll to the top of the widget
                (0, $4aa70e6322f04d6f$export$f09c14f15f5542d7)(widget);
                // Show the bookingComplete modal
                (0, $63daabb835e29093$export$8e2d697d9c0c7e4c)(widget, booking).then(()=>{
                    setTimeout(()=>{
                        (0, $cc943cf31e795207$export$5cee2c2772922923)(widget);
                    }, 400);
                });
            });
        } else {
            // Show the error message
            errorElem.classList.remove("hidden");
            // Hide the loader
            (0, $cc943cf31e795207$export$5cee2c2772922923)(widget);
        }
    });
};








const $906c409909cbde01$export$187869b0a24f024a = async (widget, type, filter = true, venueId = null)=>{
    let formData = new FormData();
    formData.append("data_type", "all");
    formData.append("action", "getBookingTypes");
    if (venueId != null) formData.append("venueID", venueId);
    (0, $4aa70e6322f04d6f$export$3c293e733be50c44)("Getting booking types from DMN - https://api.designmynight.com/v4/venues/VENUE_ID?fields=booking_types");
    const allBookingTypes = await (0, $551afe4eb57f5422$export$6fb38195a7366394)(formData);
    (0, $4aa70e6322f04d6f$export$3c293e733be50c44)("Booking Types:");
    (0, $4aa70e6322f04d6f$export$3c293e733be50c44)(allBookingTypes);
    if (filter) return await (0, $bde3b974cc47c9fd$export$ca52c79ee00d63e7)(widget, allBookingTypes, type);
    else return allBookingTypes;
};















const $4f8b5d4736d6e0ea$export$388a3290071db3b2 = ()=>{
    const allDurations = (0, $6ab8eb33d1de4787$export$54eca3721020c605)("validation")?.validation?.duration?.suggestedValues;
    const durations = allDurations ? allDurations.filter((duration)=>duration.valid).map((duration)=>(0, $4aa70e6322f04d6f$export$9cabd011967ef036)(duration)) : [];
    return {
        type: (0, $6ab8eb33d1de4787$export$54eca3721020c605)("bookingType"),
        venueId: (0, $6ab8eb33d1de4787$export$54eca3721020c605)("venue")._id,
        durations: durations
    };
};
const $4f8b5d4736d6e0ea$export$e8c8ac35210f7ba0 = async ()=>{
    const bookingTypeDetails = (0, $6ab8eb33d1de4787$export$4cc47fe0ce792f33)();
    const bookingDetails = (0, $6ab8eb33d1de4787$export$80824bcdfa204e75)();
    const bookingType = (0, $bde3b974cc47c9fd$export$98f06c4eeebe0b65)(bookingTypeDetails.name);
    const numPeople = bookingDetails.num_people;
    const peopleText = numPeople === 1 ? "person" : "people";
    const time = bookingDetails.time;
    const date = (0, $4aa70e6322f04d6f$export$f132f811af620c86)(bookingDetails.date);
    const description = `You are making a ${bookingType} enquiry for ${numPeople} ${peopleText} at ${time} on ${date}`;
    return description;
};
const $4f8b5d4736d6e0ea$export$65bd5e8197dc700d = (widget)=>{
    const form = widget.querySelector(".ig-dmn__details-form");
    const env = (0, $cc943cf31e795207$export$42d1a34989af9d5c)(widget);
    form.addEventListener("submit", (event)=>{
        event.preventDefault();
        // Show the loader
        (0, $cc943cf31e795207$export$56525cbb1fcd885c)(widget);
        const errorElem = form.querySelector(".ig-dmn-form-error");
        // Clear any active error messages
        errorElem.classList.add("hidden");
        const isValid = (0, $4aa70e6322f04d6f$export$5fa1f25e8ff4f893)(form);
        if (isValid) {
            // Check if DOB is set to be required and update the hidden field if so
            if (form.querySelector(".ig-dmn__form-dates")) {
                const day = form.querySelector(".ig-dmn__form-dob-day").value;
                const month = form.querySelector(".ig-dmn__form-dob-month").value;
                const year = form.querySelector(".ig-dmn__form-dob-year").value;
                const dob = `${year}-${month}-${day}`;
                form.querySelector(".ig-dmn__form-dob").value = dob;
            }
            // Run the submitBooking function
            (0, $3590469e1f0cdfd9$export$85e58a4b0352fe9b)(env, form).then((booking)=>{
                // Scroll to the top of the widget
                (0, $4aa70e6322f04d6f$export$f09c14f15f5542d7)(widget);
                // Show the bookingComplete modal
                (0, $63daabb835e29093$export$8e2d697d9c0c7e4c)(widget, booking).then(()=>{
                    setTimeout(()=>{
                        (0, $cc943cf31e795207$export$5cee2c2772922923)(widget);
                    }, 400);
                });
            });
        } else {
            // Show the error message
            errorElem.classList.remove("hidden");
            // Hide the loader
            (0, $cc943cf31e795207$export$5cee2c2772922923)(widget);
        }
    });
};


const $a8373d788e05a866$export$c6e648fdd52b8d01 = async (widget, bookingForm)=>{
    // Get the booking rules
    const bookingRules = await (0, $4633da21d666e450$export$c2afb403ff7aee9a)(widget);
    // Get any existing details
    const exisitngDetails = $a8373d788e05a866$var$getExisitngDetails();
    // Get the enquiryDetails
    const enquiryDetails = (0, $4f8b5d4736d6e0ea$export$388a3290071db3b2)();
    // Get any packages avialable
    const packages = await (0, $8967bc42bf098e48$export$c7e818e6afe71b1a)();
    // Get the marketing preferences
    const marketingPreferences = await (0, $8967bc42bf098e48$export$7109cb6850612023)();
    // Get the booking policy from the booking rules
    const bookingPolicy = bookingRules.booking_notes;
    // Check if DOB is required for this booking type
    const bookingType = (0, $6ab8eb33d1de4787$export$4cc47fe0ce792f33)();
    const typeOfBooking = (0, $bde3b974cc47c9fd$export$174a3933f2ecb932)(bookingType.id) === "Occasions" ? "space_booking_" : "table_booking_";
    const formData = new FormData();
    formData.append("existing_details", JSON.stringify(exisitngDetails));
    formData.append("type", enquiryDetails.type);
    formData.append("durations", JSON.stringify(enquiryDetails.durations));
    formData.append("packages", JSON.stringify(packages));
    if (bookingType.dob_required) formData.append("dob", true);
    formData.append("marketing_preferences", JSON.stringify(marketingPreferences));
    formData.append("booking_policy", bookingPolicy);
    formData.append("type_of_booking", typeOfBooking);
    formData.append("action", "getEnquiryFormHtml");
    const formHTML = await (0, $551afe4eb57f5422$export$6fb38195a7366394)(formData);
    await (0, $4aa70e6322f04d6f$export$ce85b5fea1553a6)(widget, ".ig-dmn__inner", formHTML);
    const enquiryDescription = await (0, $4f8b5d4736d6e0ea$export$e8c8ac35210f7ba0)();
    await (0, $4aa70e6322f04d6f$export$ce85b5fea1553a6)(widget, ".ig-dmn__details-booking-description-text", enquiryDescription);
};
const $a8373d788e05a866$var$getExisitngDetails = ()=>{
    const bookingDetails = (0, $6ab8eb33d1de4787$export$80824bcdfa204e75)();
    const dateVal = bookingDetails.date;
    const numPeopleVal = bookingDetails.num_people;
    const timeVal = bookingDetails.time;
    const exisitngDetails = {
        date: dateVal !== "" ? dateVal : null,
        numPeople: numPeopleVal !== "" ? numPeopleVal : null,
        time: timeVal !== "" ? timeVal : null
    };
    return exisitngDetails;
};





const $047c4079eb3e54aa$export$8591b008baf26a22 = (widget)=>{
    const triggers = widget.querySelectorAll(".ig-dmn__vtour-trigger");
    if (triggers) triggers.forEach((trigger)=>{
        trigger.addEventListener("click", (event)=>{
            event.preventDefault();
            // Get the bookingTypeId from the trigger
            const bookingType = trigger.getAttribute("data-booking-type-id");
            (0, $63daabb835e29093$export$e9c0f5cb968f2933)(widget, bookingType);
        });
    });
};






const $e04935feec114dfb$export$cf0c82adb864946b = async (venues, venuesAttr)=>{
    let filteredVenues;
    if (venuesAttr === "all") // Create a new array which just contains the id and name for each venue
    filteredVenues = venues.map((venue)=>{
        return {
            id: venue._id,
            name: venue.title,
            city: venue.city
        };
    });
    else {
        const venuesAtrrArray = venuesAttr.split(",");
        filteredVenues = [];
        // Create a new array which just contains the id and name for the specific booking type
        venues.forEach((venue)=>{
            if (venuesAtrrArray.includes(venue._id)) {
                const venueData = {
                    id: venue._id,
                    name: venue.title,
                    city: venue.city
                };
                filteredVenues.push(venueData);
            }
        });
    }
    return filteredVenues;
};
const $e04935feec114dfb$export$b45eadf0967f2cb2 = (widget)=>{
    const triggers = widget.querySelectorAll(".ig-dmn__venue-trigger");
    if (triggers) triggers.forEach((trigger)=>{
        trigger.addEventListener("click", (event)=>{
            event.preventDefault();
            const venueId = trigger.getAttribute("data-venue-id");
            // Update the eidget venue-id attribute
            widget.setAttribute("data-venue-id", venueId);
            //Update local storage with selected venue data
            (0, $6ab8eb33d1de4787$export$f772d4644e06847e)((0, $8967bc42bf098e48$export$8a22be7c64085dc6)(venueId));
            // Go to the booking types stage
            (0, $c5a626aad556a640$export$f5f00fdbfdfc6331)(widget);
        });
    });
};


const $e7f63d4942215d36$export$9489c8872de5c6e1 = async (venuesAttr)=>{
    const formData = new FormData();
    formData.append("action", "getVenues");
    const allVenues = await (0, $551afe4eb57f5422$export$6fb38195a7366394)(formData);
    const venues = await (0, $e04935feec114dfb$export$cf0c82adb864946b)(allVenues, venuesAttr);
    return venues;
};



const $b22069c041a4c1c8$export$9801e2f7ff15e97f = async (venues)=>{
    const formData = new FormData();
    formData.append("venues", JSON.stringify(venues));
    formData.append("action", "getVenuesHtml");
    const venuesHtml = await (0, $551afe4eb57f5422$export$6fb38195a7366394)(formData);
    return venuesHtml;
};



const $c5a626aad556a640$export$12ed1233ac55ca66 = async (widget)=>{
    // Reset the venue-id attribute
    widget.setAttribute("data-venue-id", "");
    const venuesAttr = widget.getAttribute("data-venues");
    // Show the loader
    (0, $cc943cf31e795207$export$56525cbb1fcd885c)(widget);
    // Reset bookingData
    $6ab8eb33d1de4787$export$aea372fef393a613(widget, true);
    // Update the booking stage indicator
    $c5a626aad556a640$export$8af7eced0ccd8df7(widget, "venue");
    // Init the stages triggers
    $c5a626aad556a640$export$42635dc7b0945433(widget);
    // Get all the venue groups venues
    const venues = await (0, $e7f63d4942215d36$export$9489c8872de5c6e1)(venuesAttr);
    const venuesHtml = await (0, $b22069c041a4c1c8$export$9801e2f7ff15e97f)(venues);
    // display the HTML
    (0, $4aa70e6322f04d6f$export$ce85b5fea1553a6)(widget, ".ig-dmn__inner", venuesHtml);
    setTimeout(()=>{
        // Hide the loader elem
        (0, $cc943cf31e795207$export$5cee2c2772922923)(widget);
        // Enable the venueTriggers
        (0, $e04935feec114dfb$export$b45eadf0967f2cb2)(widget);
        // Run the initNavButtons function
        (0, $24eadea78386e142$export$faea57be7a472670)(widget);
    }, 400);
};
const $c5a626aad556a640$export$f5f00fdbfdfc6331 = async (widget)=>{
    // Show the loader
    (0, $cc943cf31e795207$export$56525cbb1fcd885c)(widget);
    // Get the venue ID that the booking is being made for
    const venueId = widget.getAttribute("data-venue-id");
    const type = (0, $cc943cf31e795207$export$43dc4e2240cb354f)(widget);
    // Reset bookingData
    $6ab8eb33d1de4787$export$aea372fef393a613(widget);
    // Update the booking stage indicator
    $c5a626aad556a640$export$8af7eced0ccd8df7(widget, "type");
    // Init the stages triggers
    $c5a626aad556a640$export$42635dc7b0945433(widget);
    // Get the booking types for this venue
    (0, $906c409909cbde01$export$187869b0a24f024a)(widget, type, true, venueId).then((bookingTypes)=>{
        (0, $bde3b974cc47c9fd$export$86d02590a16a49fd)(bookingTypes, type).then((bookingTypesHTML)=>{
            // display the HTML
            (0, $4aa70e6322f04d6f$export$ce85b5fea1553a6)(widget, ".ig-dmn__inner", bookingTypesHTML);
            setTimeout(()=>{
                // Hide the loader elem
                (0, $cc943cf31e795207$export$5cee2c2772922923)(widget);
                // Initialize the bookingTypeFilters
                (0, $bde3b974cc47c9fd$export$904c957131a01a24)(widget);
                // Enable the bookingTypeTriggers
                (0, $bde3b974cc47c9fd$export$6d4ad9ac3284536d)(widget, venueId);
                // Enable the virtual tour triggers
                (0, $047c4079eb3e54aa$export$8591b008baf26a22)(widget);
                // Run the initOffersModal function
                (0, $63daabb835e29093$export$1c9503703a5621c0)(widget);
                // Run the initNavButtons function
                (0, $24eadea78386e142$export$faea57be7a472670)(widget);
            }, 400);
        });
    });
};
const $c5a626aad556a640$export$8e024081af2f7115 = async (widget)=>{
    const env = (0, $cc943cf31e795207$export$42d1a34989af9d5c)(widget);
    const bookingDetails = $6ab8eb33d1de4787$export$54eca3721020c605("bookingDetails");
    // If the widget is using the test environment for the formType to use the API
    const formType = env === "test" ? "api" : bookingDetails.formType;
    // Get the HTML for the booking details page
    await (0, $e626bb069be7ce59$export$d25ba62a45f0c44d)(widget).then(()=>{
        if (formType === "api") // Call the details form submit function
        (0, $e626bb069be7ce59$export$36d6e057347bc8b7)(widget);
        else {
            const iframe = widget.querySelector(".ig-dmn__form-iframe");
        // iframe.onload = helpers.resizeIframe(iframe);
        }
        // Update the booking stage indicator
        $c5a626aad556a640$export$8af7eced0ccd8df7(widget, "details");
        // Call the initStageTriggers function
        $c5a626aad556a640$export$42635dc7b0945433(widget);
    });
};
const $c5a626aad556a640$export$d8289a28872b9c1b = async (widget)=>{
    const bookingForm = widget.querySelector(".ig-dmn__booking-form");
    // Load in the HTML for the enquiry form
    await (0, $a8373d788e05a866$export$c6e648fdd52b8d01)(widget, bookingForm).then(()=>{
        // Re-initialize the calendar
        // initCalendar(widget, 'details');
        // Call the details form submit function
        (0, $4f8b5d4736d6e0ea$export$65bd5e8197dc700d)(widget);
        // Update the booking stage indicator
        $c5a626aad556a640$export$8af7eced0ccd8df7(widget, "details");
        // Call the initStageTriggers function
        $c5a626aad556a640$export$42635dc7b0945433(widget);
    });
};
const $c5a626aad556a640$export$ae2dff29da9c2d50 = async (widget, stage)=>{
    if (stage === "details") // initialize the details stage
    await $c5a626aad556a640$export$8e024081af2f7115(widget);
    if (stage === "enquire") // Initialize the enquiry stage
    await $c5a626aad556a640$export$d8289a28872b9c1b(widget);
};
const $c5a626aad556a640$export$42635dc7b0945433 = (widget)=>{
    const triggers = document.querySelectorAll(".ig-dmn__stage-section-trigger.past");
    if (triggers) triggers.forEach((trigger)=>{
        trigger.addEventListener("click", (event)=>{
            event.preventDefault();
            const stage = trigger.getAttribute("data-stage");
            stage;
            if (stage === "venue") $c5a626aad556a640$export$12ed1233ac55ca66(widget);
            if (stage === "type") $c5a626aad556a640$export$f5f00fdbfdfc6331(widget);
        });
    });
};
const $c5a626aad556a640$export$8af7eced0ccd8df7 = (widget, stage)=>{
    const stages = widget.querySelectorAll(".ig-dmn__stages-stage");
    // Loop through and remove the past and active classes from each stage element
    if (stages) stages.forEach((stage)=>{
        stage.classList.remove("active");
        stage.classList.remove("past");
    });
    stage;
    if (stage === "venue") {
        // Add the past class to the reservations stage
        widget.querySelector('.ig-dmn__stages-stage[data-stage="reservation"]').classList.add("past");
        // Add the active class to the venue stage
        widget.querySelector('.ig-dmn__stages-stage[data-stage="venue"]').classList.add("active");
    }
    if (stage === "type") {
        // Add the past class to the reservations and venue stage
        widget.querySelector('.ig-dmn__stages-stage[data-stage="reservation"]').classList.add("past");
        if (widget.querySelector('.ig-dmn__stages-stage[data-stage="venue"]')) widget.querySelector('.ig-dmn__stages-stage[data-stage="venue"]').classList.add("past");
        // Add the active class to the type stage
        widget.querySelector('.ig-dmn__stages-stage[data-stage="type"]').classList.add("active");
    }
    if (stage === "details" || stage === "enquire") {
        // Add the past class to the reservations, venue and type stages
        widget.querySelector('.ig-dmn__stages-stage[data-stage="reservation"]').classList.add("past");
        if (widget.querySelector('.ig-dmn__stages-stage[data-stage="venue"]')) widget.querySelector('.ig-dmn__stages-stage[data-stage="venue"]').classList.add("past");
        widget.querySelector('.ig-dmn__stages-stage[data-stage="type"]').classList.add("past");
        // Add the active class to the details booking stage
        widget.querySelector('.ig-dmn__stages-stage[data-stage="details"]').classList.add("active");
    }
};



const $2bc80c769f6bcd82$var$widgetElems = document.querySelectorAll(".ig-dmn");
if ($2bc80c769f6bcd82$var$widgetElems) // Initialise the booking types stage for each widget
$2bc80c769f6bcd82$var$widgetElems.forEach((widget)=>{
    // Check if we should load the venues stage or the booking type stage
    const initStage = widget.getAttribute("data-venues") && widget.getAttribute("data-venues") != "" ? "venues" : "bookingTypes";
    if (initStage === "venues") (0, $c5a626aad556a640$export$12ed1233ac55ca66)(widget);
    else (0, $c5a626aad556a640$export$f5f00fdbfdfc6331)(widget);
});

})();
//# sourceMappingURL=index.js.map
